webpackJsonp([1],Array(21).concat([
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var db = {};

db.version = '5';
db.key = 'vueMobile.database_' + db.version;

db.culture = 'en';
db.timezone = 'America/Los_Angeles';
db.textValue = '';
db.textareaValue = '';
db.checkboxValue = false;
db.dropdownValue = null;
db.radioValue = '#C0C0C0';
db.segmentedValue = 'FIRST';
db.date = null;
db.dateTime = null;
db.list = [{
    id: 1,
    sex: 1,
    name: 'John'
}, {
    id: 2,
    sex: 2,
    name: 'Sabrina'
}, {
    id: 3,
    sex: 1,
    name: 'Randall'
}, {
    id: 4,
    sex: 2,
    name: 'Lisa'
}, {
    id: 5,
    sex: 1,
    name: 'Gabriel'
}];

db.todos = [{
    id: 1,
    title: 'Create awesome app',
    done: true
}, {
    id: 2,
    title: 'Deploy it to web',
    done: false
}, {
    id: 3,
    title: 'Publish it to AppStore',
    done: false
}, {
    id: 4,
    title: 'Publish it to Google Play',
    done: false
}];

db.load = function () {
    var dbString = void 0;
    try {
        dbString = localStorage.getItem(db.key);
    } catch (e) {}

    if (dbString) {
        var data = JSON.parse(dbString);
        db.culture = data.culture;
        db.timezone = data.timezone;
        db.textValue = data.textValue;
        db.textareaValue = data.textareaValue;
        db.checkboxValue = data.checkboxValue;
        db.dropdownValue = data.dropdownValue;
        db.radioValue = data.radioValue;
        db.segmentedValue = data.segmentedValue;
        db.date = data.date;
        db.dateTime = data.dateTime;
        db.list = data.list;
        db.todos = data.todos;
    }
};

db.save = function () {
    try {
        var data = {
            culture: db.culture,
            timezone: db.timezone,
            textValue: db.textValue,
            textareaValue: db.textareaValue,
            checkboxValue: db.checkboxValue,
            dropdownValue: db.dropdownValue,
            radioValue: db.radioValue,
            segmentedValue: db.segmentedValue,
            date: db.date,
            dateTime: db.dateTime,
            list: db.list,
            todos: db.todos
        };
        localStorage.setItem(db.key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a(data));
    } catch (e) {}
};

db.load();

/* harmony default export */ __webpack_exports__["a"] = (db);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_SignInView__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_SignInView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_SignInView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_SignUpView__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_SignUpView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_SignUpView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ForgotPasswordView__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ForgotPasswordView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_ForgotPasswordView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_DashboardView__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_DashboardView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_DashboardView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ListView__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ListView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_ListView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_TableView__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_TableView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_TableView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_CatalogView__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_CatalogView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_CatalogView__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{ name: 'signin', path: '/signin', component: __WEBPACK_IMPORTED_MODULE_2__views_SignInView___default.a }, { name: 'signup', path: '/signup', component: __WEBPACK_IMPORTED_MODULE_3__views_SignUpView___default.a }, { name: 'forgot-password', path: '/forgot-password', component: __WEBPACK_IMPORTED_MODULE_4__views_ForgotPasswordView___default.a }, { name: 'dashboard', path: '/', component: __WEBPACK_IMPORTED_MODULE_5__views_DashboardView___default.a }, { name: 'list', path: '/list', component: __WEBPACK_IMPORTED_MODULE_6__views_ListView___default.a }, { name: 'table', path: '/table', component: __WEBPACK_IMPORTED_MODULE_7__views_TableView___default.a }, { name: 'catalog', path: '/catalog/:id?', component: __WEBPACK_IMPORTED_MODULE_8__views_CatalogView___default.a }, { path: '*', redirect: '/' }]
}));

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test_data_server__ = __webpack_require__(441);





/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url, errorMutation) {
        if (errorMutation) {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit(errorMutation, {}, { root: true });
        }

        return __WEBPACK_IMPORTED_MODULE_2__test_data_server__["a" /* default */].get(url).then(function (response) {
            return response;
        }, function (response) {
            __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].handleErrors(response.status, response.body, errorMutation);
            throw new Error();
        });
    },
    post: function post(url, data, errorMutation) {
        if (errorMutation) {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit(errorMutation, {}, { root: true });
        }

        return __WEBPACK_IMPORTED_MODULE_2__test_data_server__["a" /* default */].post(url, data).then(function (response) {
            return response;
        }, function (response) {
            __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].handleErrors(response.status, response.body, errorMutation);
            throw new Error();
        });
    },
    put: function put(url, data, errorMutation) {
        if (errorMutation) {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit(errorMutation, {}, { root: true });
        }

        return __WEBPACK_IMPORTED_MODULE_2__test_data_server__["a" /* default */].put(url, data).then(function (response) {
            return response;
        }, function (response) {
            __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].handleErrors(response.status, response.body, errorMutation);
            throw new Error();
        });
    },
    delete: function _delete(url, errorMutation) {
        if (errorMutation) {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit(errorMutation, {}, { root: true });
        }

        return __WEBPACK_IMPORTED_MODULE_2__test_data_server__["a" /* default */].delete(url).then(function (response) {
            return response;
        }, function (response) {
            __WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* default */].handleErrors(response.status, response.body, errorMutation);
            throw new Error();
        });
    }
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(498),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(140);



/* harmony default export */ __webpack_exports__["a"] = ({
    handleErrors: function handleErrors(status, errorList, errorMutation) {
        if (status === -1) {
            errorList = [{
                property: 'global',
                message: 'MESSAGE.GENERAL.NO_SERVER_CONNECTION'
            }];
        } else if (status === 500) {
            errorList = [{
                property: 'global',
                message: 'MESSAGE.GENERAL.SERVER_ERROR_OCCURRED'
            }];
        } else if (status !== 400) {
            errorList = [{
                property: 'global',
                message: 'MESSAGE.GENERAL.ERROR_OCCURRED'
            }];
        }

        var errors = {};
        for (var i = 0; i < errorList.length; i++) {
            var error = errorList[i];
            var lowerCase = error.property.charAt(0).toLowerCase() + error.property.slice(1);
            if (!errors[lowerCase]) {
                errors[lowerCase] = [];
            }
            var message = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['translation/translate'](error.message);

            if (error.additionalData) {
                for (var propertyName in error.additionalData) {
                    if (error.additionalData.hasOwnProperty(propertyName)) {
                        message = message.replace(new RegExp('{{' + propertyName + '}}', 'g'), error.additionalData[propertyName]);
                    }
                }
            }

            errors[lowerCase].push(message);
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('settings/addError', message, { root: true });
        }

        if (errorMutation) {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit(errorMutation, errors, { root: true });
        }
    },
    convertStringToDate: function convertStringToDate(store, dateString, toUtc, format) {
        if (!format) {
            format = 'L LT';
        }
        if (dateString && dateString.length > 0) {
            var zoned = __WEBPACK_IMPORTED_MODULE_0__main__["moment"].tz(dateString, format, store.rootState.settings.account.timezone);
            if (zoned.isValid()) {
                if (toUtc) {
                    return __WEBPACK_IMPORTED_MODULE_0__main__["moment"].tz(zoned, 'Etc/UTC');
                } else {
                    return zoned;
                }
            }
        }
        return null;
    },

    disableButton: function disableButton(btn) {
        if (btn && btn.className) {
            btn.className += ' disabled';
        }
    },
    enableButton: function enableButton(btn) {
        if (btn && btn.className && btn.className.indexOf("disabled") > 0) {
            btn.className = btn.className.replace(new RegExp('(?:^|\\s)' + 'disabled' + '(?:\\s|$)'), ' ');
        }
    },
    scrollToTop: function scrollToTop() {
        window.scrollTo(0, 0);
    }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constants = {};

constants.appName = 'VueMobile';
constants.appFirstWord = 'Vue';
constants.appSecondWord = 'Mobile';
constants.tokenKey = 'vueMobile.authorizationData_user';
constants.culture = 'en';
constants.server = 'https://yoursite.com';

constants.cultures = [{ id: 'en', name: 'CULTURE__EN' }, { id: 'de', name: 'CULTURE__DE' }, { id: 'ru', name: 'CULTURE__RU' }];
constants.timezones = [{ id: 'Europe/Andorra', name: 'TIMEZONES__EUROPE_ANDORRA' }, { id: 'Asia/Dubai', name: 'TIMEZONES__ASIA_DUBAI' }, { id: 'Asia/Kabul', name: 'TIMEZONES__ASIA_KABUL' }, { id: 'America/Antigua', name: 'TIMEZONES__AMERICA_ANTIGUA' }, { id: 'America/Anguilla', name: 'TIMEZONES__AMERICA_ANGUILLA' }, { id: 'Europe/Tirane', name: 'TIMEZONES__EUROPE_TIRANE' }, { id: 'Asia/Yerevan', name: 'TIMEZONES__ASIA_YEREVAN' }, { id: 'Africa/Luanda', name: 'TIMEZONES__AFRICA_LUANDA' }, { id: 'Antarctica/McMurdo', name: 'TIMEZONES__ANTARCTICA_MCMURDO' }, { id: 'Antarctica/Rothera', name: 'TIMEZONES__ANTARCTICA_ROTHERA' }, { id: 'Antarctica/Palmer', name: 'TIMEZONES__ANTARCTICA_PALMER' }, { id: 'Antarctica/Mawson', name: 'TIMEZONES__ANTARCTICA_MAWSON' }, { id: 'Antarctica/Davis', name: 'TIMEZONES__ANTARCTICA_DAVIS' }, { id: 'Antarctica/Casey', name: 'TIMEZONES__ANTARCTICA_CASEY' }, { id: 'Antarctica/Vostok', name: 'TIMEZONES__ANTARCTICA_VOSTOK' }, { id: 'Antarctica/DumontDUrville', name: 'TIMEZONES__ANTARCTICA_DUMONTDURVILLE' }, { id: 'Antarctica/Syowa', name: 'TIMEZONES__ANTARCTICA_SYOWA' }, { id: 'Antarctica/Troll', name: 'TIMEZONES__ANTARCTICA_TROLL' }, { id: 'America/Argentina/Buenos_Aires', name: 'TIMEZONES__AMERICA_ARGENTINA_BUENOS_AIRES' }, { id: 'America/Argentina/Cordoba', name: 'TIMEZONES__AMERICA_ARGENTINA_CORDOBA' }, { id: 'America/Argentina/Salta', name: 'TIMEZONES__AMERICA_ARGENTINA_SALTA' }, { id: 'America/Argentina/Jujuy', name: 'TIMEZONES__AMERICA_ARGENTINA_JUJUY' }, { id: 'America/Argentina/Tucuman', name: 'TIMEZONES__AMERICA_ARGENTINA_TUCUMAN' }, { id: 'America/Argentina/Catamarca', name: 'TIMEZONES__AMERICA_ARGENTINA_CATAMARCA' }, { id: 'America/Argentina/La_Rioja', name: 'TIMEZONES__AMERICA_ARGENTINA_LA_RIOJA' }, { id: 'America/Argentina/San_Juan', name: 'TIMEZONES__AMERICA_ARGENTINA_SAN_JUAN' }, { id: 'America/Argentina/Mendoza', name: 'TIMEZONES__AMERICA_ARGENTINA_MENDOZA' }, { id: 'America/Argentina/San_Luis', name: 'TIMEZONES__AMERICA_ARGENTINA_SAN_LUIS' }, { id: 'America/Argentina/Rio_Gallegos', name: 'TIMEZONES__AMERICA_ARGENTINA_RIO_GALLEGOS' }, { id: 'America/Argentina/Ushuaia', name: 'TIMEZONES__AMERICA_ARGENTINA_USHUAIA' }, { id: 'Pacific/Pago_Pago', name: 'TIMEZONES__PACIFIC_PAGO_PAGO' }, { id: 'Europe/Vienna', name: 'TIMEZONES__EUROPE_VIENNA' }, { id: 'Australia/Lord_Howe', name: 'TIMEZONES__AUSTRALIA_LORD_HOWE' }, { id: 'Antarctica/Macquarie', name: 'TIMEZONES__ANTARCTICA_MACQUARIE' }, { id: 'Australia/Hobart', name: 'TIMEZONES__AUSTRALIA_HOBART' }, { id: 'Australia/Currie', name: 'TIMEZONES__AUSTRALIA_CURRIE' }, { id: 'Australia/Melbourne', name: 'TIMEZONES__AUSTRALIA_MELBOURNE' }, { id: 'Australia/Sydney', name: 'TIMEZONES__AUSTRALIA_SYDNEY' }, { id: 'Australia/Broken_Hill', name: 'TIMEZONES__AUSTRALIA_BROKEN_HILL' }, { id: 'Australia/Brisbane', name: 'TIMEZONES__AUSTRALIA_BRISBANE' }, { id: 'Australia/Lindeman', name: 'TIMEZONES__AUSTRALIA_LINDEMAN' }, { id: 'Australia/Adelaide', name: 'TIMEZONES__AUSTRALIA_ADELAIDE' }, { id: 'Australia/Darwin', name: 'TIMEZONES__AUSTRALIA_DARWIN' }, { id: 'Australia/Perth', name: 'TIMEZONES__AUSTRALIA_PERTH' }, { id: 'Australia/Eucla', name: 'TIMEZONES__AUSTRALIA_EUCLA' }, { id: 'America/Aruba', name: 'TIMEZONES__AMERICA_ARUBA' }, { id: 'Europe/Mariehamn', name: 'TIMEZONES__EUROPE_MARIEHAMN' }, { id: 'Asia/Baku', name: 'TIMEZONES__ASIA_BAKU' }, { id: 'Europe/Sarajevo', name: 'TIMEZONES__EUROPE_SARAJEVO' }, { id: 'America/Barbados', name: 'TIMEZONES__AMERICA_BARBADOS' }, { id: 'Asia/Dhaka', name: 'TIMEZONES__ASIA_DHAKA' }, { id: 'Europe/Brussels', name: 'TIMEZONES__EUROPE_BRUSSELS' }, { id: 'Africa/Ouagadougou', name: 'TIMEZONES__AFRICA_OUAGADOUGOU' }, { id: 'Europe/Sofia', name: 'TIMEZONES__EUROPE_SOFIA' }, { id: 'Asia/Bahrain', name: 'TIMEZONES__ASIA_BAHRAIN' }, { id: 'Africa/Bujumbura', name: 'TIMEZONES__AFRICA_BUJUMBURA' }, { id: 'Africa/Porto-Novo', name: 'TIMEZONES__AFRICA_PORTO_NOVO' }, { id: 'America/St_Barthelemy', name: 'TIMEZONES__AMERICA_ST_BARTHELEMY' }, { id: 'Atlantic/Bermuda', name: 'TIMEZONES__ATLANTIC_BERMUDA' }, { id: 'Asia/Brunei', name: 'TIMEZONES__ASIA_BRUNEI' }, { id: 'America/La_Paz', name: 'TIMEZONES__AMERICA_LA_PAZ' }, { id: 'America/Kralendijk', name: 'TIMEZONES__AMERICA_KRALENDIJK' }, { id: 'America/Noronha', name: 'TIMEZONES__AMERICA_NORONHA' }, { id: 'America/Belem', name: 'TIMEZONES__AMERICA_BELEM' }, { id: 'America/Fortaleza', name: 'TIMEZONES__AMERICA_FORTALEZA' }, { id: 'America/Recife', name: 'TIMEZONES__AMERICA_RECIFE' }, { id: 'America/Araguaina', name: 'TIMEZONES__AMERICA_ARAGUAINA' }, { id: 'America/Maceio', name: 'TIMEZONES__AMERICA_MACEIO' }, { id: 'America/Bahia', name: 'TIMEZONES__AMERICA_BAHIA' }, { id: 'America/Sao_Paulo', name: 'TIMEZONES__AMERICA_SAO_PAULO' }, { id: 'America/Campo_Grande', name: 'TIMEZONES__AMERICA_CAMPO_GRANDE' }, { id: 'America/Cuiaba', name: 'TIMEZONES__AMERICA_CUIABA' }, { id: 'America/Santarem', name: 'TIMEZONES__AMERICA_SANTAREM' }, { id: 'America/Porto_Velho', name: 'TIMEZONES__AMERICA_PORTO_VELHO' }, { id: 'America/Boa_Vista', name: 'TIMEZONES__AMERICA_BOA_VISTA' }, { id: 'America/Manaus', name: 'TIMEZONES__AMERICA_MANAUS' }, { id: 'America/Eirunepe', name: 'TIMEZONES__AMERICA_EIRUNEPE' }, { id: 'America/Rio_Branco', name: 'TIMEZONES__AMERICA_RIO_BRANCO' }, { id: 'America/Nassau', name: 'TIMEZONES__AMERICA_NASSAU' }, { id: 'Asia/Thimphu', name: 'TIMEZONES__ASIA_THIMPHU' }, { id: 'Africa/Gaborone', name: 'TIMEZONES__AFRICA_GABORONE' }, { id: 'Europe/Minsk', name: 'TIMEZONES__EUROPE_MINSK' }, { id: 'America/Belize', name: 'TIMEZONES__AMERICA_BELIZE' }, { id: 'America/St_Johns', name: 'TIMEZONES__AMERICA_ST_JOHNS' }, { id: 'America/Halifax', name: 'TIMEZONES__AMERICA_HALIFAX' }, { id: 'America/Glace_Bay', name: 'TIMEZONES__AMERICA_GLACE_BAY' }, { id: 'America/Moncton', name: 'TIMEZONES__AMERICA_MONCTON' }, { id: 'America/Goose_Bay', name: 'TIMEZONES__AMERICA_GOOSE_BAY' }, { id: 'America/Blanc-Sablon', name: 'TIMEZONES__AMERICA_BLANC_SABLON' }, { id: 'America/Toronto', name: 'TIMEZONES__AMERICA_TORONTO' }, { id: 'America/Nipigon', name: 'TIMEZONES__AMERICA_NIPIGON' }, { id: 'America/Thunder_Bay', name: 'TIMEZONES__AMERICA_THUNDER_BAY' }, { id: 'America/Iqaluit', name: 'TIMEZONES__AMERICA_IQALUIT' }, { id: 'America/Pangnirtung', name: 'TIMEZONES__AMERICA_PANGNIRTUNG' }, { id: 'America/Resolute', name: 'TIMEZONES__AMERICA_RESOLUTE' }, { id: 'America/Atikokan', name: 'TIMEZONES__AMERICA_ATIKOKAN' }, { id: 'America/Rankin_Inlet', name: 'TIMEZONES__AMERICA_RANKIN_INLET' }, { id: 'America/Winnipeg', name: 'TIMEZONES__AMERICA_WINNIPEG' }, { id: 'America/Rainy_River', name: 'TIMEZONES__AMERICA_RAINY_RIVER' }, { id: 'America/Regina', name: 'TIMEZONES__AMERICA_REGINA' }, { id: 'America/Swift_Current', name: 'TIMEZONES__AMERICA_SWIFT_CURRENT' }, { id: 'America/Edmonton', name: 'TIMEZONES__AMERICA_EDMONTON' }, { id: 'America/Cambridge_Bay', name: 'TIMEZONES__AMERICA_CAMBRIDGE_BAY' }, { id: 'America/Yellowknife', name: 'TIMEZONES__AMERICA_YELLOWKNIFE' }, { id: 'America/Inuvik', name: 'TIMEZONES__AMERICA_INUVIK' }, { id: 'America/Creston', name: 'TIMEZONES__AMERICA_CRESTON' }, { id: 'America/Dawson_Creek', name: 'TIMEZONES__AMERICA_DAWSON_CREEK' }, { id: 'America/Vancouver', name: 'TIMEZONES__AMERICA_VANCOUVER' }, { id: 'America/Whitehorse', name: 'TIMEZONES__AMERICA_WHITEHORSE' }, { id: 'America/Dawson', name: 'TIMEZONES__AMERICA_DAWSON' }, { id: 'Indian/Cocos', name: 'TIMEZONES__INDIAN_COCOS' }, { id: 'Africa/Kinshasa', name: 'TIMEZONES__AFRICA_KINSHASA' }, { id: 'Africa/Lubumbashi', name: 'TIMEZONES__AFRICA_LUBUMBASHI' }, { id: 'Africa/Bangui', name: 'TIMEZONES__AFRICA_BANGUI' }, { id: 'Africa/Brazzaville', name: 'TIMEZONES__AFRICA_BRAZZAVILLE' }, { id: 'Europe/Zurich', name: 'TIMEZONES__EUROPE_ZURICH' }, { id: 'Africa/Abidjan', name: 'TIMEZONES__AFRICA_ABIDJAN' }, { id: 'Pacific/Rarotonga', name: 'TIMEZONES__PACIFIC_RAROTONGA' }, { id: 'America/Santiago', name: 'TIMEZONES__AMERICA_SANTIAGO' }, { id: 'Pacific/Easter', name: 'TIMEZONES__PACIFIC_EASTER' }, { id: 'Africa/Douala', name: 'TIMEZONES__AFRICA_DOUALA' }, { id: 'Asia/Shanghai', name: 'TIMEZONES__ASIA_SHANGHAI' }, { id: 'Asia/Urumqi', name: 'TIMEZONES__ASIA_URUMQI' }, { id: 'America/Bogota', name: 'TIMEZONES__AMERICA_BOGOTA' }, { id: 'America/Costa_Rica', name: 'TIMEZONES__AMERICA_COSTA_RICA' }, { id: 'America/Havana', name: 'TIMEZONES__AMERICA_HAVANA' }, { id: 'Atlantic/Cape_Verde', name: 'TIMEZONES__ATLANTIC_CAPE_VERDE' }, { id: 'America/Curacao', name: 'TIMEZONES__AMERICA_CURACAO' }, { id: 'Indian/Christmas', name: 'TIMEZONES__INDIAN_CHRISTMAS' }, { id: 'Asia/Nicosia', name: 'TIMEZONES__ASIA_NICOSIA' }, { id: 'Europe/Prague', name: 'TIMEZONES__EUROPE_PRAGUE' }, { id: 'Europe/Berlin', name: 'TIMEZONES__EUROPE_BERLIN' }, { id: 'Europe/Busingen', name: 'TIMEZONES__EUROPE_BUSINGEN' }, { id: 'Africa/Djibouti', name: 'TIMEZONES__AFRICA_DJIBOUTI' }, { id: 'Europe/Copenhagen', name: 'TIMEZONES__EUROPE_COPENHAGEN' }, { id: 'America/Dominica', name: 'TIMEZONES__AMERICA_DOMINICA' }, { id: 'America/Santo_Domingo', name: 'TIMEZONES__AMERICA_SANTO_DOMINGO' }, { id: 'Africa/Algiers', name: 'TIMEZONES__AFRICA_ALGIERS' }, { id: 'America/Guayaquil', name: 'TIMEZONES__AMERICA_GUAYAQUIL' }, { id: 'Pacific/Galapagos', name: 'TIMEZONES__PACIFIC_GALAPAGOS' }, { id: 'Europe/Tallinn', name: 'TIMEZONES__EUROPE_TALLINN' }, { id: 'Africa/Cairo', name: 'TIMEZONES__AFRICA_CAIRO' }, { id: 'Africa/El_Aaiun', name: 'TIMEZONES__AFRICA_EL_AAIUN' }, { id: 'Africa/Asmara', name: 'TIMEZONES__AFRICA_ASMARA' }, { id: 'Europe/Madrid', name: 'TIMEZONES__EUROPE_MADRID' }, { id: 'Africa/Ceuta', name: 'TIMEZONES__AFRICA_CEUTA' }, { id: 'Atlantic/Canary', name: 'TIMEZONES__ATLANTIC_CANARY' }, { id: 'Africa/Addis_Ababa', name: 'TIMEZONES__AFRICA_ADDIS_ABABA' }, { id: 'Europe/Helsinki', name: 'TIMEZONES__EUROPE_HELSINKI' }, { id: 'Pacific/Fiji', name: 'TIMEZONES__PACIFIC_FIJI' }, { id: 'Atlantic/Stanley', name: 'TIMEZONES__ATLANTIC_STANLEY' }, { id: 'Pacific/Chuuk', name: 'TIMEZONES__PACIFIC_CHUUK' }, { id: 'Pacific/Pohnpei', name: 'TIMEZONES__PACIFIC_POHNPEI' }, { id: 'Pacific/Kosrae', name: 'TIMEZONES__PACIFIC_KOSRAE' }, { id: 'Atlantic/Faroe', name: 'TIMEZONES__ATLANTIC_FAROE' }, { id: 'Europe/Paris', name: 'TIMEZONES__EUROPE_PARIS' }, { id: 'Africa/Libreville', name: 'TIMEZONES__AFRICA_LIBREVILLE' }, { id: 'Europe/London', name: 'TIMEZONES__EUROPE_LONDON' }, { id: 'America/Grenada', name: 'TIMEZONES__AMERICA_GRENADA' }, { id: 'Asia/Tbilisi', name: 'TIMEZONES__ASIA_TBILISI' }, { id: 'America/Cayenne', name: 'TIMEZONES__AMERICA_CAYENNE' }, { id: 'Europe/Guernsey', name: 'TIMEZONES__EUROPE_GUERNSEY' }, { id: 'Africa/Accra', name: 'TIMEZONES__AFRICA_ACCRA' }, { id: 'Europe/Gibraltar', name: 'TIMEZONES__EUROPE_GIBRALTAR' }, { id: 'America/Godthab', name: 'TIMEZONES__AMERICA_GODTHAB' }, { id: 'America/Danmarkshavn', name: 'TIMEZONES__AMERICA_DANMARKSHAVN' }, { id: 'America/Scoresbysund', name: 'TIMEZONES__AMERICA_SCORESBYSUND' }, { id: 'America/Thule', name: 'TIMEZONES__AMERICA_THULE' }, { id: 'Africa/Banjul', name: 'TIMEZONES__AFRICA_BANJUL' }, { id: 'Africa/Conakry', name: 'TIMEZONES__AFRICA_CONAKRY' }, { id: 'America/Guadeloupe', name: 'TIMEZONES__AMERICA_GUADELOUPE' }, { id: 'Africa/Malabo', name: 'TIMEZONES__AFRICA_MALABO' }, { id: 'Europe/Athens', name: 'TIMEZONES__EUROPE_ATHENS' }, { id: 'Atlantic/South_Georgia', name: 'TIMEZONES__ATLANTIC_SOUTH_GEORGIA' }, { id: 'America/Guatemala', name: 'TIMEZONES__AMERICA_GUATEMALA' }, { id: 'Pacific/Guam', name: 'TIMEZONES__PACIFIC_GUAM' }, { id: 'Africa/Bissau', name: 'TIMEZONES__AFRICA_BISSAU' }, { id: 'America/Guyana', name: 'TIMEZONES__AMERICA_GUYANA' }, { id: 'Asia/Hong_Kong', name: 'TIMEZONES__ASIA_HONG_KONG' }, { id: 'America/Tegucigalpa', name: 'TIMEZONES__AMERICA_TEGUCIGALPA' }, { id: 'Europe/Zagreb', name: 'TIMEZONES__EUROPE_ZAGREB' }, { id: 'America/Port-au-Prince', name: 'TIMEZONES__AMERICA_PORT_AU_PRINCE' }, { id: 'Europe/Budapest', name: 'TIMEZONES__EUROPE_BUDAPEST' }, { id: 'Asia/Jakarta', name: 'TIMEZONES__ASIA_JAKARTA' }, { id: 'Asia/Pontianak', name: 'TIMEZONES__ASIA_PONTIANAK' }, { id: 'Asia/Makassar', name: 'TIMEZONES__ASIA_MAKASSAR' }, { id: 'Asia/Jayapura', name: 'TIMEZONES__ASIA_JAYAPURA' }, { id: 'Europe/Dublin', name: 'TIMEZONES__EUROPE_DUBLIN' }, { id: 'Asia/Jerusalem', name: 'TIMEZONES__ASIA_JERUSALEM' }, { id: 'Europe/Isle_of_Man', name: 'TIMEZONES__EUROPE_ISLE_OF_MAN' }, { id: 'Asia/Kolkata', name: 'TIMEZONES__ASIA_KOLKATA' }, { id: 'Indian/Chagos', name: 'TIMEZONES__INDIAN_CHAGOS' }, { id: 'Asia/Baghdad', name: 'TIMEZONES__ASIA_BAGHDAD' }, { id: 'Asia/Tehran', name: 'TIMEZONES__ASIA_TEHRAN' }, { id: 'Atlantic/Reykjavik', name: 'TIMEZONES__ATLANTIC_REYKJAVIK' }, { id: 'Europe/Rome', name: 'TIMEZONES__EUROPE_ROME' }, { id: 'Europe/Jersey', name: 'TIMEZONES__EUROPE_JERSEY' }, { id: 'America/Jamaica', name: 'TIMEZONES__AMERICA_JAMAICA' }, { id: 'Asia/Amman', name: 'TIMEZONES__ASIA_AMMAN' }, { id: 'Asia/Tokyo', name: 'TIMEZONES__ASIA_TOKYO' }, { id: 'Africa/Nairobi', name: 'TIMEZONES__AFRICA_NAIROBI' }, { id: 'Asia/Bishkek', name: 'TIMEZONES__ASIA_BISHKEK' }, { id: 'Asia/Phnom_Penh', name: 'TIMEZONES__ASIA_PHNOM_PENH' }, { id: 'Pacific/Tarawa', name: 'TIMEZONES__PACIFIC_TARAWA' }, { id: 'Pacific/Enderbury', name: 'TIMEZONES__PACIFIC_ENDERBURY' }, { id: 'Pacific/Kiritimati', name: 'TIMEZONES__PACIFIC_KIRITIMATI' }, { id: 'Indian/Comoro', name: 'TIMEZONES__INDIAN_COMORO' }, { id: 'America/St_Kitts', name: 'TIMEZONES__AMERICA_ST_KITTS' }, { id: 'Asia/Pyongyang', name: 'TIMEZONES__ASIA_PYONGYANG' }, { id: 'Asia/Seoul', name: 'TIMEZONES__ASIA_SEOUL' }, { id: 'Asia/Kuwait', name: 'TIMEZONES__ASIA_KUWAIT' }, { id: 'America/Cayman', name: 'TIMEZONES__AMERICA_CAYMAN' }, { id: 'Asia/Almaty', name: 'TIMEZONES__ASIA_ALMATY' }, { id: 'Asia/Qyzylorda', name: 'TIMEZONES__ASIA_QYZYLORDA' }, { id: 'Asia/Aqtobe', name: 'TIMEZONES__ASIA_AQTOBE' }, { id: 'Asia/Aqtau', name: 'TIMEZONES__ASIA_AQTAU' }, { id: 'Asia/Oral', name: 'TIMEZONES__ASIA_ORAL' }, { id: 'Asia/Vientiane', name: 'TIMEZONES__ASIA_VIENTIANE' }, { id: 'Asia/Beirut', name: 'TIMEZONES__ASIA_BEIRUT' }, { id: 'America/St_Lucia', name: 'TIMEZONES__AMERICA_ST_LUCIA' }, { id: 'Europe/Vaduz', name: 'TIMEZONES__EUROPE_VADUZ' }, { id: 'Asia/Colombo', name: 'TIMEZONES__ASIA_COLOMBO' }, { id: 'Africa/Monrovia', name: 'TIMEZONES__AFRICA_MONROVIA' }, { id: 'Africa/Maseru', name: 'TIMEZONES__AFRICA_MASERU' }, { id: 'Europe/Vilnius', name: 'TIMEZONES__EUROPE_VILNIUS' }, { id: 'Europe/Luxembourg', name: 'TIMEZONES__EUROPE_LUXEMBOURG' }, { id: 'Europe/Riga', name: 'TIMEZONES__EUROPE_RIGA' }, { id: 'Africa/Tripoli', name: 'TIMEZONES__AFRICA_TRIPOLI' }, { id: 'Africa/Casablanca', name: 'TIMEZONES__AFRICA_CASABLANCA' }, { id: 'Europe/Monaco', name: 'TIMEZONES__EUROPE_MONACO' }, { id: 'Europe/Chisinau', name: 'TIMEZONES__EUROPE_CHISINAU' }, { id: 'Europe/Podgorica', name: 'TIMEZONES__EUROPE_PODGORICA' }, { id: 'America/Marigot', name: 'TIMEZONES__AMERICA_MARIGOT' }, { id: 'Indian/Antananarivo', name: 'TIMEZONES__INDIAN_ANTANANARIVO' }, { id: 'Pacific/Majuro', name: 'TIMEZONES__PACIFIC_MAJURO' }, { id: 'Pacific/Kwajalein', name: 'TIMEZONES__PACIFIC_KWAJALEIN' }, { id: 'Europe/Skopje', name: 'TIMEZONES__EUROPE_SKOPJE' }, { id: 'Africa/Bamako', name: 'TIMEZONES__AFRICA_BAMAKO' }, { id: 'Asia/Rangoon', name: 'TIMEZONES__ASIA_RANGOON' }, { id: 'Asia/Ulaanbaatar', name: 'TIMEZONES__ASIA_ULAANBAATAR' }, { id: 'Asia/Hovd', name: 'TIMEZONES__ASIA_HOVD' }, { id: 'Asia/Choibalsan', name: 'TIMEZONES__ASIA_CHOIBALSAN' }, { id: 'Asia/Macau', name: 'TIMEZONES__ASIA_MACAU' }, { id: 'Pacific/Saipan', name: 'TIMEZONES__PACIFIC_SAIPAN' }, { id: 'America/Martinique', name: 'TIMEZONES__AMERICA_MARTINIQUE' }, { id: 'Africa/Nouakchott', name: 'TIMEZONES__AFRICA_NOUAKCHOTT' }, { id: 'America/Montserrat', name: 'TIMEZONES__AMERICA_MONTSERRAT' }, { id: 'Europe/Malta', name: 'TIMEZONES__EUROPE_MALTA' }, { id: 'Indian/Mauritius', name: 'TIMEZONES__INDIAN_MAURITIUS' }, { id: 'Indian/Maldives', name: 'TIMEZONES__INDIAN_MALDIVES' }, { id: 'Africa/Blantyre', name: 'TIMEZONES__AFRICA_BLANTYRE' }, { id: 'America/Mexico_City', name: 'TIMEZONES__AMERICA_MEXICO_CITY' }, { id: 'America/Cancun', name: 'TIMEZONES__AMERICA_CANCUN' }, { id: 'America/Merida', name: 'TIMEZONES__AMERICA_MERIDA' }, { id: 'America/Monterrey', name: 'TIMEZONES__AMERICA_MONTERREY' }, { id: 'America/Matamoros', name: 'TIMEZONES__AMERICA_MATAMOROS' }, { id: 'America/Mazatlan', name: 'TIMEZONES__AMERICA_MAZATLAN' }, { id: 'America/Chihuahua', name: 'TIMEZONES__AMERICA_CHIHUAHUA' }, { id: 'America/Ojinaga', name: 'TIMEZONES__AMERICA_OJINAGA' }, { id: 'America/Hermosillo', name: 'TIMEZONES__AMERICA_HERMOSILLO' }, { id: 'America/Tijuana', name: 'TIMEZONES__AMERICA_TIJUANA' }, { id: 'America/Bahia_Banderas', name: 'TIMEZONES__AMERICA_BAHIA_BANDERAS' }, { id: 'Asia/Kuala_Lumpur', name: 'TIMEZONES__ASIA_KUALA_LUMPUR' }, { id: 'Asia/Kuching', name: 'TIMEZONES__ASIA_KUCHING' }, { id: 'Africa/Maputo', name: 'TIMEZONES__AFRICA_MAPUTO' }, { id: 'Africa/Windhoek', name: 'TIMEZONES__AFRICA_WINDHOEK' }, { id: 'Pacific/Noumea', name: 'TIMEZONES__PACIFIC_NOUMEA' }, { id: 'Africa/Niamey', name: 'TIMEZONES__AFRICA_NIAMEY' }, { id: 'Pacific/Norfolk', name: 'TIMEZONES__PACIFIC_NORFOLK' }, { id: 'Africa/Lagos', name: 'TIMEZONES__AFRICA_LAGOS' }, { id: 'America/Managua', name: 'TIMEZONES__AMERICA_MANAGUA' }, { id: 'Europe/Amsterdam', name: 'TIMEZONES__EUROPE_AMSTERDAM' }, { id: 'Europe/Oslo', name: 'TIMEZONES__EUROPE_OSLO' }, { id: 'Asia/Kathmandu', name: 'TIMEZONES__ASIA_KATHMANDU' }, { id: 'Pacific/Nauru', name: 'TIMEZONES__PACIFIC_NAURU' }, { id: 'Pacific/Niue', name: 'TIMEZONES__PACIFIC_NIUE' }, { id: 'Pacific/Auckland', name: 'TIMEZONES__PACIFIC_AUCKLAND' }, { id: 'Pacific/Chatham', name: 'TIMEZONES__PACIFIC_CHATHAM' }, { id: 'Asia/Muscat', name: 'TIMEZONES__ASIA_MUSCAT' }, { id: 'America/Panama', name: 'TIMEZONES__AMERICA_PANAMA' }, { id: 'America/Lima', name: 'TIMEZONES__AMERICA_LIMA' }, { id: 'Pacific/Tahiti', name: 'TIMEZONES__PACIFIC_TAHITI' }, { id: 'Pacific/Marquesas', name: 'TIMEZONES__PACIFIC_MARQUESAS' }, { id: 'Pacific/Gambier', name: 'TIMEZONES__PACIFIC_GAMBIER' }, { id: 'Pacific/Port_Moresby', name: 'TIMEZONES__PACIFIC_PORT_MORESBY' }, { id: 'Pacific/Bougainville', name: 'TIMEZONES__PACIFIC_BOUGAINVILLE' }, { id: 'Asia/Manila', name: 'TIMEZONES__ASIA_MANILA' }, { id: 'Asia/Karachi', name: 'TIMEZONES__ASIA_KARACHI' }, { id: 'Europe/Warsaw', name: 'TIMEZONES__EUROPE_WARSAW' }, { id: 'America/Miquelon', name: 'TIMEZONES__AMERICA_MIQUELON' }, { id: 'Pacific/Pitcairn', name: 'TIMEZONES__PACIFIC_PITCAIRN' }, { id: 'America/Puerto_Rico', name: 'TIMEZONES__AMERICA_PUERTO_RICO' }, { id: 'Asia/Gaza', name: 'TIMEZONES__ASIA_GAZA' }, { id: 'Asia/Hebron', name: 'TIMEZONES__ASIA_HEBRON' }, { id: 'Europe/Lisbon', name: 'TIMEZONES__EUROPE_LISBON' }, { id: 'Atlantic/Madeira', name: 'TIMEZONES__ATLANTIC_MADEIRA' }, { id: 'Atlantic/Azores', name: 'TIMEZONES__ATLANTIC_AZORES' }, { id: 'Pacific/Palau', name: 'TIMEZONES__PACIFIC_PALAU' }, { id: 'America/Asuncion', name: 'TIMEZONES__AMERICA_ASUNCION' }, { id: 'Asia/Qatar', name: 'TIMEZONES__ASIA_QATAR' }, { id: 'Indian/Reunion', name: 'TIMEZONES__INDIAN_REUNION' }, { id: 'Europe/Bucharest', name: 'TIMEZONES__EUROPE_BUCHAREST' }, { id: 'Europe/Belgrade', name: 'TIMEZONES__EUROPE_BELGRADE' }, { id: 'Europe/Kaliningrad', name: 'TIMEZONES__EUROPE_KALININGRAD' }, { id: 'Europe/Moscow', name: 'TIMEZONES__EUROPE_MOSCOW' }, { id: 'Europe/Simferopol', name: 'TIMEZONES__EUROPE_SIMFEROPOL' }, { id: 'Europe/Volgograd', name: 'TIMEZONES__EUROPE_VOLGOGRAD' }, { id: 'Europe/Samara', name: 'TIMEZONES__EUROPE_SAMARA' }, { id: 'Asia/Yekaterinburg', name: 'TIMEZONES__ASIA_YEKATERINBURG' }, { id: 'Asia/Omsk', name: 'TIMEZONES__ASIA_OMSK' }, { id: 'Asia/Novosibirsk', name: 'TIMEZONES__ASIA_NOVOSIBIRSK' }, { id: 'Asia/Novokuznetsk', name: 'TIMEZONES__ASIA_NOVOKUZNETSK' }, { id: 'Asia/Krasnoyarsk', name: 'TIMEZONES__ASIA_KRASNOYARSK' }, { id: 'Asia/Irkutsk', name: 'TIMEZONES__ASIA_IRKUTSK' }, { id: 'Asia/Chita', name: 'TIMEZONES__ASIA_CHITA' }, { id: 'Asia/Yakutsk', name: 'TIMEZONES__ASIA_YAKUTSK' }, { id: 'Asia/Khandyga', name: 'TIMEZONES__ASIA_KHANDYGA' }, { id: 'Asia/Vladivostok', name: 'TIMEZONES__ASIA_VLADIVOSTOK' }, { id: 'Asia/Sakhalin', name: 'TIMEZONES__ASIA_SAKHALIN' }, { id: 'Asia/Ust-Nera', name: 'TIMEZONES__ASIA_UST_NERA' }, { id: 'Asia/Magadan', name: 'TIMEZONES__ASIA_MAGADAN' }, { id: 'Asia/Srednekolymsk', name: 'TIMEZONES__ASIA_SREDNEKOLYMSK' }, { id: 'Asia/Kamchatka', name: 'TIMEZONES__ASIA_KAMCHATKA' }, { id: 'Asia/Anadyr', name: 'TIMEZONES__ASIA_ANADYR' }, { id: 'Africa/Kigali', name: 'TIMEZONES__AFRICA_KIGALI' }, { id: 'Asia/Riyadh', name: 'TIMEZONES__ASIA_RIYADH' }, { id: 'Pacific/Guadalcanal', name: 'TIMEZONES__PACIFIC_GUADALCANAL' }, { id: 'Indian/Mahe', name: 'TIMEZONES__INDIAN_MAHE' }, { id: 'Africa/Khartoum', name: 'TIMEZONES__AFRICA_KHARTOUM' }, { id: 'Europe/Stockholm', name: 'TIMEZONES__EUROPE_STOCKHOLM' }, { id: 'Asia/Singapore', name: 'TIMEZONES__ASIA_SINGAPORE' }, { id: 'Atlantic/St_Helena', name: 'TIMEZONES__ATLANTIC_ST_HELENA' }, { id: 'Europe/Ljubljana', name: 'TIMEZONES__EUROPE_LJUBLJANA' }, { id: 'Arctic/Longyearbyen', name: 'TIMEZONES__ARCTIC_LONGYEARBYEN' }, { id: 'Europe/Bratislava', name: 'TIMEZONES__EUROPE_BRATISLAVA' }, { id: 'Africa/Freetown', name: 'TIMEZONES__AFRICA_FREETOWN' }, { id: 'Europe/San_Marino', name: 'TIMEZONES__EUROPE_SAN_MARINO' }, { id: 'Africa/Dakar', name: 'TIMEZONES__AFRICA_DAKAR' }, { id: 'Africa/Mogadishu', name: 'TIMEZONES__AFRICA_MOGADISHU' }, { id: 'America/Paramaribo', name: 'TIMEZONES__AMERICA_PARAMARIBO' }, { id: 'Africa/Juba', name: 'TIMEZONES__AFRICA_JUBA' }, { id: 'Africa/Sao_Tome', name: 'TIMEZONES__AFRICA_SAO_TOME' }, { id: 'America/El_Salvador', name: 'TIMEZONES__AMERICA_EL_SALVADOR' }, { id: 'America/Lower_Princes', name: 'TIMEZONES__AMERICA_LOWER_PRINCES' }, { id: 'Asia/Damascus', name: 'TIMEZONES__ASIA_DAMASCUS' }, { id: 'Africa/Mbabane', name: 'TIMEZONES__AFRICA_MBABANE' }, { id: 'America/Grand_Turk', name: 'TIMEZONES__AMERICA_GRAND_TURK' }, { id: 'Africa/Ndjamena', name: 'TIMEZONES__AFRICA_NDJAMENA' }, { id: 'Indian/Kerguelen', name: 'TIMEZONES__INDIAN_KERGUELEN' }, { id: 'Africa/Lome', name: 'TIMEZONES__AFRICA_LOME' }, { id: 'Asia/Bangkok', name: 'TIMEZONES__ASIA_BANGKOK' }, { id: 'Asia/Dushanbe', name: 'TIMEZONES__ASIA_DUSHANBE' }, { id: 'Pacific/Fakaofo', name: 'TIMEZONES__PACIFIC_FAKAOFO' }, { id: 'Asia/Dili', name: 'TIMEZONES__ASIA_DILI' }, { id: 'Asia/Ashgabat', name: 'TIMEZONES__ASIA_ASHGABAT' }, { id: 'Africa/Tunis', name: 'TIMEZONES__AFRICA_TUNIS' }, { id: 'Pacific/Tongatapu', name: 'TIMEZONES__PACIFIC_TONGATAPU' }, { id: 'Europe/Istanbul', name: 'TIMEZONES__EUROPE_ISTANBUL' }, { id: 'America/Port_of_Spain', name: 'TIMEZONES__AMERICA_PORT_OF_SPAIN' }, { id: 'Pacific/Funafuti', name: 'TIMEZONES__PACIFIC_FUNAFUTI' }, { id: 'Asia/Taipei', name: 'TIMEZONES__ASIA_TAIPEI' }, { id: 'Africa/Dar_es_Salaam', name: 'TIMEZONES__AFRICA_DAR_ES_SALAAM' }, { id: 'Europe/Kiev', name: 'TIMEZONES__EUROPE_KIEV' }, { id: 'Europe/Uzhgorod', name: 'TIMEZONES__EUROPE_UZHGOROD' }, { id: 'Europe/Zaporozhye', name: 'TIMEZONES__EUROPE_ZAPOROZHYE' }, { id: 'Africa/Kampala', name: 'TIMEZONES__AFRICA_KAMPALA' }, { id: 'Pacific/Johnston', name: 'TIMEZONES__PACIFIC_JOHNSTON' }, { id: 'Pacific/Midway', name: 'TIMEZONES__PACIFIC_MIDWAY' }, { id: 'Pacific/Wake', name: 'TIMEZONES__PACIFIC_WAKE' }, { id: 'America/New_York', name: 'TIMEZONES__AMERICA_NEW_YORK' }, { id: 'America/Detroit', name: 'TIMEZONES__AMERICA_DETROIT' }, { id: 'America/Kentucky/Louisville', name: 'TIMEZONES__AMERICA_KENTUCKY_LOUISVILLE' }, { id: 'America/Kentucky/Monticello', name: 'TIMEZONES__AMERICA_KENTUCKY_MONTICELLO' }, { id: 'America/Indiana/Indianapolis', name: 'TIMEZONES__AMERICA_INDIANA_INDIANAPOLIS' }, { id: 'America/Indiana/Vincennes', name: 'TIMEZONES__AMERICA_INDIANA_VINCENNES' }, { id: 'America/Indiana/Winamac', name: 'TIMEZONES__AMERICA_INDIANA_WINAMAC' }, { id: 'America/Indiana/Marengo', name: 'TIMEZONES__AMERICA_INDIANA_MARENGO' }, { id: 'America/Indiana/Petersburg', name: 'TIMEZONES__AMERICA_INDIANA_PETERSBURG' }, { id: 'America/Indiana/Vevay', name: 'TIMEZONES__AMERICA_INDIANA_VEVAY' }, { id: 'America/Chicago', name: 'TIMEZONES__AMERICA_CHICAGO' }, { id: 'America/Indiana/Tell_City', name: 'TIMEZONES__AMERICA_INDIANA_TELL_CITY' }, { id: 'America/Indiana/Knox', name: 'TIMEZONES__AMERICA_INDIANA_KNOX' }, { id: 'America/Menominee', name: 'TIMEZONES__AMERICA_MENOMINEE' }, { id: 'America/North_Dakota/Center', name: 'TIMEZONES__AMERICA_NORTH_DAKOTA_CENTER' }, { id: 'America/North_Dakota/New_Salem', name: 'TIMEZONES__AMERICA_NORTH_DAKOTA_NEW_SALEM' }, { id: 'America/North_Dakota/Beulah', name: 'TIMEZONES__AMERICA_NORTH_DAKOTA_BEULAH' }, { id: 'America/Denver', name: 'TIMEZONES__AMERICA_DENVER' }, { id: 'America/Boise', name: 'TIMEZONES__AMERICA_BOISE' }, { id: 'America/Phoenix', name: 'TIMEZONES__AMERICA_PHOENIX' }, { id: 'America/Los_Angeles', name: 'TIMEZONES__AMERICA_LOS_ANGELES' }, { id: 'America/Metlakatla', name: 'TIMEZONES__AMERICA_METLAKATLA' }, { id: 'America/Anchorage', name: 'TIMEZONES__AMERICA_ANCHORAGE' }, { id: 'America/Juneau', name: 'TIMEZONES__AMERICA_JUNEAU' }, { id: 'America/Sitka', name: 'TIMEZONES__AMERICA_SITKA' }, { id: 'America/Yakutat', name: 'TIMEZONES__AMERICA_YAKUTAT' }, { id: 'America/Nome', name: 'TIMEZONES__AMERICA_NOME' }, { id: 'America/Adak', name: 'TIMEZONES__AMERICA_ADAK' }, { id: 'Pacific/Honolulu', name: 'TIMEZONES__PACIFIC_HONOLULU' }, { id: 'America/Montevideo', name: 'TIMEZONES__AMERICA_MONTEVIDEO' }, { id: 'Asia/Samarkand', name: 'TIMEZONES__ASIA_SAMARKAND' }, { id: 'Asia/Tashkent', name: 'TIMEZONES__ASIA_TASHKENT' }, { id: 'Europe/Vatican', name: 'TIMEZONES__EUROPE_VATICAN' }, { id: 'America/St_Vincent', name: 'TIMEZONES__AMERICA_ST_VINCENT' }, { id: 'America/Caracas', name: 'TIMEZONES__AMERICA_CARACAS' }, { id: 'America/Tortola', name: 'TIMEZONES__AMERICA_TORTOLA' }, { id: 'America/St_Thomas', name: 'TIMEZONES__AMERICA_ST_THOMAS' }, { id: 'Asia/Ho_Chi_Minh', name: 'TIMEZONES__ASIA_HO_CHI_MINH' }, { id: 'Pacific/Efate', name: 'TIMEZONES__PACIFIC_EFATE' }, { id: 'Pacific/Wallis', name: 'TIMEZONES__PACIFIC_WALLIS' }, { id: 'Pacific/Apia', name: 'TIMEZONES__PACIFIC_APIA' }, { id: 'Asia/Aden', name: 'TIMEZONES__ASIA_ADEN' }, { id: 'Indian/Mayotte', name: 'TIMEZONES__INDIAN_MAYOTTE' }, { id: 'Africa/Johannesburg', name: 'TIMEZONES__AFRICA_JOHANNESBURG' }, { id: 'Africa/Lusaka', name: 'TIMEZONES__AFRICA_LUSAKA' }, { id: 'Africa/Harare', name: 'TIMEZONES__AFRICA_HARARE' }];

/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(492),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(495),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_vue_cordova__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_timezone__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_timezone__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "moment", function() { return __WEBPACK_IMPORTED_MODULE_8_moment_timezone___default.a; });










__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__utils_vue_cordova__["a" /* default */]);

var isCordova = false;

if (window.location.protocol === 'file:' || window.location.port === '3000') {
    var cordovaScript = document.createElement('script');
    cordovaScript.setAttribute('type', 'text/javascript');
    cordovaScript.setAttribute('src', 'cordova.js');
    document.body.appendChild(cordovaScript);
    isCordova = true;
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */]({
        translate: 'translation/translate'
    }))
});

if (document.getElementById('app')) {
    new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
        template: '<App/>',
        components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a },
        mounted: function mounted() {
            var _this = this;

            if (isCordova) {
                __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].cordova.on('deviceready', function () {
                    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('settings/init', { params: _this.$route.params, query: _this.$route.query, isCordova: isCordova });
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('settings/init', { params: this.$route.params, query: this.$route.query, isCordova: isCordova });
            }
        }
    });
}


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(519),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dateTimePicker__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_confirmation__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_settings__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_translation__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_signin__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_signup__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_forgotPassword__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dashboard__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_configuration__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_list__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_listItem__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_form__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_table__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_catalog__ = __webpack_require__(609);



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        dateTimePicker: __WEBPACK_IMPORTED_MODULE_2__modules_dateTimePicker__["a" /* default */],
        confirmation: __WEBPACK_IMPORTED_MODULE_3__modules_confirmation__["a" /* default */],
        settings: __WEBPACK_IMPORTED_MODULE_4__modules_settings__["a" /* default */],
        translation: __WEBPACK_IMPORTED_MODULE_5__modules_translation__["a" /* default */],
        signin: __WEBPACK_IMPORTED_MODULE_6__modules_signin__["a" /* default */],
        signup: __WEBPACK_IMPORTED_MODULE_7__modules_signup__["a" /* default */],
        forgotPassword: __WEBPACK_IMPORTED_MODULE_8__modules_forgotPassword__["a" /* default */],
        dashboard: __WEBPACK_IMPORTED_MODULE_9__modules_dashboard__["a" /* default */],
        configuration: __WEBPACK_IMPORTED_MODULE_10__modules_configuration__["a" /* default */],
        list: __WEBPACK_IMPORTED_MODULE_11__modules_list__["a" /* default */],
        listItem: __WEBPACK_IMPORTED_MODULE_12__modules_listItem__["a" /* default */],
        form: __WEBPACK_IMPORTED_MODULE_13__modules_form__["a" /* default */],
        table: __WEBPACK_IMPORTED_MODULE_14__modules_table__["a" /* default */],
        catalog: __WEBPACK_IMPORTED_MODULE_15__modules_catalog__["a" /* default */]
    }
}));

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(486),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
module.exports = __webpack_require__(76);


/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export functions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utilities__ = __webpack_require__(60);



var state = {
    visible: false,
    title: '',
    handlerAction: null,
    handlerActionParams: null,
    showTime: false,
    monthTitle: '',
    month: null,
    weekdays: [],
    days: [],
    hours: [],
    times: [],
    time: null,
    hourFormat: 'H',
    date: null
};

var mutations = {
    show: function show(state) {
        state.visible = true;
    },
    hide: function hide(state) {
        state.visible = false;
    },
    title: function title(state, _title) {
        state.title = _title;
    },
    handlerAction: function handlerAction(state, _handlerAction) {
        state.handlerAction = _handlerAction;
    },
    handlerActionParams: function handlerActionParams(state, _handlerActionParams) {
        state.handlerActionParams = _handlerActionParams;
    },
    showTime: function showTime(state, _showTime) {
        state.showTime = _showTime;
    },
    date: function date(state, _date) {
        state.date = _date;
    },
    monthTitle: function monthTitle(state, _monthTitle) {
        state.monthTitle = _monthTitle;
    },
    month: function month(state, _month) {
        state.month = _month;
    },
    weekdays: function weekdays(state, _weekdays) {
        state.weekdays = _weekdays;
    },
    days: function days(state, _days) {
        state.days = _days;
    },
    deselectDays: function deselectDays(state) {
        for (var i = 0; i < 42; i++) {
            state.days[i].isSelected = false;
        }
    },
    selectDay: function selectDay(state, index) {
        state.days[index].isSelected = true;
    },
    hours: function hours(state, _hours) {
        state.hours = _hours;
    },
    times: function times(state, _times) {
        state.times = _times;
    },
    time: function time(state, _time) {
        state.time = _time;
    },
    hourFormat: function hourFormat(state, _hourFormat) {
        state.hourFormat = _hourFormat;
    }
};

var functions = {
    local: function local(store, date) {
        return __WEBPACK_IMPORTED_MODULE_0__main__["moment"].tz(date, store.rootState.settings.account.timezone);
    },
    loadDates: function loadDates(store, date) {
        store.commit('monthTitle', date.format('MMMM YYYY'));

        var currentMonth = date.month();
        date.startOf('week');
        var days = [];
        for (var i = 0; i < 42; i++) {
            days.push({
                name: date.format('D'),
                isCurrentMonth: date.month() === currentMonth,
                date: date.clone(),
                isSelected: store.state.date ? date.isSame(store.state.date, 'day') : false
            });
            date.add(1, 'd');
        }
        store.commit('days', days);
    },
    loadHours: function loadHours(store, date) {
        var nextDay = date.clone().add(1, 'd');
        var hours = [];

        var timesDate = date.clone();
        var times = [];

        while (date.diff(nextDay) < 0) {
            hours.push(date.format(store.state.hourFormat));
            date.add(1, 'h');
        }

        var timeIndex = 0;
        var position = 0;
        var selectedTimeIndex = 0;

        while (timesDate.diff(nextDay) < 0) {
            if (timesDate.isSame(store.state.date)) {
                selectedTimeIndex = timeIndex;
            }

            times.push({
                title: timesDate.format('LT'),
                date: timesDate.clone(),
                position: position * 100 / 48,
                index: timeIndex
            });
            timeIndex++;

            position++;
            timesDate.add(30, 'm');
        }
        store.commit('times', times);
        store.commit('time', times[selectedTimeIndex]);
        store.commit('hours', hours);
    }
};

var actions = {
    init: function init(store) {
        var weekdays = [];
        for (var i = 0; i < 7; i++) {
            weekdays.push(__WEBPACK_IMPORTED_MODULE_0__main__["moment"]().weekday(i).format('dd'));
        }
        store.commit('weekdays', weekdays);

        var hourFormat = store.rootState.settings.account.culture === 'en' ? 'h' : 'H';

        store.commit('hourFormat', hourFormat);
    },
    open: function open(store, _ref) {
        var dateString = _ref.dateString,
            title = _ref.title,
            handlerAction = _ref.handlerAction,
            handlerActionParams = _ref.handlerActionParams,
            showTime = _ref.showTime;

        var date = __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].convertStringToDate(store, dateString, false, store.state.showTime ? 'L LT' : 'L');
        var dateMoment = date ? __WEBPACK_IMPORTED_MODULE_0__main__["moment"](date) : __WEBPACK_IMPORTED_MODULE_0__main__["moment"]();

        store.commit('title', title);
        store.commit('handlerAction', handlerAction);
        store.commit('handlerActionParams', handlerActionParams);
        store.commit('showTime', showTime);
        store.commit('date', dateMoment);

        var dayStart = dateMoment.clone().startOf('day');
        functions.loadHours(store, dayStart.clone());

        var monthStart = dateMoment.clone().startOf('month');
        store.commit('month', monthStart.clone());
        functions.loadDates(store, monthStart);

        store.commit('show');
    },
    nextMonth: function nextMonth(store) {
        var nextMonth = store.state.month.clone().add(1, 'M');
        store.commit('month', nextMonth);
        functions.loadDates(store, nextMonth.clone());
    },
    previousMonth: function previousMonth(store) {
        var nextMonth = store.state.month.clone().subtract(1, 'M');
        store.commit('month', nextMonth);
        functions.loadDates(store, nextMonth.clone());
    },
    pickDay: function pickDay(store, payload) {
        store.commit('deselectDays');
        store.commit('selectDay', payload.index);
        functions.loadHours(store, payload.date.clone());
    },
    nextTime: function nextTime(store) {
        if (store.state.time.index < store.state.times.length - 1) {
            store.commit('time', store.state.times[store.state.time.index + 1]);
        }
    },
    previousTime: function previousTime(store) {
        if (store.state.time.index > 0) {
            store.commit('time', store.state.times[store.state.time.index - 1]);
        }
    },
    pickTime: function pickTime(store, event) {
        var x = !!event.touches ? event.touches[0].pageX : event.pageX;
        var offset = 0;
        var ref = event.currentTarget;

        while (ref) {
            offset += ref.offsetLeft;
            ref = ref.offsetParent;
        }

        var position = (x - offset) / event.currentTarget.offsetWidth;

        var positionPercent = position * 100;
        if (store.state.times.length > 0) {
            var time = store.state.times[0];
            var diff = Math.abs(time.position - positionPercent);
            var index = 0;
            for (var i = 1; i < store.state.times.length; i++) {
                var newDiff = Math.abs(store.state.times[i].position - positionPercent);
                if (newDiff < diff) {
                    diff = newDiff;
                } else {
                    break;
                }
                index = i;
            }
            store.commit('time', store.state.times[index]);
        }
    },
    hide: function hide(store) {
        store.commit('hide');
    },
    ok: function ok(store) {
        store.dispatch(store.state.handlerAction, {
            dateString: __WEBPACK_IMPORTED_MODULE_0__main__["moment"].tz(store.state.time.date, store.rootState.settings.account.timezone).format(store.state.showTime ? 'L LT' : 'L'),
            date: store.state.time.date,
            params: store.state.handlerActionParams
        }, { root: true });
        store.commit('hide');
    }
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
    visible: false,
    title: '',
    handlerAction: null,
    handlerActionParams: null,
    cancelAction: null,
    cancelActionParams: null
};

var mutations = {
    show: function show(state) {
        state.visible = true;
    },
    hide: function hide(state) {
        state.visible = false;
    },
    title: function title(state, _title) {
        state.title = _title;
    },
    handlerAction: function handlerAction(state, _handlerAction) {
        state.handlerAction = _handlerAction;
    },
    handlerActionParams: function handlerActionParams(state, _handlerActionParams) {
        state.handlerActionParams = _handlerActionParams;
    },
    cancelAction: function cancelAction(state, _cancelAction) {
        state.cancelAction = _cancelAction;
    },
    cancelActionParams: function cancelActionParams(state, _cancelActionParams) {
        state.cancelActionParams = _cancelActionParams;
    }
};

var actions = {
    open: function open(store, payload) {
        store.commit('title', payload.title);
        store.commit('handlerAction', payload.handlerAction);
        store.commit('handlerActionParams', payload.handlerActionParams);
        store.commit('cancelAction', payload.cancelAction);
        store.commit('cancelActionParams', payload.cancelActionParams);
        store.commit('show');
    },
    hide: function hide(store) {
        if (store.state.cancelAction) {
            store.dispatch(store.state.cancelAction, store.state.cancelActionParams, { root: true });
        }
        store.commit('hide');
    },
    ok: function ok(store) {
        store.dispatch(store.state.handlerAction, store.state.handlerActionParams, { root: true });
        store.commit('hide');
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(76);








var state = {
    loaded: false,
    isCordova: false,
    server: '',
    account: {},
    errors: [],
    messages: []
};

var mutations = {
    loaded: function loaded(state, _loaded) {
        state.loaded = _loaded;
    },
    isCordova: function isCordova(state, _isCordova) {
        state.isCordova = _isCordova;
    },
    server: function server(state, _server) {
        state.server = _server;
    },
    account: function account(state, _account) {
        state.account = _account;
    },
    addError: function addError(state, error) {
        state.errors.push(error);
    },
    removeError: function removeError(state, index) {
        if (index >= 0) {
            state.errors.splice(index, 1);
        }
    },
    addMessage: function addMessage(state, message) {
        state.messages.push(message);
    },
    removeMessage: function removeMessage(state, index) {
        if (index >= 0) {
            state.messages.splice(index, 1);
        }
    }
};

var getters = {
    server: function server(state) {
        return function () {
            return state.server;
        };
    }
};

var functions = {
    signout: function signout(store) {
        try {
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].tokenKey);
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Authorization'] = '';
        __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace({ name: 'signin' });
    },
    initAccount: function initAccount(store) {
        __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/api/account/').then(function (response) {
            var account = response.body;
            store.commit('account', account);

            store.dispatch('translation/init', account.culture, { root: true });
            __WEBPACK_IMPORTED_MODULE_6__main__["moment"].locale(account.culture);
            __WEBPACK_IMPORTED_MODULE_6__main__["moment"].tz.setDefault(account.timezone);

            store.commit('loaded', true);
        }, function () {});
    }
};

var actions = {
    initAccount: function initAccount(store) {
        functions.initAccount(store);
    },
    init: function init(store, payload) {
        var culture = __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].culture;

        if (window.Intl && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default.a(window.Intl) === 'object') {
            if (navigator.language.lastIndexOf('ru', 0) === 0) {} else if (navigator.language.lastIndexOf('de', 0) === 0) {
                culture = 'de';
            }
        }

        store.dispatch('translation/init', culture, { root: true });

        payload.isCordova = true;
        store.commit('isCordova', payload.isCordova);
        if (store.state.isCordova) {
            store.commit('server', __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].server);
        }

        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.errorHandler = function (err, vm) {
            var path = '';
            if (vm && vm.$route && vm.$route.fullPath) {
                path = vm.$route.fullPath;
            }
            __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].post('/api/error/log', {
                message: err.message + ' at ' + path,
                exception: err.stack
            });
        };

        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Cache-Control'] = 'no-cache';
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Pragma'] = 'no-cache';
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.interceptors.push(function (request, next) {
            next(function (response) {
                if (response.status === 401) {
                    store.dispatch('settings/signout', null, { root: true });
                }

                var newToken = response.headers.get('x-vue-mobile-refresh-token');
                if (newToken) {
                    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Authorization'] = 'Bearer ' + newToken;
                    try {
                        var _authorizationDataString = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].tokenKey);
                        if (_authorizationDataString) {
                            var _authorizationData = JSON.parse(_authorizationDataString);
                            _authorizationData.token = newToken;
                            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].tokenKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a(_authorizationData));
                        }
                    } catch (e) {}
                }
            });
        });

        var authorizationData = null;
        var authorizationDataString = null;

        try {
            authorizationDataString = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].tokenKey);
        } catch (e) {}

        if (authorizationDataString) {
            authorizationData = JSON.parse(authorizationDataString);
        }
        if (!authorizationData) {
            functions.signout(store);
            store.commit('loaded', true);
        } else {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Authorization'] = 'Bearer ' + authorizationData.token;
            functions.initAccount(store);
        }
    },
    save: function save(store, payload) {
        __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/api/account/', {
            timezone: payload.timezone,
            culture: payload.culture
        }).then(function () {
            functions.initAccount(store);
        }, function () {});
    },
    signout: function signout(store) {
        functions.signout(store);
    },
    openDashboard: function openDashboard() {
        __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
            name: 'dashboard'
        });
    },
    addError: function addError(store, error) {
        store.commit('addError', error);
        setTimeout(function () {
            store.commit('removeError', store.state.errors.indexOf(error));
        }, 3000);
    },
    removeError: function removeError(store, index) {
        store.commit('removeError', index);
    },
    addMessage: function addMessage(store, message) {
        store.commit('addMessage', message);
        setTimeout(function () {
            store.commit('removeMessage', store.state.messages.indexOf(message));
        }, 3000);
    },
    removeMessage: function removeMessage(store, index) {
        store.commit('removeMessage', index);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account_signin__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_signup__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_checkEmail__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_sendPasswordResetLink__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_get__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_save__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_save__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_get__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__list_create__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__list_delete__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__list_get__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__list_getAll__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__list_update__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__table_search__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__catalog_getItems__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__todo_create__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__todo_delete__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__todo_getAll__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__todo_update__ = __webpack_require__(475);





















/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        console.log('GET: ' + url);

        switch (url) {
            case '/api/account/':
                return __WEBPACK_IMPORTED_MODULE_5__account_get__["a" /* default */].get(url);
            case '/api/form/':
                return __WEBPACK_IMPORTED_MODULE_8__form_get__["a" /* default */].get(url);
            case '/api/list/':
                return __WEBPACK_IMPORTED_MODULE_12__list_getAll__["a" /* default */].get(url);
            case '/api/todo/':
                return __WEBPACK_IMPORTED_MODULE_18__todo_getAll__["a" /* default */].get(url);
            default:
                if (url.indexOf('/api/account/checkEmail') === 0) {
                    return __WEBPACK_IMPORTED_MODULE_3__account_checkEmail__["a" /* default */].get(url);
                } else if (url.indexOf('/api/list/') === 0) {
                    return __WEBPACK_IMPORTED_MODULE_11__list_get__["a" /* default */].get(url);
                } else if (url.indexOf('/api/catalog/getItems') === 0) {
                    return __WEBPACK_IMPORTED_MODULE_15__catalog_getItems__["a" /* default */].get(url);
                }
        }

        return null;
    },
    post: function post(url, data) {
        console.log('POST: ' + url);
        console.log(data);

        switch (url) {
            case '/api/error/log':
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    resolve({ body: {} });
                });
            case '/api/account/signin':
                return __WEBPACK_IMPORTED_MODULE_1__account_signin__["a" /* default */].post(url, data);
            case '/api/account/signup':
                return __WEBPACK_IMPORTED_MODULE_2__account_signup__["a" /* default */].post(url, data);
            case '/api/account/sendPasswordResetLink':
                return __WEBPACK_IMPORTED_MODULE_4__account_sendPasswordResetLink__["a" /* default */].post(url, data);
            case '/api/table/search':
                return __WEBPACK_IMPORTED_MODULE_14__table_search__["a" /* default */].post(url, data);
            case '/api/list/':
                return __WEBPACK_IMPORTED_MODULE_9__list_create__["a" /* default */].post(url, data);
            case '/api/todo/':
                return __WEBPACK_IMPORTED_MODULE_16__todo_create__["a" /* default */].post(url, data);
        }

        return null;
    },
    put: function put(url, data) {
        console.log('PUT: ' + url);
        console.log(data);

        if (url.indexOf('/api/list/') === 0) {
            return __WEBPACK_IMPORTED_MODULE_13__list_update__["a" /* default */].put(url, data);
        } else if (url.indexOf('/api/todo/') === 0) {
            return __WEBPACK_IMPORTED_MODULE_19__todo_update__["a" /* default */].put(url, data);
        } else {
            switch (url) {
                case '/api/account/':
                    return __WEBPACK_IMPORTED_MODULE_6__account_save__["a" /* default */].put(url, data);
                case '/api/form/':
                    return __WEBPACK_IMPORTED_MODULE_7__form_save__["a" /* default */].put(url, data);
            }
        }
        return null;
    },
    delete: function _delete(url) {
        console.log('DELETE: ' + url);
        if (url.indexOf('/api/list/') === 0) {
            return __WEBPACK_IMPORTED_MODULE_10__list_delete__["a" /* default */].delete(url);
        } else if (url.indexOf('/api/todo/') === 0) {
            return __WEBPACK_IMPORTED_MODULE_17__todo_delete__["a" /* default */].delete(url);
        }
        return null;
    }
});

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
    post: function post(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (data.email == null || data.email === '') {
                reject({
                    status: 400,
                    body: [{
                        property: 'Email',
                        message: 'MESSAGE__ACCOUNT__EMAIL_REQUIRED'
                    }]
                });
                return;
            } else {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(data.email)) {
                    reject({
                        status: 400,
                        body: [{
                            property: 'Email',
                            message: 'MESSAGE__ACCOUNT__EMAIL_NOT_VALID'
                        }]
                    });
                    return;
                }
            }

            if (data.password == null || data.password === '') {
                reject({
                    status: 400,
                    body: [{
                        property: 'Password',
                        message: 'MESSAGE__ACCOUNT__PASSWORD_REQUIRED'
                    }]
                });
                return;
            }

            if (data.email !== 'john@example.com' || data.password !== 'password') {
                reject({
                    status: 400,
                    body: [{
                        property: 'Email',
                        message: 'MESSAGE__ACCOUNT__EMAIL_OR_PASSWORD_INVALID'
                    }]
                });
                return;
            }

            resolve({
                body: {
                    email: 'john@test.com',
                    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'
                }
            });
        });
    }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
    post: function post(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var errors = [];

            if (data.email == null || data.email === '') {
                errors.push({
                    property: 'Email',
                    message: 'MESSAGE__ACCOUNT__EMAIL_REQUIRED'
                });
            } else {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(data.email)) {
                    errors.push({
                        property: 'Email',
                        message: 'MESSAGE__ACCOUNT__EMAIL_NOT_VALID'
                    });
                }
            }

            if (data.password == null || data.password === '') {
                errors.push({
                    property: 'Password',
                    message: 'MESSAGE__ACCOUNT__PASSWORD_REQUIRED'
                });
            }

            if (data.confirmPassword == null || data.confirmPassword === '') {
                errors.push({
                    property: 'ConfirmPassword',
                    message: 'MESSAGE__ACCOUNT__CONFIRM_PASSWORD_REQUIRED'
                });
            }

            if (data.confirmPassword !== data.password) {
                errors.push({
                    property: 'ConfirmPassword',
                    message: 'MESSAGE__ACCOUNT__PASSWORD_CONFIRMATION_NOT_VALID'
                });
            }

            if (data.termsAccepted == null || data.termsAccepted === false) {
                errors.push({
                    property: 'TermsAccepted',
                    message: 'MESSAGE__ACCOUNT__TERMS_NOT_ACCEPTED'
                });
            }

            if (data.name == null || data.name === '') {
                errors.push({
                    property: 'Name',
                    message: 'MESSAGE__ACCOUNT__NAME_REQUIRED'
                });
            }

            if (data.company == null || data.company === '') {
                errors.push({
                    property: 'Company',
                    message: 'MESSAGE__ACCOUNT__COMPANY_NAME_REQUIRED'
                });
            }

            if (data.timezone == null || data.timezone === '') {
                errors.push({
                    property: 'Timezone',
                    message: 'MESSAGE__ACCOUNT__TIMEZONE_REQUIRED'
                });
            }

            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            resolve({
                body: {
                    email: 'john@test.com',
                    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'
                }
            });
        });
    }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve({
                body: true
            });
        });
    }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
    post: function post(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (data.email == null || data.email === '') {
                reject({
                    status: 400,
                    body: [{
                        property: 'Email',
                        message: 'MESSAGE__ACCOUNT__EMAIL_REQUIRED'
                    }]
                });
                return;
            } else {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(data.email)) {
                    reject({
                        status: 400,
                        body: [{
                            property: 'Email',
                            message: 'MESSAGE__ACCOUNT__EMAIL_NOT_VALID'
                        }]
                    });
                    return;
                }
            }

            resolve({
                body: null
            });
        });
    }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve({
                body: {
                    email: 'john@test.com',
                    name: 'John',
                    userId: 99,
                    timezone: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].timezone,
                    culture: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].culture
                }
            });
        });
    }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    put: function put(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].culture = data.culture;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].timezone = data.timezone;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();

            resolve({
                body: {}
            });
        });
    }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    put: function put(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var errors = [];

            if (data.textValue === null || data.textValue === '') {
                errors.push({
                    property: 'TextValue',
                    message: 'MESSAGE__FORM__TEXT_REQUIRED'
                });
            }

            if (data.textareaValue === null || data.textareaValue === '') {
                errors.push({
                    property: 'TextareaValue',
                    message: 'MESSAGE__FORM__TEXTAREA_REQUIRED'
                });
            }

            if (!data.checkboxValue) {
                errors.push({
                    property: 'CheckboxValue',
                    message: 'MESSAGE__FORM__CHECKBOX_REQUIRED'
                });
            }

            if (data.dropdownValue === null || data.dropdownValue === '') {
                errors.push({
                    property: 'DropdownValue',
                    message: 'MESSAGE__FORM__DROPDOWN_REQUIRED'
                });
            }

            if (data.radioValue === null || data.radioValue === '') {
                errors.push({
                    property: 'RadioValue',
                    message: 'MESSAGE__FORM__RADIO_REQUIRED'
                });
            }

            if (data.date === null) {
                errors.push({
                    property: 'Date',
                    message: 'MESSAGE__FORM__DATE_REQUIRED'
                });
            }

            if (data.dateTime === null) {
                errors.push({
                    property: 'DateTime',
                    message: 'MESSAGE__FORM__DATETIME_REQUIRED'
                });
            }

            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].textValue = data.textValue;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].textareaValue = data.textareaValue;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].checkboxValue = data.checkboxValue;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].dropdownValue = data.dropdownValue;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].radioValue = data.radioValue;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].segmentedValue = data.segmentedValue;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].date = data.date;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].dateTime = data.dateTime;
            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();

            resolve({
                body: {}
            });
        });
    }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve({
                body: {
                    textValue: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].textValue,
                    textareaValue: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].textareaValue,
                    checkboxValue: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].checkboxValue,
                    dropdownValue: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].dropdownValue,
                    radioValue: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].radioValue,
                    segmentedValue: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].segmentedValue,
                    date: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].date,
                    dateTime: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].dateTime
                }
            });
        });
    }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    post: function post(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var errors = [];

            if (data.name === null || data.name === '') {
                errors.push({
                    property: 'Name',
                    message: 'MESSAGE__LIST__NAME_REQUIRED'
                });
            }

            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            var maxId = 0;
            for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list.length; i++) {
                if (__WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list[i].id >= maxId) {
                    maxId = __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list[i].id + 1;
                }
            }

            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list.push({
                id: maxId,
                name: data.name,
                sex: data.sex
            });

            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();

            resolve({
                body: {
                    id: maxId,
                    name: data.name,
                    sex: data.sex
                }
            });
        });
    }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    delete: function _delete(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var matches = url.match(/^\/api\/list\/(\d+)/);
            if (matches.length === 2) {
                var id = matches[1];

                var index = -1;
                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list.length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list[i].id === +id) {
                        index = i;
                    }
                }

                if (index >= 0) {
                    __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list.splice(index, 1);
                    __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();
                    resolve({ body: {} });
                }
            }
            reject();
        });
    }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var matches = url.match(/^\/api\/list\/(\d+)/);
            if (matches.length === 2) {
                var id = matches[1];

                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list.length; i++) {
                    var item = __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list[i];
                    if (item.id === +id) {
                        resolve({
                            body: {
                                id: item.id,
                                sex: item.sex,
                                name: item.name
                            }
                        });
                        return;
                    }
                }
            }
            reject();
        });
    }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve({
                body: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list
            });
        });
    }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    put: function put(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var errors = [];

            if (data.name === null || data.name === '') {
                errors.push({
                    property: 'Name',
                    message: 'MESSAGE__LIST__NAME_REQUIRED'
                });
            }

            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            var matches = url.match(/^\/api\/list\/(\d+)/);
            if (matches.length === 2) {
                var id = matches[1];

                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list.length; i++) {
                    var item = __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].list[i];
                    if (item.id === +id) {
                        item.name = data.name;
                        item.sex = data.sex;
                        __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();

                        resolve({
                            body: {
                                id: item.id,
                                sex: item.sex,
                                name: item.name
                            }
                        });
                        return;
                    }
                }
            }
            reject();
        });
    }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var items = [{ id: 1, name: 'Latifah May', phone: '055 2905 8233', company: 'Mi Lacinia LLC', city: 'Pugwash' }, { id: 2, name: 'Guinevere Contreras', phone: '(0111) 325 9321', company: 'Donec Egestas Ltd', city: 'Chepstow' }, { id: 3, name: 'Nicole Porter', phone: '07176 416325', company: 'Sed Industries', city: 'Bonnyrigg' }, { id: 4, name: 'Lavinia King', phone: '0966 374 2806', company: 'Quis Institute', city: 'Wunstorf' }, { id: 5, name: 'Sylvia Chase', phone: '(016977) 3792', company: 'Elementum Lorem Company', city: 'Puerto Varas' }, { id: 6, name: 'Ella Sanchez', phone: '0500 424504', company: 'Sem Consulting', city: 'Güssing' }, { id: 7, name: 'Mira Ross', phone: '(01740) 705123', company: 'Enim LLC', city: 'Eisenhüttenstadt' }, { id: 8, name: 'Inga Higgins', phone: '(0171) 832 0840', company: 'Sit Industries', city: 'Vico nel Lazio' }, { id: 9, name: 'Joelle Rodriquez', phone: '07542 877744', company: 'Libero Et Limited', city: 'Charny' }, { id: 10, name: 'Amanda Daniel', phone: '0845 46 45', company: 'At Industries', city: 'Treppo Carnico' }, { id: 11, name: 'Laurel Short', phone: '0800 380 5680', company: 'Ligula Aenean Euismod Associates', city: 'Melilla' }, { id: 12, name: 'Teagan Robertson', phone: '07400 330925', company: 'Vestibulum Neque Sed Foundation', city: 'Newbury' }, { id: 13, name: 'Mara Francis', phone: '0949 141 3625', company: 'Nunc Sed Company', city: 'Braunau am Inn' }, { id: 14, name: 'Melodie Gibson', phone: '0500 155262', company: 'Aliquam Eros Turpis Company', city: 'Vieux-Genappe' }, { id: 15, name: 'Piper Webster', phone: '0800 285351', company: 'Commodo Auctor Institute', city: 'Kozhikode' }, { id: 16, name: 'Kiayada Howell', phone: '056 1914 9676', company: 'Arcu Vel Quam Corporation', city: 'Bismil' }, { id: 17, name: 'Vera Hodges', phone: '07406 557026', company: 'Nec Urna Suscipit Consulting', city: 'Olsztyn' }, { id: 18, name: 'Echo Boyle', phone: '(01134) 289894', company: 'Malesuada PC', city: 'Edam' }, { id: 19, name: 'Demetria English', phone: '056 6289 6434', company: 'Malesuada Company', city: 'Naperville' }, { id: 20, name: 'Fleur Quinn', phone: '056 4108 3391', company: 'Sollicitudin Orci Sem Incorporated', city: 'Dumfries' }, { id: 21, name: 'Jocelyn Workman', phone: '(015761) 71663', company: 'Urna Ut Tincidunt Limited', city: 'Iowa City' }, { id: 22, name: 'Molly Avery', phone: '0800 918336', company: 'Porttitor LLC', city: 'Pomarolo' }, { id: 23, name: 'Julie Mcdaniel', phone: '(027) 2710 7448', company: 'Tortor Nunc Corporation', city: 'Saint Paul' }, { id: 24, name: 'Oprah Mitchell', phone: '0800 313 6952', company: 'Ultricies Consulting', city: 'Ayr' }, { id: 25, name: 'Amena Mann', phone: '(028) 8285 7411', company: 'Eget Tincidunt Dui Inc.', city: 'Lampa' }, { id: 26, name: 'Quon Woodward', phone: '0363 962 2707', company: 'Ut Corp.', city: 'Tubeke Tubize' }, { id: 27, name: 'Ina Mcmahon', phone: '0928 466 3430', company: 'Dui Foundation', city: 'Contulmo' }, { id: 28, name: 'Bianca Holloway', phone: '(0119) 193 3822', company: 'Aliquam Adipiscing Institute', city: 'Ospedaletto Alpinolo' }, { id: 29, name: 'May Benson', phone: '0800 034602', company: 'Malesuada Fames Ac Ltd', city: 'Boncelles' }, { id: 30, name: 'Cameran Monroe', phone: '(012100) 95706', company: 'Fermentum LLC', city: 'Sankt Ingbert' }, { id: 31, name: 'Uta Savage', phone: '0500 703497', company: 'At Iaculis LLC', city: 'Watford' }, { id: 32, name: 'Ivana Blake', phone: '(026) 0760 4090', company: 'Mi Aliquam Limited', city: 'Ostellato' }, { id: 33, name: 'Ivy Kent', phone: '(0115) 852 5023', company: 'Auctor Non Foundation', city: 'Płock' }, { id: 34, name: 'Casey Everett', phone: '0845 46 40', company: 'Congue In Scelerisque LLP', city: 'Köflach' }, { id: 35, name: 'Adria Rhodes', phone: '(022) 7843 7916', company: 'Sed Diam Industries', city: 'New Plymouth' }, { id: 36, name: 'Judith Hicks', phone: '(0191) 249 6686', company: 'Vulputate Eu Odio Corporation', city: 'Gambolò' }, { id: 37, name: 'Tashya Mcdaniel', phone: '0981 325 6321', company: 'Ipsum Porta Associates', city: 'Haverfordwest' }, { id: 38, name: 'Minerva Pena', phone: '0800 1111', company: 'Arcu Incorporated', city: 'West Jordan' }, { id: 39, name: 'Madaline Case', phone: '07624 339068', company: 'Ac Libero Associates', city: 'Bossut-Gottechain' }, { id: 40, name: 'Joy Serrano', phone: '(025) 4404 7500', company: 'Velit Justo Limited', city: 'Edmonton' }, { id: 41, name: 'Lacota Mayo', phone: '(01295) 895127', company: 'Diam Nunc Incorporated', city: 'Rennes' }, { id: 42, name: 'Rebecca Reyes', phone: '0800 1111', company: 'Rutrum Non Hendrerit Institute', city: 'Gosnells' }, { id: 43, name: 'Kelsie Giles', phone: '(0118) 674 2805', company: 'Aliquet PC', city: 'Augusta' }, { id: 44, name: 'Desiree Bruce', phone: '0391 730 8798', company: 'A Ultricies Adipiscing Company', city: 'Penrith' }, { id: 45, name: 'Alfreda Lara', phone: '(01014) 92613', company: 'Eget Tincidunt Institute', city: 'Kasterlee' }, { id: 46, name: 'Quemby Cortez', phone: '07196 851668', company: 'Dui Nec Consulting', city: 'Gembloux' }, { id: 47, name: 'Lani Roach', phone: '07020 118337', company: 'Non Foundation', city: 'Guápiles' }, { id: 48, name: 'Jorden Alexander', phone: '0874 510 0026', company: 'Proin Corp.', city: 'Villa Cortese' }, { id: 49, name: 'Shea Dawson', phone: '07639 200787', company: 'Et Ltd', city: 'Meerut' }, { id: 50, name: 'Nerea Bullock', phone: '(016977) 8560', company: 'Mauris Vestibulum Neque Associates', city: 'Ashbourne' }, { id: 51, name: 'Alice Campos', phone: '(01925) 484986', company: 'Massa Rutrum Magna Institute', city: 'Wabamun' }, { id: 52, name: 'Sandra Rich', phone: '0363 302 8005', company: 'Nunc Sed Company', city: 'Walhain-Saint-Paul' }, { id: 53, name: 'Wilma Dillard', phone: '0800 999 4932', company: 'Natoque Penatibus Foundation', city: 'Hoeke' }, { id: 54, name: 'Melanie Page', phone: '(029) 2924 9503', company: 'Nisl LLC', city: 'Istanbul' }, { id: 55, name: 'Vivian Wallace', phone: '0961 578 8023', company: 'Gravida Institute', city: 'Pamplona' }, { id: 56, name: 'Rose Conner', phone: '(014649) 93566', company: 'Morbi Tristique Senectus Limited', city: 'Moga' }, { id: 57, name: 'Rebekah Chaney', phone: '(01631) 10127', company: 'Fames Ac Institute', city: 'StrŽe' }, { id: 58, name: 'Kimberley Macdonald', phone: '0363 185 5253', company: 'Nam Company', city: 'Creil' }, { id: 59, name: 'Maite Harper', phone: '(0141) 144 2016', company: 'Aliquet Vel Institute', city: 'Flint' }, { id: 60, name: 'Tatum Dickerson', phone: '0500 265134', company: 'Mauris Inc.', city: 'Eisenhüttenstadt' }, { id: 61, name: 'Sacha Bauer', phone: '0363 491 0412', company: 'Nascetur Corporation', city: 'Parbhani' }, { id: 62, name: 'Illiana Franks', phone: '(01899) 84531', company: 'Magna PC', city: 'Rabbi' }, { id: 63, name: 'Wynne Cline', phone: '0800 1111', company: 'Ac Tellus Suspendisse Consulting', city: 'Wetteren' }, { id: 64, name: 'Jescie Tate', phone: '0800 928941', company: 'Leo Corporation', city: 'Andernach' }, { id: 65, name: 'Anjolie Mason', phone: '(010039) 19744', company: 'Magnis Limited', city: 'Warspite' }, { id: 66, name: 'Tamekah Pittman', phone: '070 9441 7132', company: 'Sapien Gravida Institute', city: 'Tourcoing' }, { id: 67, name: 'Jana Baker', phone: '0800 1111', company: 'Dolor Vitae Dolor Associates', city: 'Sangerhausen' }, { id: 68, name: 'Jaden Taylor', phone: '0800 1111', company: 'Imperdiet Ornare In Incorporated', city: 'Baiso' }, { id: 69, name: 'Christine Kramer', phone: '(016977) 2081', company: 'Libero Ltd', city: 'St. Catharines' }, { id: 70, name: 'Flavia Hebert', phone: '0800 853990', company: 'Per Ltd', city: 'Gjoa Haven' }, { id: 71, name: 'Tara Page', phone: '056 2156 9281', company: 'Congue Elit LLP', city: 'Atlanta' }, { id: 72, name: 'Breanna Shelton', phone: '0800 1111', company: 'Gravida Molestie Arcu PC', city: 'Rothesay' }, { id: 73, name: 'Phoebe Roy', phone: '(029) 2130 7085', company: 'Quisque Industries', city: 'Gilly' }, { id: 74, name: 'Mona Whitfield', phone: '(016977) 8317', company: 'Condimentum Corp.', city: 'Reggio Emilia' }, { id: 75, name: 'Adrienne Merrill', phone: '(01299) 064806', company: 'Nulla Semper Tellus Consulting', city: 'Santa Maria a Monte' }, { id: 76, name: 'Kelsey Whitehead', phone: '(01209) 165872', company: 'Sed Leo Industries', city: 'Bois-de-Villers' }, { id: 77, name: 'Lesley Lindsay', phone: '0800 1111', company: 'Dolor Sit Amet Associates', city: 'Athus' }, { id: 78, name: 'Ignacia Griffin', phone: '(017952) 18531', company: 'Blandit Corporation', city: 'Vaux-sous-ChŽvremont' }, { id: 79, name: 'Jocelyn Parks', phone: '0800 643321', company: 'Parturient Corporation', city: 'Nairn' }, { id: 80, name: 'Octavia Wong', phone: '(01531) 98572', company: 'A Ultricies Adipiscing Industries', city: 'Spinoso' }, { id: 81, name: 'Noelani Huff', phone: '(01941) 555676', company: 'Lorem Vehicula Inc.', city: 'Fairbanks' }, { id: 82, name: 'Rinah Dotson', phone: '0800 750578', company: 'Sed Incorporated', city: 'Lexington' }, { id: 83, name: 'Maxine Orr', phone: '(0110) 489 2806', company: 'Gravida Molestie Corporation', city: 'Zonhoven' }, { id: 84, name: 'Daria Mitchell', phone: '(016977) 3556', company: 'Tincidunt Nibh Phasellus Company', city: 'Blieskastel' }, { id: 85, name: 'Margaret Stout', phone: '056 4725 2110', company: 'Iaculis Nec Limited', city: 'Fumal' }, { id: 86, name: 'September Garrison', phone: '0845 46 47', company: 'Egestas Aliquam Nec Ltd', city: 'Słupsk' }, { id: 87, name: 'Mercedes Booth', phone: '(0111) 614 0741', company: 'Vestibulum Neque Foundation', city: 'Sint-Amandsberg' }, { id: 88, name: 'Lunea Chang', phone: '0500 611151', company: 'Vulputate Velit Eu Ltd', city: 'Wolkrange' }, { id: 89, name: 'Sacha Massey', phone: '0800 641 1893', company: 'Morbi Corporation', city: 'Coassolo Torinese' }, { id: 90, name: 'Carolyn Mclean', phone: '(01618) 343440', company: 'Risus Varius Foundation', city: 'Haguenau' }, { id: 91, name: 'Freya Mitchell', phone: '0800 834507', company: 'Ultricies Sem Company', city: 'Quilicura' }, { id: 92, name: 'Glenna Sosa', phone: '07815 637428', company: 'Ac Industries', city: 'Bathgate' }, { id: 93, name: 'Dahlia Sharp', phone: '(01072) 08413', company: 'Aenean Institute', city: 'Biloxi' }, { id: 94, name: 'Chloe Walker', phone: '0895 974 0321', company: 'Arcu Et Inc.', city: 'Regina' }, { id: 95, name: 'Amethyst Cunningham', phone: '(0116) 412 0430', company: 'Elit Sed Consequat Ltd', city: 'Valbrevenna' }];

/* harmony default export */ __webpack_exports__["a"] = ({
    post: function post(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            var result = data.filter ? items.filter(function (el) {
                return el.phone.indexOf(data.filter) !== -1 || el.name.indexOf(data.filter) !== -1 || el.company.indexOf(data.filter) !== -1 || el.city.indexOf(data.filter) !== -1;
            }) : items.slice();

            var totalCount = result.length;
            var desc = data.order.charAt(0) === '-';

            var order = data.order;
            if (desc) {
                order = order.substring(1);
            }

            result.sort(function (a, b) {
                var e1 = desc ? b : a;
                var e2 = desc ? a : b;
                switch (order) {
                    case 'name':
                        return e1.name.localeCompare(e2.name);
                    case 'phone':
                        return e1.phone.localeCompare(e2.phone);
                    case 'company':
                        return e1.company.localeCompare(e2.company);
                    case 'city':
                        return e1.city.localeCompare(e2.city);
                }
                return 0;
            });

            result = result.slice((data.page - 1) * data.limit, data.page * data.limit);

            resolve({
                body: {
                    items: result,
                    totalCount: totalCount
                }
            });
        });
    }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var rootItems = [{ id: 1, name: 'Group of items', description: 'Phasellus dapibus quam quis diam. Pellentesque habitant morbi tristique senectus et netus et.', image: 'static/images/cards/1.jpg', isGroup: true }, { id: 2, name: 'Green Item', description: 'Sed et libero. Proin mi. Aliquam gravida mauris ut mi.', image: 'static/images/cards/2.jpg', isGroup: false }, { id: 3, name: 'Blue Item', description: 'Nam porttitor scelerisque neque. Nullam nisl. Maecenas malesuada fringilla est. Mauris eu turpis.', image: 'static/images/cards/3.jpg', isGroup: false }, { id: 4, name: 'Red Item', description: 'Proin vel arcu eu odio tristique pharetra. Quisque ac libero nec ligula consectetuer rhoncus.', image: 'static/images/cards/4.jpg', isGroup: false }, { id: 5, name: 'Purple Item', description: 'Cras dictum ultricies ligula. Nullam enim. Sed nulla ante.', image: 'static/images/cards/5.jpg', isGroup: false }];

var groupItems = [{ id: 6, name: 'Dark subgroup', description: 'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.', image: 'static/images/cards/6.jpg', isGroup: true }, { id: 7, name: 'Light subgroup', description: 'Donec fringilla. Donec feugiat metus sit amet ante. Vivamus non.', image: 'static/images/cards/7.jpg', isGroup: true }, { id: 8, name: 'Gold Item', description: 'Cras convallis convallis dolor. Quisque tincidunt pede ac urna.', image: 'static/images/cards/8.jpg', isGroup: false }, { id: 9, name: 'Silver Item', description: 'Curabitur ut odio vel est tempor bibendum. Quisque ac libero nec ligula consectetuer rhoncus.', image: 'static/images/cards/9.jpg', isGroup: false }, { id: 10, name: 'Bronze Item', description: 'Maecenas ornare egestas ligula. Vivamus nibh dolor, nonummy ac, feugiat non, lobortis quis, pede.', image: 'static/images/cards/10.jpg', isGroup: false }];

var darkSubgroupItems = [{ id: 11, name: 'Black Item', description: 'Aliquam erat volutpat. Nulla dignissim. Maecenas ornare egestas ligula.', image: 'static/images/cards/11.jpg', isGroup: false }, { id: 12, name: 'Brown Item', description: 'Maecenas ornare egestas ligula. Nullam feugiat placerat.', image: 'static/images/cards/12.jpg', isGroup: false }];

var lightSubgroupItems = [{ id: 13, name: 'Yellow Item', description: 'Nunc mauris elit, dictum eu, eleifend nec, malesuada ut.', image: 'static/images/cards/13.jpg', isGroup: false }, { id: 14, name: 'Orange Item', description: 'Quisque imperdiet, erat nonummy ultricies ornare, elit elit fermentum risus.', image: 'static/images/cards/14.jpg', isGroup: false }];

/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var matches = url.match(/^\/api\/catalog\/getItems\/(\d+)/);
            if (matches.length === 2) {
                var id = matches[1];
                var result = rootItems;
                switch (id) {
                    case '1':
                        result = groupItems;
                        break;
                    case '6':
                        result = darkSubgroupItems;
                        break;
                    case '7':
                        result = lightSubgroupItems;
                        break;
                }

                resolve({
                    body: result
                });
                return;
            }
            reject();
        });
    }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    post: function post(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var errors = [];

            if (data.title === null || data.title === '') {
                errors.push({
                    property: 'Title',
                    message: 'MESSAGE__TODO__TITLE_REQUIRED'
                });
            }

            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            var maxId = 0;
            for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos.length; i++) {
                if (__WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos[i].id >= maxId) {
                    maxId = __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos[i].id + 1;
                }
            }

            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos.push({
                id: maxId,
                title: data.title,
                done: data.done
            });

            __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();

            resolve({
                body: {
                    id: maxId,
                    title: data.title,
                    done: data.done
                }
            });
        });
    }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    delete: function _delete(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var matches = url.match(/^\/api\/todo\/(\d+)/);
            if (matches.length === 2) {
                var id = matches[1];
                var index = -1;
                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos.length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos[i].id === +id) {
                        index = i;
                    }
                }

                if (index >= 0) {
                    __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos.splice(index, 1);
                    __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();
                    resolve({ body: {} });
                }
            }
            reject();
        });
    }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(url) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve({
                body: __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos.slice()
            });
        });
    }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__db__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
    put: function put(url, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var errors = [];

            if (data.title === null || data.title === '') {
                errors.push({
                    property: 'Title',
                    message: 'MESSAGE__TODO__TITLE_REQUIRED'
                });
            }

            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            var matches = url.match(/^\/api\/todo\/(\d+)/);
            if (matches.length === 2) {
                var id = matches[1];

                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos.length; i++) {
                    var item = __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].todos[i];
                    if (item.id === +id) {
                        item.title = data.title;
                        item.done = data.done;
                        __WEBPACK_IMPORTED_MODULE_1__db__["a" /* default */].save();

                        resolve({
                            body: {
                                id: item.id,
                                title: item.title,
                                done: item.done
                            }
                        });
                        return;
                    }
                }
            }
            reject();
        });
    }
});

/***/ }),
/* 476 */,
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(499),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */,
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_constants__ = __webpack_require__(61);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SignInView',
    components: {
        ThePageExternal: __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue___default.a,
        BaseText: __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue___default.a,
        BaseButton: __WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        email: function email(s) {
            return s.signin.email;
        },
        password: function password(s) {
            return s.signin.password;
        },
        errors: function errors(s) {
            return s.signin.errors;
        }
    }), {
        appName: function appName() {
            return __WEBPACK_IMPORTED_MODULE_6__store_constants__["a" /* default */].appName;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        signin: 'signin/signin',
        openForgotPassword: 'signin/openForgotPassword',
        openSignUp: 'signin/openSignUp',

        setEmail: 'signin/setEmail',
        setPassword: 'signin/setPassword'
    }))
});

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TheLogo_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TheLogo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TheLogo_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ThePageExternal',
    components: {
        TheLogo: __WEBPACK_IMPORTED_MODULE_0__TheLogo_vue___default.a
    },
    props: {
        title: {
            type: String
        },

        className: {
            type: String
        }
    }
});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_constants__ = __webpack_require__(61);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TheLogo',
    computed: {
        appFirstWord: function appFirstWord() {
            return __WEBPACK_IMPORTED_MODULE_0__store_constants__["a" /* default */].appFirstWord;
        },
        appSecondWord: function appSecondWord() {
            return __WEBPACK_IMPORTED_MODULE_0__store_constants__["a" /* default */].appSecondWord;
        }
    }
});

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheLogo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TheLogo__title"
  }, [_vm._v("\n        " + _vm._s(_vm.appFirstWord)), _c('span', {
    staticClass: "TheLogo__color"
  }, [_vm._v(_vm._s(_vm.appSecondWord))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheLogo__icon"
  }, [_c('img', {
    staticClass: "TheLogo__image",
    attrs: {
      "src": "static/images/icons/android-icon-144x144.png"
    }
  })])
}]}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ThePageExternal', _vm.className]
  }, [_c('div', {
    staticClass: "ThePageExternal__header"
  }, [_c('TheLogo'), _vm._v(" "), _c('div', {
    staticClass: "ThePageExternal__title"
  }, [_vm._v("\n            " + _vm._s(_vm.translate(_vm.title)) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ThePageExternal__content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseText',
    components: {
        BaseErrors: __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default.a
    },
    props: {
        label: {
            type: String
        },

        value: {
            type: String
        },

        errors: {
            type: Array
        },

        autofocus: {
            type: Boolean
        },

        password: {
            type: Boolean
        },

        className: {
            type: String
        },

        icon: {
            type: String
        }
    },
    methods: {
        change: function change(e) {
            this.$emit('change', e);
        },
        enter: function enter() {
            this.$emit('enter');
        }

    }
});

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseErrors',
    props: {
        errors: {
            type: Array
        }
    }
});

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseErrors"
  }, _vm._l((_vm.errors), function(error) {
    return _c('div', {
      staticClass: "BaseErrors__item"
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseText__container', _vm.className]
  }, [(_vm.icon) ? _c('i', {
    class: ['BaseText__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BaseText",
    class: {
      'BaseText_error': (_vm.errors && _vm.errors.length > 0)
    }
  }, [_c('input', {
    staticClass: "BaseText__input",
    attrs: {
      "type": _vm.password ? 'password' : 'text',
      "required": "",
      "autofocus": _vm.autofocus ? true : false
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "BaseText__bar"
  }), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseText__label"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))])
}]}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseButton',
    props: {
        label: {
            type: String,
            required: true
        },

        accent: {
            type: Boolean
        },

        className: {
            type: String
        }
    },
    methods: {
        click: function click(e) {
            this.$emit('click', e);
        }
    }
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseButton', _vm.className, _vm.accent ? 'BaseButton_accent' : ''],
    on: {
      "click": function($event) {
        _vm.click($event.target)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translate(_vm.label)) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseButtonFlat',
    props: {
        label: {
            type: String,
            required: true
        },

        accent: {
            type: Boolean
        },

        className: {
            type: String
        }
    },
    methods: {
        click: function click(e) {
            this.$emit('click', e);
        }
    }
});

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseButtonFlat', _vm.className, _vm.accent ? 'BaseButtonFlat_accent' : ''],
    on: {
      "click": function($event) {
        _vm.click($event.target)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translate(_vm.label)) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePageExternal', {
    attrs: {
      "title": 'SIGNIN__TITLE',
      "className": 'SignInView'
    }
  }, [_c('BaseText', {
    attrs: {
      "label": 'SIGNIN__EMAIL',
      "value": _vm.email,
      "errors": _vm.errors['email'],
      "autofocus": true,
      "icon": 'icon-mail'
    },
    on: {
      "change": function($event) {
        _vm.setEmail($event.target.value)
      },
      "enter": function($event) {
        _vm.signin()
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNIN__PASSWORD',
      "value": _vm.password,
      "errors": _vm.errors['password'],
      "icon": 'icon-lock',
      "password": true
    },
    on: {
      "change": function($event) {
        _vm.setPassword($event.target.value)
      },
      "enter": function($event) {
        _vm.signin()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "SignInView__actions"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'SIGNIN__FORGOT_PASSWORD',
      "class-name": 'SignInView__forgot-password'
    },
    on: {
      "click": function($event) {
        _vm.openForgotPassword()
      }
    }
  }), _vm._v(" "), _c('BaseButtonFlat', {
    attrs: {
      "label": 'SIGNIN__NEED_ACCOUNT',
      "class-name": 'SignInView__need-account'
    },
    on: {
      "click": function($event) {
        _vm.openSignUp()
      }
    }
  })], 1), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'SIGNIN__SIGN_IN'
    },
    on: {
      "click": function($event) {
        _vm.signin($event.target)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "SignInView__bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.appName) + " " + _vm._s((new Date()).getFullYear()) + "\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseDropdown_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseDropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_BaseDropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_BaseCheckbox_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_BaseCheckbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_BaseCheckbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_BaseButton_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_BaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_BaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_BaseButtonFlat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_constants__ = __webpack_require__(61);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SignUpView',
    components: {
        ThePageExternal: __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue___default.a,
        BaseText: __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue___default.a,
        BaseDropdown: __WEBPACK_IMPORTED_MODULE_4__components_common_BaseDropdown_vue___default.a,
        BaseCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_common_BaseCheckbox_vue___default.a,
        BaseButton: __WEBPACK_IMPORTED_MODULE_6__components_common_BaseButton_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_7__components_common_BaseButtonFlat_vue___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.load();
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        isEmailConfirmationPending: function isEmailConfirmationPending(s) {
            return s.signup.isEmailConfirmationPending;
        },
        email: function email(s) {
            return s.signup.email;
        },
        password: function password(s) {
            return s.signup.password;
        },
        confirmPassword: function confirmPassword(s) {
            return s.signup.confirmPassword;
        },
        name: function name(s) {
            return s.signup.name;
        },
        company: function company(s) {
            return s.signup.company;
        },
        timezone: function timezone(s) {
            return s.signup.timezone;
        },
        termsAccepted: function termsAccepted(s) {
            return s.signup.termsAccepted;
        },
        errors: function errors(s) {
            return s.signup.errors;
        },
        termsLink: function termsLink(s) {
            return 'https://example.com/terms';
        }
    }), {
        timezones: function timezones() {
            return __WEBPACK_IMPORTED_MODULE_8__store_constants__["a" /* default */].timezones;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        load: 'signup/load',
        openSignIn: 'signup/openSignIn',
        signup: 'signup/signup',

        setEmail: 'signup/setEmail',
        setPassword: 'signup/setPassword',
        setConfirmPassword: 'signup/setConfirmPassword',
        setName: 'signup/setName',
        setCompany: 'signup/setCompany',
        setTimezone: 'signup/setTimezone',
        setTermsAccepted: 'signup/setTermsAccepted'
    }))
});

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseDropdown',
    components: {
        BaseErrors: __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default.a
    },
    props: {
        label: {
            type: String,
            required: true
        },

        value: {
            type: String
        },

        items: {
            type: Array,
            required: true
        },

        errors: {
            type: Array
        },

        className: {
            type: String
        },

        icon: {
            type: String
        }
    },
    methods: {
        change: function change(e) {
            this.$emit('change', e);
        }
    }
});

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseDropdown__container', _vm.className]
  }, [(_vm.icon) ? _c('i', {
    class: ['BaseDropdown__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BaseDropdown",
    class: {
      'BaseDropdown_error': (_vm.errors && _vm.errors.length > 0)
    }
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    staticClass: "BaseDropdown__select",
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      }
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('option', {
      key: item.id,
      staticClass: "BaseDropdown__option",
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n                " + _vm._s(_vm.translate(item.name)) + "\n            ")])
  })), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseDropdown__label"
  }, [_vm._v("\n            " + _vm._s(_vm.translate(_vm.label)) + "\n        ")])
}]}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseCheckbox',
    components: {
        BaseErrors: __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default.a
    },
    props: {
        label: {
            type: String,
            required: true
        },

        value: {
            type: Boolean,
            required: true
        },

        fieldName: {
            type: String,
            required: true
        },

        errors: {
            type: Array
        },

        className: {
            type: String
        },

        linkLabel: {
            type: String
        },

        link: {
            type: String
        }
    },
    methods: {
        change: function change(e) {
            this.$emit('change', e);
        }
    }
});

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.className]
  }, [_c('div', {
    staticClass: "BaseCheckbox",
    class: {
      'BaseCheckbox_error': (_vm.errors && _vm.errors.length > 0)
    }
  }, [_c('input', {
    attrs: {
      "id": _vm.fieldName,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.fieldName
    }
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))]), _vm._v(" "), (_vm.link) ? _c('a', {
    staticClass: "BaseCheckbox__link",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.translate(_vm.linkLabel)))]) : _vm._e()]), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePageExternal', {
    attrs: {
      "title": 'SIGNUP__NEW_ACCOUNT',
      "class-name": 'SignUpView'
    }
  }, [(_vm.isEmailConfirmationPending) ? [_c('div', {
    staticClass: "SignUpView__account-created"
  }, [_vm._v("\n            " + _vm._s(_vm.translate('SIGNUP__ACCOUNT_CREATED')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__email-activity"
  }, [_c('div', {
    staticClass: "SignUpView__email-activity_content"
  }), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__email-activity-icon-container"
  }, [_c('i', {
    staticClass: "icon-mail SignUpView__email-activity-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__waiting-confirmation"
  }, [_vm._v("\n            " + _vm._s(_vm.translate('SIGNUP__WAITING_FOR_EMAIL_CONFIRMAITON')) + " "), _c('span', {
    staticClass: "SignUpView__waiting-confirmation-email"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v("...\n        ")])] : [_c('div', {
    staticClass: "SignUpView__content"
  }, [_c('div', {
    staticClass: "SignUpView__column"
  }, [_c('BaseText', {
    attrs: {
      "label": 'SIGNUP__EMAIL',
      "value": _vm.email,
      "errors": _vm.errors['email'],
      "autofocus": true,
      "icon": 'icon-mail'
    },
    on: {
      "change": function($event) {
        _vm.setEmail($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNUP__PASSWORD',
      "value": _vm.password,
      "errors": _vm.errors['password'],
      "icon": 'icon-lock',
      "password": true
    },
    on: {
      "change": function($event) {
        _vm.setPassword($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNUP__CONFIRM_PASSWORD',
      "value": _vm.confirmPassword,
      "errors": _vm.errors['confirmPassword'],
      "icon": 'icon-cw-1',
      "password": true
    },
    on: {
      "change": function($event) {
        _vm.setConfirmPassword($event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__column"
  }, [_c('BaseText', {
    attrs: {
      "label": 'SIGNUP__NAME',
      "value": _vm.name,
      "errors": _vm.errors['name'],
      "icon": 'icon-child'
    },
    on: {
      "change": function($event) {
        _vm.setName($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNUP__COMPANY_NAME',
      "value": _vm.company,
      "errors": _vm.errors['company'],
      "icon": 'icon-bank'
    },
    on: {
      "change": function($event) {
        _vm.setCompany($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseDropdown', {
    attrs: {
      "label": 'SIGNUP__TIMEZONE',
      "value": _vm.timezone,
      "items": _vm.timezones,
      "errors": _vm.errors['timezone'],
      "icon": 'icon-clock'
    },
    on: {
      "change": function($event) {
        _vm.setTimezone($event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__terms"
  }, [_c('BaseCheckbox', {
    attrs: {
      "label": 'SIGNUP__I_AGREE_TO',
      "value": _vm.termsAccepted,
      "field-name": 'termsAccepted',
      "errors": _vm.errors['termsAccepted'],
      "link": _vm.termsLink,
      "link-label": 'SIGNUP__TO_TERMS_AND_CONDITIONS'
    },
    on: {
      "change": function($event) {
        _vm.setTermsAccepted($event.target.checked)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__actions"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'SIGNUP__TO_SIGN_IN',
      "class-name": 'SignUpView__signin'
    },
    on: {
      "click": function($event) {
        _vm.openSignIn()
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'SIGNUP__SIGN_UP'
    },
    on: {
      "click": function($event) {
        _vm.signup($event.target)
      }
    }
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ForgotPasswordView',
    components: {
        ThePageExternal: __WEBPACK_IMPORTED_MODULE_2__components_common_ThePageExternal_vue___default.a,
        BaseText: __WEBPACK_IMPORTED_MODULE_3__components_common_BaseText_vue___default.a,
        BaseButton: __WEBPACK_IMPORTED_MODULE_4__components_common_BaseButton_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_5__components_common_BaseButtonFlat_vue___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.load();
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        completedSuccessfully: function completedSuccessfully(s) {
            return s.forgotPassword.completedSuccessfully;
        },
        email: function email(s) {
            return s.forgotPassword.email;
        },
        errors: function errors(s) {
            return s.forgotPassword.errors;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        load: 'forgotPassword/load',
        openSignIn: 'forgotPassword/openSignIn',
        send: 'forgotPassword/send',

        setEmail: 'forgotPassword/setEmail'
    }))
});

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePageExternal', {
    attrs: {
      "title": 'FORGOT_PASSWORD__RESET_PASSWORD',
      "class-name": 'ForgotPasswordView'
    }
  }, [(_vm.completedSuccessfully) ? [_c('div', {
    staticClass: "ForgotPasswordView__text"
  }, [_vm._v("\n            " + _vm._s(_vm.translate('FORGOT_PASSWORD__EMAIL_WAS_SENT')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ForgotPasswordView__actions"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'FORGOT_PASSWORD__BACK_TO_SIGN_IN',
      "class-name": 'ForgotPasswordView__signin'
    },
    on: {
      "click": function($event) {
        _vm.openSignIn()
      }
    }
  })], 1)] : [_c('div', {
    staticClass: "ForgotPasswordView__text"
  }, [_vm._v("\n            " + _vm._s(_vm.translate('FORGOT_PASSWORD__ENTER_EMAIL')) + "\n        ")]), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'FORGOT_PASSWORD__EMAIL',
      "value": _vm.email,
      "errors": _vm.errors['email'],
      "autofocus": true,
      "icon": 'icon-mail'
    },
    on: {
      "change": function($event) {
        _vm.setEmail($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ForgotPasswordView__actions"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'FORGOT_PASSWORD__BACK_TO_SIGN_IN',
      "class-name": 'ForgotPasswordView__signin'
    },
    on: {
      "click": function($event) {
        _vm.openSignIn()
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'FORGOT_PASSWORD__SEND'
    },
    on: {
      "click": function($event) {
        _vm.send($event.target)
      }
    }
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_TheLogo_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_TheLogo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_TheLogo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseNavigationButton_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseNavigationButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_BaseNavigationButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_DashboardItem_vue__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_DashboardItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dashboard_DashboardItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dashboard_FormModal_vue__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dashboard_FormModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dashboard_FormModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dashboard_ConfigurationModal_vue__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dashboard_ConfigurationModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dashboard_ConfigurationModal_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DashboardView',
    components: {
        ThePage: __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default.a,
        TheLogo: __WEBPACK_IMPORTED_MODULE_3__components_common_TheLogo_vue___default.a,
        BaseNavigationButton: __WEBPACK_IMPORTED_MODULE_4__components_common_BaseNavigationButton_vue___default.a,
        DashboardItem: __WEBPACK_IMPORTED_MODULE_5__components_dashboard_DashboardItem_vue___default.a,
        FormModal: __WEBPACK_IMPORTED_MODULE_6__components_dashboard_FormModal_vue___default.a,
        ConfigurationModal: __WEBPACK_IMPORTED_MODULE_7__components_dashboard_ConfigurationModal_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        formVisible: function formVisible(s) {
            return s.form.visible;
        },
        configurationVisible: function configurationVisible(s) {
            return s.configuration.visible;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        openConfiguration: 'configuration/open',
        openList: 'dashboard/openList',
        openForm: 'form/open',
        openTable: 'dashboard/openTable',
        openCatalog: 'dashboard/openCatalog'
    }))
});

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ThePage',
    props: {
        title: {
            type: String
        },

        className: {
            type: String
        }
    }
});

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ThePage', _vm.className]
  }, [_c('div', {
    staticClass: "ThePage__header"
  }, [_vm._t("left-action"), _vm._v(" "), _c('div', {
    staticClass: "ThePage__header-title"
  }, [_vm._v("\n            " + _vm._s(_vm.translate(_vm.title)) + "\n        ")]), _vm._v(" "), _vm._t("right-action")], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "ThePage__bottom-color"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseNavigationButton',
    props: {
        label: {
            type: String
        },

        icon: {
            type: String
        },

        className: {
            type: String
        }
    },
    methods: {
        click: function click(e) {
            this.$emit('click', e);
        }
    }
});

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseNavigationButton', _vm.className],
    on: {
      "click": function($event) {
        _vm.click($event.target)
      }
    }
  }, [(_vm.icon) ? _c('i', {
    class: [_vm.icon]
  }) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', {
    staticClass: "BaseNavigationButton__text"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DashboardItem',
    props: {
        name: {
            type: String,
            required: true
        },

        icon: {
            type: String,
            required: true
        }
    },
    methods: {
        click: function click(e) {
            this.$emit('click', e);
        }
    }
});

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DashboardItem__icon-right"
  }, [_c('i', {
    staticClass: "icon-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DashboardItem",
    on: {
      "click": function($event) {
        _vm.click($event.target)
      }
    }
  }, [_c('div', {
    staticClass: "DashboardItem__icon"
  }, [_c('i', {
    class: [_vm.icon]
  })]), _vm._v(" "), _c('div', {
    staticClass: "DashboardItem__header"
  }, [_vm._v(_vm._s(_vm.translate(_vm.name)))]), _vm._v(" "), _vm._m(0)])
}]}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseTabs_vue__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseTabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BaseTabs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BaseLabel_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BaseLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BaseLabel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BaseText_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BaseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BaseText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BaseTextarea_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BaseTextarea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_BaseTextarea_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BaseCheckbox_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BaseCheckbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BaseCheckbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BaseDropdown_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BaseDropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_BaseDropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BaseRadio_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BaseRadio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_BaseRadio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BaseSegmented_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BaseSegmented_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_BaseSegmented_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BaseDateTime_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BaseDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_BaseDateTime_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FormModal',
    components: {
        BaseModal: __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue___default.a,
        BaseTabs: __WEBPACK_IMPORTED_MODULE_3__common_BaseTabs_vue___default.a,
        BaseLabel: __WEBPACK_IMPORTED_MODULE_4__common_BaseLabel_vue___default.a,
        BaseText: __WEBPACK_IMPORTED_MODULE_5__common_BaseText_vue___default.a,
        BaseTextarea: __WEBPACK_IMPORTED_MODULE_6__common_BaseTextarea_vue___default.a,
        BaseCheckbox: __WEBPACK_IMPORTED_MODULE_7__common_BaseCheckbox_vue___default.a,
        BaseDropdown: __WEBPACK_IMPORTED_MODULE_8__common_BaseDropdown_vue___default.a,
        BaseRadio: __WEBPACK_IMPORTED_MODULE_9__common_BaseRadio_vue___default.a,
        BaseSegmented: __WEBPACK_IMPORTED_MODULE_10__common_BaseSegmented_vue___default.a,
        BaseDateTime: __WEBPACK_IMPORTED_MODULE_11__common_BaseDateTime_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        selectedTab: function selectedTab(s) {
            return s.form.selectedTab;
        },
        tabs: function tabs(s) {
            return s.form.tabs;
        },
        textValue: function textValue(s) {
            return s.form.textValue;
        },
        textareaValue: function textareaValue(s) {
            return s.form.textareaValue;
        },
        checkboxValue: function checkboxValue(s) {
            return s.form.checkboxValue;
        },
        dropdownValue: function dropdownValue(s) {
            return s.form.dropdownValue;
        },
        dropdownItems: function dropdownItems(s) {
            return s.form.dropdownItems;
        },
        radioValue: function radioValue(s) {
            return s.form.radioValue;
        },
        radioItems: function radioItems(s) {
            return s.form.radioItems;
        },
        segmentedValue: function segmentedValue(s) {
            return s.form.segmentedValue;
        },
        segmentedItems: function segmentedItems(s) {
            return s.form.segmentedItems;
        },
        dateString: function dateString(s) {
            return s.form.dateString;
        },
        dateTimeString: function dateTimeString(s) {
            return s.form.dateTimeString;
        },
        errors: function errors(s) {
            return s.form.errors;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        close: 'form/close',
        save: 'form/save',

        setSelectedTab: 'form/setSelectedTab',
        setTextValue: 'form/setTextValue',
        setTextareaValue: 'form/setTextareaValue',
        setCheckboxValue: 'form/setCheckboxValue',
        setDropdownValue: 'form/setDropdownValue',
        setRadioValue: 'form/setRadioValue',
        setSegmentedValue: 'form/setSegmentedValue',
        setDateString: 'form/setDateString',
        setDateTimeString: 'form/setDateTimeString'
    }), __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */]({
        getStateString: 'form/getStateString'
    }))
});

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseButton_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BaseButtonFlat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseNavigationButton_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseNavigationButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaseNavigationButton_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseModal',
    components: {
        BaseButton: __WEBPACK_IMPORTED_MODULE_0__BaseButton_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_1__BaseButtonFlat_vue___default.a,
        BaseNavigationButton: __WEBPACK_IMPORTED_MODULE_2__BaseNavigationButton_vue___default.a
    },
    props: {
        title: {
            type: String
        },

        className: {
            type: String
        }
    },
    methods: {
        close: function close(e) {
            this.$emit('close', e);
        },
        save: function save(e) {
            this.$emit('save', e);
        }
    }
});

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseModal__mask"
  }, [_c('div', {
    class: ['BaseModal', _vm.className]
  }, [_c('div', {
    staticClass: "BaseModal__header"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "class-name": 'BaseModal__header-close',
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.close($event.target)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "BaseModal__header-title"
  }, [_vm._v("\n                " + _vm._s(_vm.translate(_vm.title)) + "\n            ")]), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__SAVE',
      "class-name": 'BaseModal__header-save',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.save($event.target)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "BaseModal__body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "BaseModal__bottom"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'COMMON__CLOSE',
      "class-name": 'BaseModal__close'
    },
    on: {
      "click": function($event) {
        _vm.close($event.target)
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__SAVE',
      "class-name": 'BaseModal__save',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.save($event.target)
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseTabs',
    props: {
        value: {},

        items: {
            type: Array,
            required: true
        },

        className: {
            type: String
        }
    },
    methods: {
        change: function change(e) {
            this.$emit('change', e);
        }
    }
});

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseTabs', _vm.className]
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.id,
      class: ['BaseTabs__item', item.id == _vm.value ? 'BaseTabs__item_selected' : ''],
      on: {
        "click": function($event) {
          _vm.change(item.id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.translate(item.name)) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseLabel',
    props: {
        text: {
            type: String,
            required: true
        }
    }
});

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseLabel"
  }, [_vm._v(_vm._s(_vm.translate(_vm.text)))])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseTextarea',
    components: {
        BaseErrors: __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default.a
    },
    props: {
        label: {
            type: String
        },

        value: {
            type: String
        },

        errors: {
            type: Array
        },

        autofocus: {
            type: Boolean
        },

        rows: {
            type: Number
        },

        className: {
            type: String
        },

        icon: {
            type: String
        }
    },
    methods: {
        change: function change(e) {
            this.$emit('change', e);
        }
    }
});

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseTextarea__container', _vm.className]
  }, [(_vm.icon) ? _c('i', {
    class: ['BaseTextarea__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BaseTextarea",
    class: {
      'BaseTextarea_error': (_vm.errors && _vm.errors.length > 0)
    }
  }, [_c('textarea', {
    staticClass: "BaseTextarea__input",
    attrs: {
      "type": "text",
      "required": "",
      "autofocus": _vm.autofocus ? true : false,
      "rows": _vm.rows
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "BaseTextarea__bar"
  }), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseTextarea__label_after"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseRadio',
    components: {
        BaseErrors: __WEBPACK_IMPORTED_MODULE_0__BaseErrors_vue___default.a
    },
    props: {
        label: {
            type: String,
            required: true
        },

        value: {
            type: String
        },

        items: {
            type: Array,
            required: true
        },

        errors: {
            type: Array
        },

        fieldName: {
            type: String
        },

        className: {
            type: String
        },

        icon: {
            type: String
        }
    },
    methods: {
        change: function change(e) {
            this.$emit('change', e);
        }
    }
});

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseRadio', _vm.className]
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "BaseRadio__item"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": 'radio' + _vm.fieldName + '_' + index,
        "name": 'radio' + _vm.fieldName
      },
      domProps: {
        "value": item.id,
        "checked": _vm.value == item.id
      },
      on: {
        "change": function($event) {
          _vm.change($event)
        }
      }
    }), _vm._v(" "), _vm._o(_c('label', {
      staticClass: "BaseRadio__item-label",
      attrs: {
        "for": 'radio' + _vm.fieldName + '_' + index
      }
    }, [_vm._v(_vm._s(_vm.translate(item.name)))]), 0, item.id)])
  }), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseRadio__label"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))])
}]}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseSegmented',
    props: {
        value: {},

        items: {
            type: Array,
            required: true
        },

        className: {
            type: String
        }
    },
    methods: {
        change: function change(e) {
            this.$emit('change', e);
        }
    }
});

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseSegmented', _vm.className]
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.id,
      class: ['BaseSegmented__item', item.id == _vm.value ? 'BaseSegmented__item_selected' : ''],
      on: {
        "click": function($event) {
          _vm.change(item.id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.translate(item.name)) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseText_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaseText_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseDateTime',
    components: {
        BaseText: __WEBPACK_IMPORTED_MODULE_2__BaseText_vue___default.a
    },
    props: {
        label: {
            type: String
        },

        showTime: {
            type: Boolean
        },

        dateString: {
            type: String
        },

        title: {
            type: String
        },

        handlerAction: {
            type: String
        },

        handlerActionParams: {},

        errors: {
            type: Array
        },

        className: {
            type: String
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        open: 'dateTimePicker/open'
    }), {
        change: function change(e) {
            this.$emit('change', e);
        }
    })
});

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseDateTime', _vm.className]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "BaseDateTime__date"
  }, [_c('i', {
    staticClass: "BaseDateTime__icon icon-calendar",
    on: {
      "click": function($event) {
        _vm.open({
          dateString: _vm.dateString,
          title: _vm.title,
          handlerAction: _vm.handlerAction,
          handlerActionParams: _vm.handlerActionParams,
          showTime: _vm.showTime
        })
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "value": _vm.dateString,
      "errors": _vm.errors,
      "class-name": 'BaseDateTime__text'
    },
    on: {
      "change": _vm.change
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseDateTime__label"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))])
}]}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseModal', {
    attrs: {
      "class-name": 'FormModal',
      "title": 'FORM__FORM'
    },
    on: {
      "save": _vm.save,
      "close": _vm.close
    }
  }, [_c('BaseTabs', {
    attrs: {
      "value": _vm.selectedTab,
      "items": _vm.tabs
    },
    on: {
      "change": _vm.setSelectedTab
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "FormModal__body"
  }, [(_vm.selectedTab === 1) ? [_c('div', {
    staticClass: "FormModal__columns"
  }, [_c('div', {
    staticClass: "FormModal__column"
  }, [_c('BaseText', {
    attrs: {
      "label": 'FORM__TEXT',
      "value": _vm.textValue,
      "errors": _vm.errors['textValue']
    },
    on: {
      "change": function($event) {
        _vm.setTextValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseTextarea', {
    attrs: {
      "label": 'FORM__TEXTAREA',
      "value": _vm.textareaValue,
      "errors": _vm.errors['textareaValue'],
      "rows": 3
    },
    on: {
      "change": function($event) {
        _vm.setTextareaValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseCheckbox', {
    attrs: {
      "label": 'FORM__CHECKBOX',
      "value": _vm.checkboxValue,
      "field-name": 'checkboxValue',
      "errors": _vm.errors['checkboxValue']
    },
    on: {
      "change": function($event) {
        _vm.setCheckboxValue($event.target.checked)
      }
    }
  }), _vm._v(" "), _c('BaseDropdown', {
    attrs: {
      "label": 'FORM__DROPDOWN',
      "value": _vm.dropdownValue,
      "items": _vm.dropdownItems,
      "errors": _vm.errors['dropdownValue']
    },
    on: {
      "change": function($event) {
        _vm.setDropdownValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseRadio', {
    attrs: {
      "label": 'FORM__RADIO_BUTTONS',
      "value": _vm.radioValue,
      "items": _vm.radioItems,
      "errors": _vm.errors['radioValue'],
      "field-name": 'radioValue'
    },
    on: {
      "change": function($event) {
        _vm.setRadioValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseLabel', {
    attrs: {
      "text": 'FORM__SEGMENTED_CONTROL'
    }
  }), _vm._v(" "), _c('BaseSegmented', {
    attrs: {
      "value": _vm.segmentedValue,
      "items": _vm.segmentedItems
    },
    on: {
      "change": _vm.setSegmentedValue
    }
  }), _vm._v(" "), _c('BaseDateTime', {
    attrs: {
      "label": 'FORM__DATE',
      "show-time": false,
      "date-string": _vm.dateString,
      "title": 'FORM__DATE',
      "handler-action": 'form/setDateString',
      "errors": _vm.errors['date']
    },
    on: {
      "change": function($event) {
        _vm.setDateString({
          dateString: $event.target.value
        })
      }
    }
  }), _vm._v(" "), _c('BaseDateTime', {
    attrs: {
      "label": 'FORM__DATE_AND_TIME',
      "show-time": true,
      "date-string": _vm.dateTimeString,
      "title": 'FORM__DATE_AND_TIME',
      "handler-action": 'form/setDateTimeString',
      "errors": _vm.errors['dateTime']
    },
    on: {
      "change": function($event) {
        _vm.setDateTimeString({
          dateString: $event.target.value
        })
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "FormModal__column"
  }, [_c('BaseLabel', {
    attrs: {
      "text": 'FORM__STATE'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "FormModal__state",
    domProps: {
      "innerHTML": _vm._s(_vm.getStateString())
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.selectedTab === 2) ? [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n        ")] : _vm._e(), _vm._v(" "), (_vm.selectedTab === 3) ? [_vm._v("\n            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.\n        ")] : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(557)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseLabel_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BaseLabel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BaseSegmented_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BaseSegmented_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BaseSegmented_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BaseDropdown_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BaseDropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BaseDropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_BaseButtonFlat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_constants__ = __webpack_require__(61);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ConfigurationModal',
    components: {
        BaseModal: __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue___default.a,
        BaseLabel: __WEBPACK_IMPORTED_MODULE_3__common_BaseLabel_vue___default.a,
        BaseSegmented: __WEBPACK_IMPORTED_MODULE_4__common_BaseSegmented_vue___default.a,
        BaseDropdown: __WEBPACK_IMPORTED_MODULE_5__common_BaseDropdown_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_6__common_BaseButtonFlat_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        timezone: function timezone(s) {
            return s.configuration.timezone;
        },
        culture: function culture(s) {
            return s.configuration.culture;
        },
        errors: function errors(s) {
            return s.configuration.errors;
        }
    }), {
        timezones: function timezones() {
            return __WEBPACK_IMPORTED_MODULE_7__store_constants__["a" /* default */].timezones;
        },
        cultures: function cultures() {
            return __WEBPACK_IMPORTED_MODULE_7__store_constants__["a" /* default */].cultures;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        close: 'configuration/close',
        save: 'configuration/save',
        confirmSignout: 'configuration/confirmSignout',
        setCulture: 'configuration/setCulture',
        setTimezone: 'configuration/setTimezone'
    }))
});

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseModal', {
    attrs: {
      "class-name": 'ConfigurationModal',
      "title": 'CONFIGURATION__CONFIGURATION'
    },
    on: {
      "save": _vm.save,
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "ConfigurationModal__signout-container"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'CONFIGURATION__SIGN_OUT',
      "class-name": 'ConfigurationModal__signout'
    },
    on: {
      "click": function($event) {
        _vm.confirmSignout()
      }
    }
  })], 1), _vm._v(" "), _c('BaseDropdown', {
    attrs: {
      "label": 'CONFIGURATION__TIMEZONE',
      "value": _vm.timezone,
      "items": _vm.timezones,
      "errors": _vm.errors['timezone']
    },
    on: {
      "change": function($event) {
        _vm.setTimezone($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseLabel', {
    attrs: {
      "text": 'CONFIGURATION__LANGUAGE'
    }
  }), _vm._v(" "), _c('BaseSegmented', {
    attrs: {
      "value": _vm.culture,
      "items": _vm.cultures
    },
    on: {
      "change": _vm.setCulture
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DashboardView__container"
  }, [_c('ThePage', {
    attrs: {
      "class-name": 'DashboardView'
    }
  }, [_c('template', {
    slot: "left-action"
  }, [_c('TheLogo')], 1), _vm._v(" "), _c('template', {
    slot: "right-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "label": 'DASHBOARD__CONFIGURATION',
      "icon": 'icon-cog'
    },
    on: {
      "click": _vm.openConfiguration
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "DashboardView__body"
  }, [_c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__LIST',
      "icon": 'icon-th-list'
    },
    on: {
      "click": _vm.openList
    }
  }), _vm._v(" "), _c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__FORM',
      "icon": 'icon-ok-squared'
    },
    on: {
      "click": _vm.openForm
    }
  }), _vm._v(" "), _c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__TABLE',
      "icon": 'icon-table'
    },
    on: {
      "click": _vm.openTable
    }
  }), _vm._v(" "), _c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__CATALOG',
      "icon": 'icon-th'
    },
    on: {
      "click": _vm.openCatalog
    }
  })], 1)], 2), _vm._v(" "), (_vm.formVisible) ? _c('FormModal') : _vm._e(), _vm._v(" "), (_vm.configurationVisible) ? _c('ConfigurationModal') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(575),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_list_ListItem_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_list_ListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_list_ListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_list_ListItemModal_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_list_ListItemModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_list_ListItemModal_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ListView',
    components: {
        ThePage: __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default.a,
        BaseNavigationButton: __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue___default.a,
        BaseLoader: __WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue___default.a,
        ListItem: __WEBPACK_IMPORTED_MODULE_5__components_list_ListItem_vue___default.a,
        ListItemModal: __WEBPACK_IMPORTED_MODULE_6__components_list_ListItemModal_vue___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.getItems();
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        isLoaded: function isLoaded(s) {
            return s.list.isLoaded;
        },
        items: function items(s) {
            return s.list.items;
        },
        listItemVisible: function listItemVisible(s) {
            return s.listItem.visible;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        getItems: 'list/getItems',
        back: 'list/back',
        open: 'listItem/open'
    }))
});

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseLoader'
});

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseLoader"
  }, [_c('div', {
    staticClass: "BaseLoader_content"
  })])
}]}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(568)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(570),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ListItem',
    props: {
        name: {
            type: String,
            required: true
        },

        sex: {
            type: Number,
            required: true
        }
    },
    methods: {
        click: function click(e) {
            this.$emit('click', e);
        }
    }
});

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListItem",
    on: {
      "click": function($event) {
        _vm.click($event.target)
      }
    }
  }, [_c('div', {
    staticClass: "ListItem__icon"
  }, [_c('i', {
    class: [_vm.sex === 1 ? 'icon-male' : 'icon-female']
  })]), _vm._v(" "), _c('div', {
    staticClass: "ListItem__header"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListItem__icon-right"
  }, [_c('i', {
    staticClass: "icon-angle-right"
  })])
}]}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(574),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BaseButtonFlat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BaseText_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BaseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BaseText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BaseSegmented_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BaseSegmented_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BaseSegmented_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ListItemModal',
    components: {
        BaseModal: __WEBPACK_IMPORTED_MODULE_2__common_BaseModal_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_3__common_BaseButtonFlat_vue___default.a,
        BaseText: __WEBPACK_IMPORTED_MODULE_4__common_BaseText_vue___default.a,
        BaseSegmented: __WEBPACK_IMPORTED_MODULE_5__common_BaseSegmented_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        id: function id(s) {
            return s.listItem.id;
        },
        name: function name(s) {
            return s.listItem.name;
        },
        sex: function sex(s) {
            return s.listItem.sex;
        },
        sexes: function sexes(s) {
            return s.listItem.sexes;
        },
        errors: function errors(s) {
            return s.listItem.errors;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        close: 'listItem/close',
        save: 'listItem/save',
        confirmDeleteItem: 'listItem/confirmDeleteItem',

        setName: 'listItem/setName',
        setSex: 'listItem/setSex'
    }), __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */]({
        getStateString: 'form/getStateString'
    }))
});

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseModal', {
    attrs: {
      "class-name": 'ListItemModal',
      "title": _vm.id ? _vm.name : 'LIST__NEW_ITEM'
    },
    on: {
      "save": _vm.save,
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "ListItemModal__body"
  }, [(_vm.id) ? _c('div', {
    staticClass: "ListItemModal__delete-container"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'COMMON__DELETE',
      "class-name": 'ListItemModal__delete'
    },
    on: {
      "click": function($event) {
        _vm.confirmDeleteItem()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'LIST__NAME',
      "value": _vm.name,
      "errors": _vm.errors['name']
    },
    on: {
      "change": function($event) {
        _vm.setName($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseSegmented', {
    attrs: {
      "value": _vm.sex,
      "items": _vm.sexes
    },
    on: {
      "change": _vm.setSex
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListView__container"
  }, [_c('ThePage', {
    attrs: {
      "class-name": 'ListView',
      "title": 'LIST__LIST'
    }
  }, [_c('template', {
    slot: "left-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "right-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "label": 'LIST__ADD',
      "icon": 'icon-plus'
    },
    on: {
      "click": function($event) {
        _vm.open()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "ListView__body"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('ListItem', {
      key: item.id,
      attrs: {
        "name": item.name,
        "sex": item.sex
      },
      on: {
        "click": function($event) {
          _vm.open(item.id)
        }
      }
    })
  })), _vm._v(" "), _c('BaseLoader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoaded),
      expression: "!isLoaded"
    }]
  })], 2), _vm._v(" "), (_vm.listItemVisible) ? _c('ListItemModal') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(577)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(587),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_TheTableSearch_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_TheTableSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_table_TheTableSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_table_TheTablePaging_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_table_TheTablePaging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_table_TheTablePaging_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TableView',
    components: {
        ThePage: __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default.a,
        BaseNavigationButton: __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue___default.a,
        BaseLoader: __WEBPACK_IMPORTED_MODULE_4__components_common_BaseLoader_vue___default.a,
        TheTableSearch: __WEBPACK_IMPORTED_MODULE_5__components_table_TheTableSearch_vue___default.a,
        TheTablePaging: __WEBPACK_IMPORTED_MODULE_6__components_table_TheTablePaging_vue___default.a
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.open();
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        items: function items(s) {
            return s.table.items;
        },
        isLoaded: function isLoaded(s) {
            return s.table.isLoaded;
        },
        isAsc: function isAsc(s) {
            return s.table.order.charAt(0) !== '-';
        }
    }), __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */]({
        sortByColumn: 'table/sortByColumn'
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        open: 'table/open',
        setOrder: 'table/setOrder',
        back: 'table/back'
    }))
});

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(582),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseNavigationButton_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseNavigationButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BaseNavigationButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseText_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BaseText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BaseText_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TheTableSearch',
    components: {
        BaseNavigationButton: __WEBPACK_IMPORTED_MODULE_2__common_BaseNavigationButton_vue___default.a,
        BaseText: __WEBPACK_IMPORTED_MODULE_3__common_BaseText_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        filter: function filter(s) {
            return s.table.filter;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        setFilter: 'table/setFilter',
        search: 'table/search'
    }))
});

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheTableSearch"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "icon": 'icon-search',
      "class-name": 'TheTableSearch__search'
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'TABLE__SEARCH',
      "class-name": 'TheTableSearch__text',
      "value": _vm.filter
    },
    on: {
      "change": function($event) {
        _vm.setFilter($event.target.value)
      },
      "enter": function($event) {
        _vm.search()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(586),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TheTablePaging',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        start: function start(s) {
            return s.table.start;
        },
        end: function end(s) {
            return s.table.end;
        },
        canDecrease: function canDecrease(s) {
            return s.table.canDecrease;
        },
        canIncrease: function canIncrease(s) {
            return s.table.canIncrease;
        },
        totalCount: function totalCount(s) {
            return s.table.totalCount;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        previousPage: 'table/previousPage',
        nextPage: 'table/nextPage'
    }))
});

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheTablePaging"
  }, [_c('div', {
    staticClass: "TheTablePaging__pager"
  }, [(_vm.canDecrease) ? _c('i', {
    staticClass: "icon-left-open-1 TheTablePaging__button",
    on: {
      "click": _vm.previousPage
    }
  }) : _c('i', {
    staticClass: "icon-left-open-1 TheTablePaging__disabled"
  }), _vm._v(" "), _vm._v("\n        " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + "\n\n        "), _vm._v(" "), (_vm.canIncrease) ? _c('i', {
    staticClass: "icon-right-open-1 TheTablePaging__button",
    on: {
      "click": _vm.nextPage
    }
  }) : _c('i', {
    staticClass: "icon-right-open-1 TheTablePaging__disabled"
  })]), _vm._v(" "), _c('div', {
    staticClass: "TheTablePaging__count"
  }, [_vm._v(_vm._s(_vm.totalCount) + " "), _c('span', {
    staticClass: "TheTablePaging__found"
  }, [_vm._v(_vm._s(_vm.translate('TABLE__FOUND')))])])])
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePage', {
    attrs: {
      "class-name": 'TableView',
      "title": 'TABLE__TABLE'
    }
  }, [_c('template', {
    slot: "left-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('TheTableSearch'), _vm._v(" "), _c('TheTablePaging'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "TableView__content"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0),
      expression: "items.length>0"
    }],
    staticClass: "TableView__table"
  }, [_c('thead', {
    staticClass: "TableView__head"
  }, [_c('tr', {
    staticClass: "TableView__head-row"
  }, [_c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('name')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__NAME')))]), _vm._v(" "), (_vm.sortByColumn('name')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('phone')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__PHONE')))]), _vm._v(" "), (_vm.sortByColumn('phone')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('company')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__COMPANY')))]), _vm._v(" "), (_vm.sortByColumn('company')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "TableView__head-cell",
    on: {
      "click": function($event) {
        _vm.setOrder('city')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__CITY')))]), _vm._v(" "), (_vm.sortByColumn('city')) ? _c('span', [(_vm.isAsc) ? _c('i', {
    staticClass: "icon-up-dir"
  }) : _c('i', {
    staticClass: "icon-down-dir"
  })]) : _vm._e()])])]), _vm._v(" "), _c('tbody', {
    staticClass: "TableView__body"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "TableView__row"
    }, [_c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('name')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__NAME')))]), _vm._v(" "), (_vm.sortByColumn('name')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('phone')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__PHONE')))]), _vm._v(" "), (_vm.sortByColumn('phone')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.phone) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('company')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__COMPANY')))]), _vm._v(" "), (_vm.sortByColumn('company')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.company) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "TableView__cell"
    }, [_c('div', {
      staticClass: "TableView__cell-title",
      on: {
        "click": function($event) {
          _vm.setOrder('city')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.translate('TABLE__CITY')))]), _vm._v(" "), (_vm.sortByColumn('city')) ? _c('span', [(_vm.isAsc) ? _c('i', {
      staticClass: "icon-up-dir"
    }) : _c('i', {
      staticClass: "icon-down-dir"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "TableView__cell-content"
    }, [_vm._v("\n                            " + _vm._s(item.city) + "\n                        ")])])])
  }))])]), _vm._v(" "), _c('BaseLoader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoaded),
      expression: "!isLoaded"
    }]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(595),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_catalog_CatalogItem_vue__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_catalog_CatalogItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_catalog_CatalogItem_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CatalogView',
    components: {
        ThePage: __WEBPACK_IMPORTED_MODULE_2__components_common_ThePage_vue___default.a,
        BaseNavigationButton: __WEBPACK_IMPORTED_MODULE_3__components_common_BaseNavigationButton_vue___default.a,
        CatalogItem: __WEBPACK_IMPORTED_MODULE_4__components_catalog_CatalogItem_vue___default.a
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        this.resolveParentGroup(+to.params.id);
        next();
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.openGroup({
                id: 0,
                name: null
            });
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        items: function items(s) {
            return s.catalog.items;
        },
        name: function name(s) {
            return s.catalog.name;
        }
    }), __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */]({
        showUp: 'catalog/showUp',
        showBack: 'catalog/showBack'
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        resolveParentGroup: 'catalog/resolveParentGroup',
        openGroup: 'catalog/openGroup',
        back: 'catalog/back',
        up: 'catalog/up'
    }))
});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BaseButtonFlat_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CatalogItem',
    components: {
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_2__common_BaseButtonFlat_vue___default.a
    },
    props: {
        item: {
            type: Object
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        openGroup: 'catalog/openGroup'
    }))
});

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CatalogItem"
  }, [_c('img', {
    staticClass: "CatalogItem__image",
    attrs: {
      "src": _vm.item.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "CatalogItem__header"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "CatalogItem__description"
  }, [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('div', {
    staticClass: "CatalogItem__bottom"
  }, [(_vm.item.isGroup) ? _c('BaseButtonFlat', {
    attrs: {
      "label": 'CATALOG__OPEN'
    },
    on: {
      "click": function($event) {
        _vm.openGroup(_vm.item)
      }
    }
  }) : _vm._e()], 1)])
}]}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePage', {
    attrs: {
      "class-name": 'CatalogView',
      "title": _vm.name ? _vm.name : _vm.translate('CATALOG__CATALOG')
    }
  }, [_c('template', {
    slot: "left-action"
  }, [_c('BaseNavigationButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUp),
      expression: "showUp"
    }],
    attrs: {
      "icon": 'icon-up'
    },
    on: {
      "click": function($event) {
        _vm.up()
      }
    }
  }), _vm._v(" "), _c('BaseNavigationButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBack),
      expression: "showBack"
    }],
    attrs: {
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "CatalogView__body"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('CatalogItem', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }))], 2)
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_en__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__i18n_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_de__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_ru__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__i18n_ru__);




var state = {
    text: null
};

var mutations = {
    text: function text(state, _text) {
        state.text = _text;
    }
};

var getters = {
    translate: function translate(state) {
        return function (code) {
            if (state.text) {
                var translation = state.text[code];
                return translation ? translation : code;
            }
            return null;
        };
    }
};

var actions = {
    init: function init(store, culture) {
        switch (culture) {
            case 'en':
                store.commit('text', __WEBPACK_IMPORTED_MODULE_0__i18n_en___default.a);
                break;
            case 'de':
                store.commit('text', __WEBPACK_IMPORTED_MODULE_1__i18n_de___default.a);
                break;
            case 'ru':
                store.commit('text', __WEBPACK_IMPORTED_MODULE_2__i18n_ru___default.a);
                break;

        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"COMMON__CANCEL":"Cancel","COMMON__YES":"Yes","COMMON__NO":"No","COMMON__SIGN_OUT":"Sign out","COMMON__SAVE":"Save","COMMON__OK":"OK","COMMON__ADD":"Add","COMMON__DELETE":"Delete","COMMON__DISABLED":"Disabled","COMMON__CREATE":"Create","COMMON__ENABLED":"Enabled","COMMON__REORDER":"Reorder","COMMON__HELP":"Help","COMMON__APPLY":"Apply","SIGNIN__EMAIL":"Email","SIGNIN__PASSWORD":"Password","SIGNIN__SIGN_IN":"Sign in","SIGNIN__TITLE":"Sign in to account","FORGOT_PASSWORD__BACK_TO_SIGN_IN":"Back to sign in","FORGOT_PASSWORD__RESET_PASSWORD":"Reset password","FORGOT_PASSWORD__BACK":"Back","FORGOT_PASSWORD__SENDING":"Sending...","FORGOT_PASSWORD__SEND":"Send","FORGOT_PASSWORD__EMAIL":"Email","FORGOT_PASSWORD__ENTER_EMAIL":"Enter your email to receive a link for resetting password","SIGNUP__WAITING_FOR_EMAIL_CONFIRMAITON":"Waiting for confirmation of email","SIGNUP__TO_SIGN_IN":"Sign in","SIGNUP__NEW_ACCOUNT":"New account","SIGNUP__TO_TERMS_AND_CONDITIONS":"terms and conditions","SIGNUP__I_AGREE_TO":"I agree to","SIGNUP__COMPANY_NAME":"Name of company","SIGNUP__ACCOUNT_CREATED":"Account was successfully created. Message was sent to your mail box. Please confirm your email address by clicking the link in the message.","SIGNUP__SIGN_UP":"Sign up","SIGNUP__TIMEZONE":"Time zone","SIGNUP__NAME":"Your name","SIGNUP__CONFIRM_PASSWORD":"Confirm password","SIGNUP__PASSWORD":"Password","SIGNUP__EMAIL":"Email","SIGNIN__NEED_ACCOUNT":"Need an account?","SIGNIN__FORGOT_PASSWORD":"Forgot password?","MESSAGE__ACCOUNT__EMAIL_OR_PASSWORD_INVALID":"Invalid email or password.","TIMEZONES__EUROPE_ANDORRA":"Andorra: Central European Time (Europe/Andorra)","TIMEZONES__ASIA_DUBAI":"United Arab Emirates: Gulf Standard Time (Asia/Dubai)","TIMEZONES__ASIA_KABUL":"Afghanistan: Afghanistan Time (Asia/Kabul)","TIMEZONES__AMERICA_ANTIGUA":"Antigua and Barbuda: Atlantic Time (America/Antigua)","TIMEZONES__AMERICA_ANGUILLA":"Anguilla: Atlantic Time (America/Anguilla)","TIMEZONES__EUROPE_TIRANE":"Albania: Central European Time (Europe/Tirane)","TIMEZONES__ASIA_YEREVAN":"Armenia: Armenia Time (Asia/Yerevan)","TIMEZONES__AFRICA_LUANDA":"Angola: West Africa Time (Africa/Luanda)","TIMEZONES__ANTARCTICA_MCMURDO":"Antarctica: New Zealand Time (Antarctica/McMurdo)","TIMEZONES__ANTARCTICA_ROTHERA":"Antarctica: Rothera Time (Antarctica/Rothera)","TIMEZONES__ANTARCTICA_PALMER":"Antarctica: Chile Time (Antarctica/Palmer)","TIMEZONES__ANTARCTICA_MAWSON":"Antarctica: Mawson Time (Antarctica/Mawson)","TIMEZONES__ANTARCTICA_DAVIS":"Antarctica: Davis Time (Antarctica/Davis)","TIMEZONES__ANTARCTICA_CASEY":"Antarctica: Western Australia Time (Antarctica/Casey)","TIMEZONES__ANTARCTICA_VOSTOK":"Antarctica: Vostok Time (Antarctica/Vostok)","TIMEZONES__ANTARCTICA_DUMONTDURVILLE":"Antarctica: Dumont-dРІР‚в„ўUrville Time (Antarctica/DumontDUrville)","TIMEZONES__ANTARCTICA_SYOWA":"Antarctica: Syowa Time (Antarctica/Syowa)","TIMEZONES__ANTARCTICA_TROLL":"Antarctica: Greenwich Mean Time (Antarctica/Troll)","TIMEZONES__AMERICA_ARGENTINA_BUENOS_AIRES":"Argentina: Argentina Time (America/Argentina/Buenos_Aires)","TIMEZONES__AMERICA_ARGENTINA_CORDOBA":"Argentina: Argentina Time (America/Argentina/Cordoba)","TIMEZONES__AMERICA_ARGENTINA_SALTA":"Argentina: Argentina Time (America/Argentina/Salta)","TIMEZONES__AMERICA_ARGENTINA_JUJUY":"Argentina: Argentina Time (America/Argentina/Jujuy)","TIMEZONES__AMERICA_ARGENTINA_TUCUMAN":"Argentina: Argentina Time (America/Argentina/Tucuman)","TIMEZONES__AMERICA_ARGENTINA_CATAMARCA":"Argentina: Argentina Time (America/Argentina/Catamarca)","TIMEZONES__AMERICA_ARGENTINA_LA_RIOJA":"Argentina: Argentina Time (America/Argentina/La_Rioja)","TIMEZONES__AMERICA_ARGENTINA_SAN_JUAN":"Argentina: Argentina Time (America/Argentina/San_Juan)","TIMEZONES__AMERICA_ARGENTINA_MENDOZA":"Argentina: Argentina Time (America/Argentina/Mendoza)","TIMEZONES__AMERICA_ARGENTINA_SAN_LUIS":"Argentina: Western Argentina Time (America/Argentina/San_Luis)","TIMEZONES__AMERICA_ARGENTINA_RIO_GALLEGOS":"Argentina: Argentina Time (America/Argentina/Rio_Gallegos)","TIMEZONES__AMERICA_ARGENTINA_USHUAIA":"Argentina: Argentina Time (America/Argentina/Ushuaia)","TIMEZONES__PACIFIC_PAGO_PAGO":"Samoa (American): Samoa Time (Pacific/Pago_Pago)","TIMEZONES__EUROPE_VIENNA":"Austria: Central European Time (Europe/Vienna)","TIMEZONES__AUSTRALIA_LORD_HOWE":"Australia: Lord Howe Time (Australia/Lord_Howe)","TIMEZONES__ANTARCTICA_MACQUARIE":"Australia: Macquarie Island Time (Antarctica/Macquarie)","TIMEZONES__AUSTRALIA_HOBART":"Australia: Eastern Australia Time (Australia/Hobart)","TIMEZONES__AUSTRALIA_CURRIE":"Australia: Eastern Australia Time (Australia/Currie)","TIMEZONES__AUSTRALIA_MELBOURNE":"Australia: Eastern Australia Time (Australia/Melbourne)","TIMEZONES__AUSTRALIA_SYDNEY":"Australia: Eastern Australia Time (Australia/Sydney)","TIMEZONES__AUSTRALIA_BROKEN_HILL":"Australia: Central Australia Time (Australia/Broken_Hill)","TIMEZONES__AUSTRALIA_BRISBANE":"Australia: Eastern Australia Time (Australia/Brisbane)","TIMEZONES__AUSTRALIA_LINDEMAN":"Australia: Eastern Australia Time (Australia/Lindeman)","TIMEZONES__AUSTRALIA_ADELAIDE":"Australia: Central Australia Time (Australia/Adelaide)","TIMEZONES__AUSTRALIA_DARWIN":"Australia: Central Australia Time (Australia/Darwin)","TIMEZONES__AUSTRALIA_PERTH":"Australia: Western Australia Time (Australia/Perth)","TIMEZONES__AUSTRALIA_EUCLA":"Australia: Australian Central Western Time (Australia/Eucla)","TIMEZONES__AMERICA_ARUBA":"Aruba: Atlantic Time (America/Aruba)","TIMEZONES__EUROPE_MARIEHAMN":"Aaland Islands: Eastern European Time (Europe/Mariehamn)","TIMEZONES__ASIA_BAKU":"Azerbaijan: Azerbaijan Time (Asia/Baku)","TIMEZONES__EUROPE_SARAJEVO":"Bosnia and Herzegovina: Central European Time (Europe/Sarajevo)","TIMEZONES__AMERICA_BARBADOS":"Barbados: Atlantic Time (America/Barbados)","TIMEZONES__ASIA_DHAKA":"Bangladesh: Bangladesh Time (Asia/Dhaka)","TIMEZONES__EUROPE_BRUSSELS":"Belgium: Central European Time (Europe/Brussels)","TIMEZONES__AFRICA_OUAGADOUGOU":"Burkina Faso: Greenwich Mean Time (Africa/Ouagadougou)","TIMEZONES__EUROPE_SOFIA":"Bulgaria: Eastern European Time (Europe/Sofia)","TIMEZONES__ASIA_BAHRAIN":"Bahrain: Arabian Time (Asia/Bahrain)","TIMEZONES__AFRICA_BUJUMBURA":"Burundi: Central Africa Time (Africa/Bujumbura)","TIMEZONES__AFRICA_PORTO_NOVO":"Benin: West Africa Time (Africa/Porto-Novo)","TIMEZONES__AMERICA_ST_BARTHELEMY":"St Barthelemy: Atlantic Time (America/St_Barthelemy)","TIMEZONES__ATLANTIC_BERMUDA":"Bermuda: Atlantic Time (Atlantic/Bermuda)","TIMEZONES__ASIA_BRUNEI":"Brunei: Brunei Darussalam Time (Asia/Brunei)","TIMEZONES__AMERICA_LA_PAZ":"Bolivia: Bolivia Time (America/La_Paz)","TIMEZONES__AMERICA_KRALENDIJK":"Caribbean Netherlands: Atlantic Time (America/Kralendijk)","TIMEZONES__AMERICA_NORONHA":"Brazil: Fernando de Noronha Time (America/Noronha)","TIMEZONES__AMERICA_BELEM":"Brazil: Brasilia Time (America/Belem)","TIMEZONES__AMERICA_FORTALEZA":"Brazil: Brasilia Time (America/Fortaleza)","TIMEZONES__AMERICA_RECIFE":"Brazil: Brasilia Time (America/Recife)","TIMEZONES__AMERICA_ARAGUAINA":"Brazil: Brasilia Time (America/Araguaina)","TIMEZONES__AMERICA_MACEIO":"Brazil: Brasilia Time (America/Maceio)","TIMEZONES__AMERICA_BAHIA":"Brazil: Brasilia Time (America/Bahia)","TIMEZONES__AMERICA_SAO_PAULO":"Brazil: Brasilia Time (America/Sao_Paulo)","TIMEZONES__AMERICA_CAMPO_GRANDE":"Brazil: Amazon Time (America/Campo_Grande)","TIMEZONES__AMERICA_CUIABA":"Brazil: Amazon Time (America/Cuiaba)","TIMEZONES__AMERICA_SANTAREM":"Brazil: Brasilia Time (America/Santarem)","TIMEZONES__AMERICA_PORTO_VELHO":"Brazil: Amazon Time (America/Porto_Velho)","TIMEZONES__AMERICA_BOA_VISTA":"Brazil: Amazon Time (America/Boa_Vista)","TIMEZONES__AMERICA_MANAUS":"Brazil: Amazon Time (America/Manaus)","TIMEZONES__AMERICA_EIRUNEPE":"Brazil: Acre Time (America/Eirunepe)","TIMEZONES__AMERICA_RIO_BRANCO":"Brazil: Acre Time (America/Rio_Branco)","TIMEZONES__AMERICA_NASSAU":"Bahamas: Eastern Time (America/Nassau)","TIMEZONES__ASIA_THIMPHU":"Bhutan: Bhutan Time (Asia/Thimphu)","TIMEZONES__AFRICA_GABORONE":"Botswana: Central Africa Time (Africa/Gaborone)","TIMEZONES__EUROPE_MINSK":"Belarus: Further-eastern European Time (Europe/Minsk)","TIMEZONES__AMERICA_BELIZE":"Belize: Central Time (America/Belize)","TIMEZONES__AMERICA_ST_JOHNS":"Canada: Newfoundland Time (America/St_Johns)","TIMEZONES__AMERICA_HALIFAX":"Canada: Atlantic Time (America/Halifax)","TIMEZONES__AMERICA_GLACE_BAY":"Canada: Atlantic Time (America/Glace_Bay)","TIMEZONES__AMERICA_MONCTON":"Canada: Atlantic Time (America/Moncton)","TIMEZONES__AMERICA_GOOSE_BAY":"Canada: Atlantic Time (America/Goose_Bay)","TIMEZONES__AMERICA_BLANC_SABLON":"Canada: Atlantic Time (America/Blanc-Sablon)","TIMEZONES__AMERICA_TORONTO":"Canada: Eastern Time (America/Toronto)","TIMEZONES__AMERICA_NIPIGON":"Canada: Eastern Time (America/Nipigon)","TIMEZONES__AMERICA_THUNDER_BAY":"Canada: Eastern Time (America/Thunder_Bay)","TIMEZONES__AMERICA_IQALUIT":"Canada: Eastern Time (America/Iqaluit)","TIMEZONES__AMERICA_PANGNIRTUNG":"Canada: Eastern Time (America/Pangnirtung)","TIMEZONES__AMERICA_RESOLUTE":"Canada: Central Time (America/Resolute)","TIMEZONES__AMERICA_ATIKOKAN":"Canada: Eastern Time (America/Atikokan)","TIMEZONES__AMERICA_RANKIN_INLET":"Canada: Central Time (America/Rankin_Inlet)","TIMEZONES__AMERICA_WINNIPEG":"Canada: Central Time (America/Winnipeg)","TIMEZONES__AMERICA_RAINY_RIVER":"Canada: Central Time (America/Rainy_River)","TIMEZONES__AMERICA_REGINA":"Canada: Central Time (America/Regina)","TIMEZONES__AMERICA_SWIFT_CURRENT":"Canada: Central Time (America/Swift_Current)","TIMEZONES__AMERICA_EDMONTON":"Canada: Mountain Time (America/Edmonton)","TIMEZONES__AMERICA_CAMBRIDGE_BAY":"Canada: Mountain Time (America/Cambridge_Bay)","TIMEZONES__AMERICA_YELLOWKNIFE":"Canada: Mountain Time (America/Yellowknife)","TIMEZONES__AMERICA_INUVIK":"Canada: Mountain Time (America/Inuvik)","TIMEZONES__AMERICA_CRESTON":"Canada: Mountain Time (America/Creston)","TIMEZONES__AMERICA_DAWSON_CREEK":"Canada: Mountain Time (America/Dawson_Creek)","TIMEZONES__AMERICA_VANCOUVER":"Canada: Pacific Time (America/Vancouver)","TIMEZONES__AMERICA_WHITEHORSE":"Canada: Pacific Time (America/Whitehorse)","TIMEZONES__AMERICA_DAWSON":"Canada: Pacific Time (America/Dawson)","TIMEZONES__INDIAN_COCOS":"Cocos (Keeling) Islands: Cocos Islands Time (Indian/Cocos)","TIMEZONES__AFRICA_KINSHASA":"Congo (Dem. Rep.): West Africa Time (Africa/Kinshasa)","TIMEZONES__AFRICA_LUBUMBASHI":"Congo (Dem. Rep.): Central Africa Time (Africa/Lubumbashi)","TIMEZONES__AFRICA_BANGUI":"Central African Rep.: West Africa Time (Africa/Bangui)","TIMEZONES__AFRICA_BRAZZAVILLE":"Congo (Rep.): West Africa Time (Africa/Brazzaville)","TIMEZONES__EUROPE_ZURICH":"Switzerland: Central European Time (Europe/Zurich)","TIMEZONES__AFRICA_ABIDJAN":"Cote d'Ivoire: Greenwich Mean Time (Africa/Abidjan)","TIMEZONES__PACIFIC_RAROTONGA":"Cook Islands: Cook Islands Time (Pacific/Rarotonga)","TIMEZONES__AMERICA_SANTIAGO":"Chile: Chile Time (America/Santiago)","TIMEZONES__PACIFIC_EASTER":"Chile: Easter Island Time (Pacific/Easter)","TIMEZONES__AFRICA_DOUALA":"Cameroon: West Africa Time (Africa/Douala)","TIMEZONES__ASIA_SHANGHAI":"China: China Time (Asia/Shanghai)","TIMEZONES__ASIA_URUMQI":"China: China Time (Asia/Urumqi)","TIMEZONES__AMERICA_BOGOTA":"Colombia: Colombia Time (America/Bogota)","TIMEZONES__AMERICA_COSTA_RICA":"Costa Rica: Central Time (America/Costa_Rica)","TIMEZONES__AMERICA_HAVANA":"Cuba: Cuba Time (America/Havana)","TIMEZONES__ATLANTIC_CAPE_VERDE":"Cape Verde: Cape Verde Time (Atlantic/Cape_Verde)","TIMEZONES__AMERICA_CURACAO":"Curacao: Atlantic Time (America/Curacao)","TIMEZONES__INDIAN_CHRISTMAS":"Christmas Island: Christmas Island Time (Indian/Christmas)","TIMEZONES__ASIA_NICOSIA":"Cyprus: Eastern European Time (Asia/Nicosia)","TIMEZONES__EUROPE_PRAGUE":"Czech Republic: Central European Time (Europe/Prague)","TIMEZONES__EUROPE_BERLIN":"Germany: Central European Time (Europe/Berlin)","TIMEZONES__EUROPE_BUSINGEN":"Germany: Central European Time (Europe/Busingen)","TIMEZONES__AFRICA_DJIBOUTI":"Djibouti: East Africa Time (Africa/Djibouti)","TIMEZONES__EUROPE_COPENHAGEN":"Denmark: Central European Time (Europe/Copenhagen)","TIMEZONES__AMERICA_DOMINICA":"Dominica: Atlantic Time (America/Dominica)","TIMEZONES__AMERICA_SANTO_DOMINGO":"Dominican Republic: Atlantic Time (America/Santo_Domingo)","TIMEZONES__AFRICA_ALGIERS":"Algeria: Central European Time (Africa/Algiers)","TIMEZONES__AMERICA_GUAYAQUIL":"Ecuador: Ecuador Time (America/Guayaquil)","TIMEZONES__PACIFIC_GALAPAGOS":"Ecuador: Galapagos Time (Pacific/Galapagos)","TIMEZONES__EUROPE_TALLINN":"Estonia: Eastern European Time (Europe/Tallinn)","TIMEZONES__AFRICA_CAIRO":"Egypt: Eastern European Time (Africa/Cairo)","TIMEZONES__AFRICA_EL_AAIUN":"Western Sahara: Western European Time (Africa/El_Aaiun)","TIMEZONES__AFRICA_ASMARA":"Eritrea: East Africa Time (Africa/Asmara)","TIMEZONES__EUROPE_MADRID":"Spain: Central European Time (Europe/Madrid)","TIMEZONES__AFRICA_CEUTA":"Spain: Central European Time (Africa/Ceuta)","TIMEZONES__ATLANTIC_CANARY":"Spain: Western European Time (Atlantic/Canary)","TIMEZONES__AFRICA_ADDIS_ABABA":"Ethiopia: East Africa Time (Africa/Addis_Ababa)","TIMEZONES__EUROPE_HELSINKI":"Finland: Eastern European Time (Europe/Helsinki)","TIMEZONES__PACIFIC_FIJI":"Fiji: Fiji Time (Pacific/Fiji)","TIMEZONES__ATLANTIC_STANLEY":"Falkland Islands: Falkland Islands Time (Atlantic/Stanley)","TIMEZONES__PACIFIC_CHUUK":"Micronesia: Chuuk Time (Pacific/Chuuk)","TIMEZONES__PACIFIC_POHNPEI":"Micronesia: Ponape Time (Pacific/Pohnpei)","TIMEZONES__PACIFIC_KOSRAE":"Micronesia: Kosrae Time (Pacific/Kosrae)","TIMEZONES__ATLANTIC_FAROE":"Faroe Islands: Western European Time (Atlantic/Faroe)","TIMEZONES__EUROPE_PARIS":"France: Central European Time (Europe/Paris)","TIMEZONES__AFRICA_LIBREVILLE":"Gabon: West Africa Time (Africa/Libreville)","TIMEZONES__EUROPE_LONDON":"Britain (UK): UK Time (Europe/London)","TIMEZONES__AMERICA_GRENADA":"Grenada: Atlantic Time (America/Grenada)","TIMEZONES__ASIA_TBILISI":"Georgia: Georgia Time (Asia/Tbilisi)","TIMEZONES__AMERICA_CAYENNE":"French Guiana: French Guiana Time (America/Cayenne)","TIMEZONES__EUROPE_GUERNSEY":"Guernsey: Greenwich Mean Time (Europe/Guernsey)","TIMEZONES__AFRICA_ACCRA":"Ghana: Greenwich Mean Time (Africa/Accra)","TIMEZONES__EUROPE_GIBRALTAR":"Gibraltar: Central European Time (Europe/Gibraltar)","TIMEZONES__AMERICA_GODTHAB":"Greenland: West Greenland Time (America/Godthab)","TIMEZONES__AMERICA_DANMARKSHAVN":"Greenland: Greenwich Mean Time (America/Danmarkshavn)","TIMEZONES__AMERICA_SCORESBYSUND":"Greenland: East Greenland Time (America/Scoresbysund)","TIMEZONES__AMERICA_THULE":"Greenland: Atlantic Time (America/Thule)","TIMEZONES__AFRICA_BANJUL":"Gambia: Greenwich Mean Time (Africa/Banjul)","TIMEZONES__AFRICA_CONAKRY":"Guinea: Greenwich Mean Time (Africa/Conakry)","TIMEZONES__AMERICA_GUADELOUPE":"Guadeloupe: Atlantic Time (America/Guadeloupe)","TIMEZONES__AFRICA_MALABO":"Equatorial Guinea: West Africa Time (Africa/Malabo)","TIMEZONES__EUROPE_ATHENS":"Greece: Eastern European Time (Europe/Athens)","TIMEZONES__ATLANTIC_SOUTH_GEORGIA":"South Georgia and the South Sandwich Islands: South Georgia Time (Atlantic/South_Georgia)","TIMEZONES__AMERICA_GUATEMALA":"Guatemala: Central Time (America/Guatemala)","TIMEZONES__PACIFIC_GUAM":"Guam: Chamorro Standard Time (Pacific/Guam)","TIMEZONES__AFRICA_BISSAU":"Guinea-Bissau: Greenwich Mean Time (Africa/Bissau)","TIMEZONES__AMERICA_GUYANA":"Guyana: Guyana Time (America/Guyana)","TIMEZONES__ASIA_HONG_KONG":"Hong Kong: Hong Kong Time (Asia/Hong_Kong)","TIMEZONES__AMERICA_TEGUCIGALPA":"Honduras: Central Time (America/Tegucigalpa)","TIMEZONES__EUROPE_ZAGREB":"Croatia: Central European Time (Europe/Zagreb)","TIMEZONES__AMERICA_PORT_AU_PRINCE":"Haiti: Eastern Time (America/Port-au-Prince)","TIMEZONES__EUROPE_BUDAPEST":"Hungary: Central European Time (Europe/Budapest)","TIMEZONES__ASIA_JAKARTA":"Indonesia: Western Indonesia Time (Asia/Jakarta)","TIMEZONES__ASIA_PONTIANAK":"Indonesia: Western Indonesia Time (Asia/Pontianak)","TIMEZONES__ASIA_MAKASSAR":"Indonesia: Central Indonesia Time (Asia/Makassar)","TIMEZONES__ASIA_JAYAPURA":"Indonesia: Eastern Indonesia Time (Asia/Jayapura)","TIMEZONES__EUROPE_DUBLIN":"Ireland: Ireland Time (Europe/Dublin)","TIMEZONES__ASIA_JERUSALEM":"Israel: Israel Time (Asia/Jerusalem)","TIMEZONES__EUROPE_ISLE_OF_MAN":"Isle of Man: Greenwich Mean Time (Europe/Isle_of_Man)","TIMEZONES__ASIA_KOLKATA":"India: India Standard Time (Asia/Kolkata)","TIMEZONES__INDIAN_CHAGOS":"British Indian Ocean Territory: Indian Ocean Time (Indian/Chagos)","TIMEZONES__ASIA_BAGHDAD":"Iraq: Arabian Time (Asia/Baghdad)","TIMEZONES__ASIA_TEHRAN":"Iran: Iran Time (Asia/Tehran)","TIMEZONES__ATLANTIC_REYKJAVIK":"Iceland: Greenwich Mean Time (Atlantic/Reykjavik)","TIMEZONES__EUROPE_ROME":"Italy: Central European Time (Europe/Rome)","TIMEZONES__EUROPE_JERSEY":"Jersey: Greenwich Mean Time (Europe/Jersey)","TIMEZONES__AMERICA_JAMAICA":"Jamaica: Eastern Time (America/Jamaica)","TIMEZONES__ASIA_AMMAN":"Jordan: Eastern European Time (Asia/Amman)","TIMEZONES__ASIA_TOKYO":"Japan: Japan Time (Asia/Tokyo)","TIMEZONES__AFRICA_NAIROBI":"Kenya: East Africa Time (Africa/Nairobi)","TIMEZONES__ASIA_BISHKEK":"Kyrgyzstan: Kyrgystan Time (Asia/Bishkek)","TIMEZONES__ASIA_PHNOM_PENH":"Cambodia: Indochina Time (Asia/Phnom_Penh)","TIMEZONES__PACIFIC_TARAWA":"Kiribati: Gilbert Islands Time (Pacific/Tarawa)","TIMEZONES__PACIFIC_ENDERBURY":"Kiribati: Phoenix Islands Time (Pacific/Enderbury)","TIMEZONES__PACIFIC_KIRITIMATI":"Kiribati: Line Islands Time (Pacific/Kiritimati)","TIMEZONES__INDIAN_COMORO":"Comoros: East Africa Time (Indian/Comoro)","TIMEZONES__AMERICA_ST_KITTS":"St Kitts and Nevis: Atlantic Time (America/St_Kitts)","TIMEZONES__ASIA_PYONGYANG":"Korea (North): Korean Time (Asia/Pyongyang)","TIMEZONES__ASIA_SEOUL":"Korea (South): Korean Time (Asia/Seoul)","TIMEZONES__ASIA_KUWAIT":"Kuwait: Arabian Time (Asia/Kuwait)","TIMEZONES__AMERICA_CAYMAN":"Cayman Islands: Eastern Time (America/Cayman)","TIMEZONES__ASIA_ALMATY":"Kazakhstan: East Kazakhstan Time (Asia/Almaty)","TIMEZONES__ASIA_QYZYLORDA":"Kazakhstan: East Kazakhstan Time (Asia/Qyzylorda)","TIMEZONES__ASIA_AQTOBE":"Kazakhstan: West Kazakhstan Time (Asia/Aqtobe)","TIMEZONES__ASIA_AQTAU":"Kazakhstan: West Kazakhstan Time (Asia/Aqtau)","TIMEZONES__ASIA_ORAL":"Kazakhstan: West Kazakhstan Time (Asia/Oral)","TIMEZONES__ASIA_VIENTIANE":"Laos: Indochina Time (Asia/Vientiane)","TIMEZONES__ASIA_BEIRUT":"Lebanon: Eastern European Time (Asia/Beirut)","TIMEZONES__AMERICA_ST_LUCIA":"St Lucia: Atlantic Time (America/St_Lucia)","TIMEZONES__EUROPE_VADUZ":"Liechtenstein: Central European Time (Europe/Vaduz)","TIMEZONES__ASIA_COLOMBO":"Sri Lanka: India Standard Time (Asia/Colombo)","TIMEZONES__AFRICA_MONROVIA":"Liberia: Greenwich Mean Time (Africa/Monrovia)","TIMEZONES__AFRICA_MASERU":"Lesotho: South Africa Standard Time (Africa/Maseru)","TIMEZONES__EUROPE_VILNIUS":"Lithuania: Eastern European Time (Europe/Vilnius)","TIMEZONES__EUROPE_LUXEMBOURG":"Luxembourg: Central European Time (Europe/Luxembourg)","TIMEZONES__EUROPE_RIGA":"Latvia: Eastern European Time (Europe/Riga)","TIMEZONES__AFRICA_TRIPOLI":"Libya: Eastern European Time (Africa/Tripoli)","TIMEZONES__AFRICA_CASABLANCA":"Morocco: Western European Time (Africa/Casablanca)","TIMEZONES__EUROPE_MONACO":"Monaco: Central European Time (Europe/Monaco)","TIMEZONES__EUROPE_CHISINAU":"Moldova: Eastern European Time (Europe/Chisinau)","TIMEZONES__EUROPE_PODGORICA":"Montenegro: Central European Time (Europe/Podgorica)","TIMEZONES__AMERICA_MARIGOT":"St Martin (French part): Atlantic Time (America/Marigot)","TIMEZONES__INDIAN_ANTANANARIVO":"Madagascar: East Africa Time (Indian/Antananarivo)","TIMEZONES__PACIFIC_MAJURO":"Marshall Islands: Marshall Islands Time (Pacific/Majuro)","TIMEZONES__PACIFIC_KWAJALEIN":"Marshall Islands: Marshall Islands Time (Pacific/Kwajalein)","TIMEZONES__EUROPE_SKOPJE":"Macedonia: Central European Time (Europe/Skopje)","TIMEZONES__AFRICA_BAMAKO":"Mali: Greenwich Mean Time (Africa/Bamako)","TIMEZONES__ASIA_RANGOON":"Myanmar (Burma): Myanmar Time (Asia/Rangoon)","TIMEZONES__ASIA_ULAANBAATAR":"Mongolia: Ulan Bator Time (Asia/Ulaanbaatar)","TIMEZONES__ASIA_HOVD":"Mongolia: Hovd Time (Asia/Hovd)","TIMEZONES__ASIA_CHOIBALSAN":"Mongolia: Choibalsan Time (Asia/Choibalsan)","TIMEZONES__ASIA_MACAU":"Macau: China Time (Asia/Macau)","TIMEZONES__PACIFIC_SAIPAN":"Northern Mariana Islands: Chamorro Standard Time (Pacific/Saipan)","TIMEZONES__AMERICA_MARTINIQUE":"Martinique: Atlantic Time (America/Martinique)","TIMEZONES__AFRICA_NOUAKCHOTT":"Mauritania: Greenwich Mean Time (Africa/Nouakchott)","TIMEZONES__AMERICA_MONTSERRAT":"Montserrat: Atlantic Time (America/Montserrat)","TIMEZONES__EUROPE_MALTA":"Malta: Central European Time (Europe/Malta)","TIMEZONES__INDIAN_MAURITIUS":"Mauritius: Mauritius Time (Indian/Mauritius)","TIMEZONES__INDIAN_MALDIVES":"Maldives: Maldives Time (Indian/Maldives)","TIMEZONES__AFRICA_BLANTYRE":"Malawi: Central Africa Time (Africa/Blantyre)","TIMEZONES__AMERICA_MEXICO_CITY":"Mexico: Central Time (America/Mexico_City)","TIMEZONES__AMERICA_CANCUN":"Mexico: Eastern Time (America/Cancun)","TIMEZONES__AMERICA_MERIDA":"Mexico: Central Time (America/Merida)","TIMEZONES__AMERICA_MONTERREY":"Mexico: Central Time (America/Monterrey)","TIMEZONES__AMERICA_MATAMOROS":"Mexico: Central Time (America/Matamoros)","TIMEZONES__AMERICA_MAZATLAN":"Mexico: Mexican Pacific Time (America/Mazatlan)","TIMEZONES__AMERICA_CHIHUAHUA":"Mexico: Mexican Pacific Time (America/Chihuahua)","TIMEZONES__AMERICA_OJINAGA":"Mexico: Mountain Time (America/Ojinaga)","TIMEZONES__AMERICA_HERMOSILLO":"Mexico: Mexican Pacific Time (America/Hermosillo)","TIMEZONES__AMERICA_TIJUANA":"Mexico: Pacific Time (America/Tijuana)","TIMEZONES__AMERICA_BAHIA_BANDERAS":"Mexico: Central Time (America/Bahia_Banderas)","TIMEZONES__ASIA_KUALA_LUMPUR":"Malaysia: Malaysia Time (Asia/Kuala_Lumpur)","TIMEZONES__ASIA_KUCHING":"Malaysia: Malaysia Time (Asia/Kuching)","TIMEZONES__AFRICA_MAPUTO":"Mozambique: Central Africa Time (Africa/Maputo)","TIMEZONES__AFRICA_WINDHOEK":"Namibia: West Africa Time (Africa/Windhoek)","TIMEZONES__PACIFIC_NOUMEA":"New Caledonia: New Caledonia Time (Pacific/Noumea)","TIMEZONES__AFRICA_NIAMEY":"Niger: West Africa Time (Africa/Niamey)","TIMEZONES__PACIFIC_NORFOLK":"Norfolk Island: Norfolk Island Time (Pacific/Norfolk)","TIMEZONES__AFRICA_LAGOS":"Nigeria: West Africa Time (Africa/Lagos)","TIMEZONES__AMERICA_MANAGUA":"Nicaragua: Central Time (America/Managua)","TIMEZONES__EUROPE_AMSTERDAM":"Netherlands: Central European Time (Europe/Amsterdam)","TIMEZONES__EUROPE_OSLO":"Norway: Central European Time (Europe/Oslo)","TIMEZONES__ASIA_KATHMANDU":"Nepal: Nepal Time (Asia/Kathmandu)","TIMEZONES__PACIFIC_NAURU":"Nauru: Nauru Time (Pacific/Nauru)","TIMEZONES__PACIFIC_NIUE":"Niue: Niue Time (Pacific/Niue)","TIMEZONES__PACIFIC_AUCKLAND":"New Zealand: New Zealand Time (Pacific/Auckland)","TIMEZONES__PACIFIC_CHATHAM":"New Zealand: Chatham Time (Pacific/Chatham)","TIMEZONES__ASIA_MUSCAT":"Oman: Gulf Standard Time (Asia/Muscat)","TIMEZONES__AMERICA_PANAMA":"Panama: Eastern Time (America/Panama)","TIMEZONES__AMERICA_LIMA":"Peru: Peru Time (America/Lima)","TIMEZONES__PACIFIC_TAHITI":"French Polynesia: Tahiti Time (Pacific/Tahiti)","TIMEZONES__PACIFIC_MARQUESAS":"French Polynesia: Marquesas Time (Pacific/Marquesas)","TIMEZONES__PACIFIC_GAMBIER":"French Polynesia: Gambier Time (Pacific/Gambier)","TIMEZONES__PACIFIC_PORT_MORESBY":"Papua New Guinea: Papua New Guinea Time (Pacific/Port_Moresby)","TIMEZONES__PACIFIC_BOUGAINVILLE":"Papua New Guinea: Papua New Guinea Time (Pacific/Bougainville)","TIMEZONES__ASIA_MANILA":"Philippines: Philippine Time (Asia/Manila)","TIMEZONES__ASIA_KARACHI":"Pakistan: Pakistan Time (Asia/Karachi)","TIMEZONES__EUROPE_WARSAW":"Poland: Central European Time (Europe/Warsaw)","TIMEZONES__AMERICA_MIQUELON":"St Pierre and Miquelon: St. Pierre and Miquelon Time (America/Miquelon)","TIMEZONES__PACIFIC_PITCAIRN":"Pitcairn: Pitcairn Time (Pacific/Pitcairn)","TIMEZONES__AMERICA_PUERTO_RICO":"Puerto Rico: Atlantic Time (America/Puerto_Rico)","TIMEZONES__ASIA_GAZA":"Palestine: Eastern European Time (Asia/Gaza)","TIMEZONES__ASIA_HEBRON":"Palestine: Eastern European Time (Asia/Hebron)","TIMEZONES__EUROPE_LISBON":"Portugal: Western European Time (Europe/Lisbon)","TIMEZONES__ATLANTIC_MADEIRA":"Portugal: Western European Time (Atlantic/Madeira)","TIMEZONES__ATLANTIC_AZORES":"Portugal: Azores Time (Atlantic/Azores)","TIMEZONES__PACIFIC_PALAU":"Palau: Palau Time (Pacific/Palau)","TIMEZONES__AMERICA_ASUNCION":"Paraguay: Paraguay Time (America/Asuncion)","TIMEZONES__ASIA_QATAR":"Qatar: Arabian Time (Asia/Qatar)","TIMEZONES__INDIAN_REUNION":"Reunion: Reunion Time (Indian/Reunion)","TIMEZONES__EUROPE_BUCHAREST":"Romania: Eastern European Time (Europe/Bucharest)","TIMEZONES__EUROPE_BELGRADE":"Serbia: Central European Time (Europe/Belgrade)","TIMEZONES__EUROPE_KALININGRAD":"Russia: Eastern European Time (Europe/Kaliningrad)","TIMEZONES__EUROPE_MOSCOW":"Russia: Moscow Time (Europe/Moscow)","TIMEZONES__EUROPE_SIMFEROPOL":"Russia: Moscow Time (Europe/Simferopol)","TIMEZONES__EUROPE_VOLGOGRAD":"Russia: Moscow Time (Europe/Volgograd)","TIMEZONES__EUROPE_SAMARA":"Russia: Samara Time (Europe/Samara)","TIMEZONES__ASIA_YEKATERINBURG":"Russia: Yekaterinburg Time (Asia/Yekaterinburg)","TIMEZONES__ASIA_OMSK":"Russia: Omsk Time (Asia/Omsk)","TIMEZONES__ASIA_NOVOSIBIRSK":"Russia: Novosibirsk Time (Asia/Novosibirsk)","TIMEZONES__ASIA_NOVOKUZNETSK":"Russia: Krasnoyarsk Time (Asia/Novokuznetsk)","TIMEZONES__ASIA_KRASNOYARSK":"Russia: Krasnoyarsk Time (Asia/Krasnoyarsk)","TIMEZONES__ASIA_IRKUTSK":"Russia: Irkutsk Time (Asia/Irkutsk)","TIMEZONES__ASIA_CHITA":"Russia: Irkutsk Time (Asia/Chita)","TIMEZONES__ASIA_YAKUTSK":"Russia: Yakutsk Time (Asia/Yakutsk)","TIMEZONES__ASIA_KHANDYGA":"Russia: Yakutsk Time (Asia/Khandyga)","TIMEZONES__ASIA_VLADIVOSTOK":"Russia: Vladivostok Time (Asia/Vladivostok)","TIMEZONES__ASIA_SAKHALIN":"Russia: Sakhalin Time (Asia/Sakhalin)","TIMEZONES__ASIA_UST_NERA":"Russia: Vladivostok Time (Asia/Ust-Nera)","TIMEZONES__ASIA_MAGADAN":"Russia: Magadan Time (Asia/Magadan)","TIMEZONES__ASIA_SREDNEKOLYMSK":"Russia: Magadan Time (Asia/Srednekolymsk)","TIMEZONES__ASIA_KAMCHATKA":"Russia: Petropavlovsk-Kamchatski Time (Asia/Kamchatka)","TIMEZONES__ASIA_ANADYR":"Russia: Magadan Time (Asia/Anadyr)","TIMEZONES__AFRICA_KIGALI":"Rwanda: Central Africa Time (Africa/Kigali)","TIMEZONES__ASIA_RIYADH":"Saudi Arabia: Arabian Time (Asia/Riyadh)","TIMEZONES__PACIFIC_GUADALCANAL":"Solomon Islands: Solomon Islands Time (Pacific/Guadalcanal)","TIMEZONES__INDIAN_MAHE":"Seychelles: Seychelles Time (Indian/Mahe)","TIMEZONES__AFRICA_KHARTOUM":"Sudan: East Africa Time (Africa/Khartoum)","TIMEZONES__EUROPE_STOCKHOLM":"Sweden: Central European Time (Europe/Stockholm)","TIMEZONES__ASIA_SINGAPORE":"Singapore: Singapore Standard Time (Asia/Singapore)","TIMEZONES__ATLANTIC_ST_HELENA":"St Helena: Greenwich Mean Time (Atlantic/St_Helena)","TIMEZONES__EUROPE_LJUBLJANA":"Slovenia: Central European Time (Europe/Ljubljana)","TIMEZONES__ARCTIC_LONGYEARBYEN":"Svalbard and Jan Mayen: Central European Time (Arctic/Longyearbyen)","TIMEZONES__EUROPE_BRATISLAVA":"Slovakia: Central European Time (Europe/Bratislava)","TIMEZONES__AFRICA_FREETOWN":"Sierra Leone: Greenwich Mean Time (Africa/Freetown)","TIMEZONES__EUROPE_SAN_MARINO":"San Marino: Central European Time (Europe/San_Marino)","TIMEZONES__AFRICA_DAKAR":"Senegal: Greenwich Mean Time (Africa/Dakar)","TIMEZONES__AFRICA_MOGADISHU":"Somalia: East Africa Time (Africa/Mogadishu)","TIMEZONES__AMERICA_PARAMARIBO":"Suriname: Suriname Time (America/Paramaribo)","TIMEZONES__AFRICA_JUBA":"South Sudan: East Africa Time (Africa/Juba)","TIMEZONES__AFRICA_SAO_TOME":"Sao Tome and Principe: Greenwich Mean Time (Africa/Sao_Tome)","TIMEZONES__AMERICA_EL_SALVADOR":"El Salvador: Central Time (America/El_Salvador)","TIMEZONES__AMERICA_LOWER_PRINCES":"St Maarten (Dutch part): Atlantic Time (America/Lower_Princes)","TIMEZONES__ASIA_DAMASCUS":"Syria: Eastern European Time (Asia/Damascus)","TIMEZONES__AFRICA_MBABANE":"Swaziland: South Africa Standard Time (Africa/Mbabane)","TIMEZONES__AMERICA_GRAND_TURK":"Turks and Caicos Is: Atlantic Time (America/Grand_Turk)","TIMEZONES__AFRICA_NDJAMENA":"Chad: West Africa Time (Africa/Ndjamena)","TIMEZONES__INDIAN_KERGUELEN":"French Southern and Antarctic Lands: French Southern and Antarctic Time (Indian/Kerguelen)","TIMEZONES__AFRICA_LOME":"Togo: Greenwich Mean Time (Africa/Lome)","TIMEZONES__ASIA_BANGKOK":"Thailand: Indochina Time (Asia/Bangkok)","TIMEZONES__ASIA_DUSHANBE":"Tajikistan: Tajikistan Time (Asia/Dushanbe)","TIMEZONES__PACIFIC_FAKAOFO":"Tokelau: Tokelau Time (Pacific/Fakaofo)","TIMEZONES__ASIA_DILI":"East Timor: East Timor Time (Asia/Dili)","TIMEZONES__ASIA_ASHGABAT":"Turkmenistan: Turkmenistan Time (Asia/Ashgabat)","TIMEZONES__AFRICA_TUNIS":"Tunisia: Central European Time (Africa/Tunis)","TIMEZONES__PACIFIC_TONGATAPU":"Tonga: Tonga Time (Pacific/Tongatapu)","TIMEZONES__EUROPE_ISTANBUL":"Turkey: Eastern European Time (Europe/Istanbul)","TIMEZONES__AMERICA_PORT_OF_SPAIN":"Trinidad and Tobago: Atlantic Time (America/Port_of_Spain)","TIMEZONES__PACIFIC_FUNAFUTI":"Tuvalu: Tuvalu Time (Pacific/Funafuti)","TIMEZONES__ASIA_TAIPEI":"Taiwan: Taipei Time (Asia/Taipei)","TIMEZONES__AFRICA_DAR_ES_SALAAM":"Tanzania: East Africa Time (Africa/Dar_es_Salaam)","TIMEZONES__EUROPE_KIEV":"Ukraine: Eastern European Time (Europe/Kiev)","TIMEZONES__EUROPE_UZHGOROD":"Ukraine: Eastern European Time (Europe/Uzhgorod)","TIMEZONES__EUROPE_ZAPOROZHYE":"Ukraine: Eastern European Time (Europe/Zaporozhye)","TIMEZONES__AFRICA_KAMPALA":"Uganda: East Africa Time (Africa/Kampala)","TIMEZONES__PACIFIC_JOHNSTON":"US minor outlying islands: Hawaii-Aleutian Time (Pacific/Johnston)","TIMEZONES__PACIFIC_MIDWAY":"US minor outlying islands: Samoa Time (Pacific/Midway)","TIMEZONES__PACIFIC_WAKE":"US minor outlying islands: Wake Island Time (Pacific/Wake)","TIMEZONES__AMERICA_NEW_YORK":"United States: Eastern Time (America/New_York)","TIMEZONES__AMERICA_DETROIT":"United States: Eastern Time (America/Detroit)","TIMEZONES__AMERICA_KENTUCKY_LOUISVILLE":"United States: Eastern Time (America/Kentucky/Louisville)","TIMEZONES__AMERICA_KENTUCKY_MONTICELLO":"United States: Eastern Time (America/Kentucky/Monticello)","TIMEZONES__AMERICA_INDIANA_INDIANAPOLIS":"United States: Eastern Time (America/Indiana/Indianapolis)","TIMEZONES__AMERICA_INDIANA_VINCENNES":"United States: Eastern Time (America/Indiana/Vincennes)","TIMEZONES__AMERICA_INDIANA_WINAMAC":"United States: Eastern Time (America/Indiana/Winamac)","TIMEZONES__AMERICA_INDIANA_MARENGO":"United States: Eastern Time (America/Indiana/Marengo)","TIMEZONES__AMERICA_INDIANA_PETERSBURG":"United States: Eastern Time (America/Indiana/Petersburg)","TIMEZONES__AMERICA_INDIANA_VEVAY":"United States: Eastern Time (America/Indiana/Vevay)","TIMEZONES__AMERICA_CHICAGO":"United States: Central Time (America/Chicago)","TIMEZONES__AMERICA_INDIANA_TELL_CITY":"United States: Central Time (America/Indiana/Tell_City)","TIMEZONES__AMERICA_INDIANA_KNOX":"United States: Central Time (America/Indiana/Knox)","TIMEZONES__AMERICA_MENOMINEE":"United States: Central Time (America/Menominee)","TIMEZONES__AMERICA_NORTH_DAKOTA_CENTER":"United States: Central Time (America/North_Dakota/Center)","TIMEZONES__AMERICA_NORTH_DAKOTA_NEW_SALEM":"United States: Central Time (America/North_Dakota/New_Salem)","TIMEZONES__AMERICA_NORTH_DAKOTA_BEULAH":"United States: Central Time (America/North_Dakota/Beulah)","TIMEZONES__AMERICA_DENVER":"United States: Mountain Time (America/Denver)","TIMEZONES__AMERICA_BOISE":"United States: Mountain Time (America/Boise)","TIMEZONES__AMERICA_PHOENIX":"United States: Mountain Time (America/Phoenix)","TIMEZONES__AMERICA_LOS_ANGELES":"United States: Pacific Time (America/Los_Angeles)","TIMEZONES__AMERICA_METLAKATLA":"United States: Pacific Time (America/Metlakatla)","TIMEZONES__AMERICA_ANCHORAGE":"United States: Alaska Time (America/Anchorage)","TIMEZONES__AMERICA_JUNEAU":"United States: Alaska Time (America/Juneau)","TIMEZONES__AMERICA_SITKA":"United States: Alaska Time (America/Sitka)","TIMEZONES__AMERICA_YAKUTAT":"United States: Alaska Time (America/Yakutat)","TIMEZONES__AMERICA_NOME":"United States: Alaska Time (America/Nome)","TIMEZONES__AMERICA_ADAK":"United States: Hawaii-Aleutian Time (America/Adak)","TIMEZONES__PACIFIC_HONOLULU":"United States: Hawaii-Aleutian Time (Pacific/Honolulu)","TIMEZONES__AMERICA_MONTEVIDEO":"Uruguay: Uruguay Time (America/Montevideo)","TIMEZONES__ASIA_SAMARKAND":"Uzbekistan: Uzbekistan Time (Asia/Samarkand)","TIMEZONES__ASIA_TASHKENT":"Uzbekistan: Uzbekistan Time (Asia/Tashkent)","TIMEZONES__EUROPE_VATICAN":"Vatican City: Central European Time (Europe/Vatican)","TIMEZONES__AMERICA_ST_VINCENT":"St Vincent: Atlantic Time (America/St_Vincent)","TIMEZONES__AMERICA_CARACAS":"Venezuela: Venezuela Time (America/Caracas)","TIMEZONES__AMERICA_TORTOLA":"Virgin Islands (UK): Atlantic Time (America/Tortola)","TIMEZONES__AMERICA_ST_THOMAS":"Virgin Islands (US): Atlantic Time (America/St_Thomas)","TIMEZONES__ASIA_HO_CHI_MINH":"Vietnam: Indochina Time (Asia/Ho_Chi_Minh)","TIMEZONES__PACIFIC_EFATE":"Vanuatu: Vanuatu Time (Pacific/Efate)","TIMEZONES__PACIFIC_WALLIS":"Wallis and Futuna: Wallis and Futuna Time (Pacific/Wallis)","TIMEZONES__PACIFIC_APIA":"Samoa (western): Apia Time (Pacific/Apia)","TIMEZONES__ASIA_ADEN":"Yemen: Arabian Time (Asia/Aden)","TIMEZONES__INDIAN_MAYOTTE":"Mayotte: East Africa Time (Indian/Mayotte)","TIMEZONES__AFRICA_JOHANNESBURG":"South Africa: South Africa Standard Time (Africa/Johannesburg)","TIMEZONES__AFRICA_LUSAKA":"Zambia: Central Africa Time (Africa/Lusaka)","TIMEZONES__AFRICA_HARARE":"Zimbabwe: Central Africa Time (Africa/Harare)","COMMON__CLOSE":"Close","CULTURE__EN":"English","CULTURE__RU":"Russian","CULTURE__DE":"German","CONFIGURATION__SIGN_OUT":"Sign out","MESSAGE__ACCOUNT__EMAIL_REQUIRED":"Email is required.","MESSAGE__ACCOUNT__PASSWORD_REQUIRED":"Password is required.","MESSAGE__ACCOUNT__CONFIRM_PASSWORD_REQUIRED":"Password confirmation is required.","MESSAGE__ACCOUNT__TERMS_NOT_ACCEPTED":"Terms and conditions should be accepted.","MESSAGE__ACCOUNT__NAME_REQUIRED":"Name is required.","MESSAGE__ACCOUNT__COMPANY_NAME_REQUIRED":"Company name is required.","MESSAGE__ACCOUNT__TIMEZONE_REQUIRED":"Time zone is required.","MESSAGE__ACCOUNT__PASSWORD_CONFIRMATION_NOT_VALID":"Password confirmation is not valid.","MESSAGE__ACCOUNT__EMAIL_NOT_VALID":"Email is not valid.","FORGOT_PASSWORD__EMAIL_WAS_SENT":"Thank you! If account with specified email exists then message will be sent to this address soon. Please follow the link in the received message to reset your password.","DASHBOARD__CONFIGURATION":"Configuration","DASHBOARD__LIST":"List","DASHBOARD__FORM":"Form","DASHBOARD__TABLE":"Table","DASHBOARD__CATALOG":"Catalog","FORM__FORM":"Form","CONFIGURATION__CONFIGURATION":"Configuration","STATES__ALASKA":"Alaska","STATES__ARIZONA":"Arizona","STATES__ARKANSAS":"Arkansas","STATES__CALIFORNIA":"California","STATES__COLORADO":"Colorado","STATES__CONNECTICUT":"Connecticut","STATES__DELAWARE":"Delaware","COLOR__SILVER":"Silver","COLOR__BLACK":"Black","COLOR__GRAY":"Gray","FORM__TEXTAREA":"Text area","FORM__TEXT":"Text","STATES__ALABAMA":"Alabama","FORM__DROPDOWN":"Dropdown","FORM__CHECKBOX":"Checkbox","FORM__RADIO_BUTTONS":"Radio buttons","FORM__DATE":"Date","FORM__DATE_AND_TIME":"Date and time","ORDINAL__FIRST":"First","ORDINAL__SECOND":"Second","ORDINAL__THIRD":"Third","TABS__1":"Tab 1","FORM__SEGMENTED_CONTROL":"Segmented control","TABS__2":"Tab 2","TABS__3":"Tab 3","FORM__STATE":"State","MESSAGE__FORM__TEXT_REQUIRED":"Enter text.","MESSAGE__FORM__TEXTAREA_REQUIRED":"Enter text.","MESSAGE__FORM__CHECKBOX_REQUIRED":"Check this flag.","MESSAGE__FORM__DROPDOWN_REQUIRED":"Select any value from dropdown.","MESSAGE__FORM__RADIO_REQUIRED":"Choose any option using radio buttons.","MESSAGE__FORM__DATE_REQUIRED":"Enter date.","MESSAGE__FORM__DATETIME_REQUIRED":"Enter date and time.","CONFIGURATION__TIMEZONE":"Time zone","FORM__FORM_SUCCESSFULLY_SAVED":"Form successfully saved.","CONFIGURATION__LANGUAGE":"Language","CONFIGURATION__CONFIRM_SIGNOUT":"Are you sure that you want to sign out?","MESSAGE__LIST__NAME_REQUIRED":"Enter name.","SEX__MALE":"Male","SEX__FEMALE":"Female","LIST__DELETE_ITEM_PROMPT":"Are you sure that you want to delete this item?","LIST__LIST":"List","LIST__ADD":"Add","TABLE__TABLE":"Table","LIST__NAME":"Name","LIST__NEW_ITEM":"New item","TABLE__SEARCH":"Search","TABLE__FOUND":"Found","TABLE__CITY":"City","TABLE__COMPANY":"Company","TABLE__PHONE":"Phone","TABLE__NAME":"Name","CATALOG__OPEN":"Open","CATALOG__CATALOG":"Catalog"}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {"COMMON__CANCEL":"Abbrechen","COMMON__YES":"Ja","COMMON__NO":"Nein","COMMON__SIGN_OUT":"Abmelden","COMMON__SAVE":"Speichern","COMMON__OK":"OK","COMMON__ADD":"Hinzufügen","COMMON__DELETE":"Entfernen","COMMON__DISABLED":"Behindert","COMMON__CREATE":"Erstellen","COMMON__ENABLED":"Aktiviert","COMMON__REORDER":"Neu ordnen","COMMON__HELP":"Hilfe","COMMON__APPLY":"Anwenden","SIGNIN__EMAIL":"E-Mail","SIGNIN__PASSWORD":"Passwort","SIGNIN__SIGN_IN":"Anmelden","SIGNIN__TITLE":"Melden Sie sich an","FORGOT_PASSWORD__BACK_TO_SIGN_IN":"Zurück, um sich anzumelden","FORGOT_PASSWORD__RESET_PASSWORD":"Passwort zurücksetzen","FORGOT_PASSWORD__BACK":"Zurück","FORGOT_PASSWORD__SENDING":"Es wird gesendet...","FORGOT_PASSWORD__SEND":"Senden","FORGOT_PASSWORD__EMAIL":"E-Mail","FORGOT_PASSWORD__ENTER_EMAIL":"Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen des Passworts zu erhalten","SIGNUP__WAITING_FOR_EMAIL_CONFIRMAITON":"Warten auf Bestätigung der E-Mail","SIGNUP__TO_SIGN_IN":"Zur Anmeldeseite","SIGNUP__NEW_ACCOUNT":"Neues Konto","SIGNUP__TO_TERMS_AND_CONDITIONS":"Geschäftsbedingungen","SIGNUP__I_AGREE_TO":"Ich stimme zu","SIGNUP__COMPANY_NAME":"Name der Firma","SIGNUP__ACCOUNT_CREATED":"Konto wurde erfolgreich erstellt. Die Nachricht wurde an Ihre Mailbox gesendet. Bitte bestätigen Sie Ihre E-Mail-Adresse, indem Sie auf den Link in der Nachricht klicken.","SIGNUP__SIGN_UP":"Registrieren","SIGNUP__TIMEZONE":"Zeitzone","SIGNUP__NAME":"Ihr Name","SIGNUP__CONFIRM_PASSWORD":"Bestätigen Sie das Passwort","SIGNUP__PASSWORD":"Passwort","SIGNUP__EMAIL":"E-Mail","SIGNIN__NEED_ACCOUNT":"Brauchen Sie ein Konto?","SIGNIN__FORGOT_PASSWORD":"Haben Sie Ihr Passwort vergessen?","MESSAGE__ACCOUNT__EMAIL_OR_PASSWORD_INVALID":"Ungültige E-Mail oder Passwort.","TIMEZONES__EUROPE_ANDORRA":"Andorra: Mitteleuropäische Zeit (Europe/Andorra)","TIMEZONES__ASIA_DUBAI":"United Arab Emirates: Golf-Zeit (Asia/Dubai)","TIMEZONES__ASIA_KABUL":"Afghanistan: Afghanistan-Zeit (Asia/Kabul)","TIMEZONES__AMERICA_ANTIGUA":"Antigua & Barbuda: Atlantik-Zeit (America/Antigua)","TIMEZONES__AMERICA_ANGUILLA":"Anguilla: Atlantik-Zeit (America/Anguilla)","TIMEZONES__EUROPE_TIRANE":"Albania: Mitteleuropäische Zeit (Europe/Tirane)","TIMEZONES__ASIA_YEREVAN":"Armenia: Armenische Zeit (Asia/Yerevan)","TIMEZONES__AFRICA_LUANDA":"Angola: Westafrikanische Zeit (Africa/Luanda)","TIMEZONES__ANTARCTICA_MCMURDO":"Antarctica: Neuseeland-Zeit (Antarctica/McMurdo)","TIMEZONES__ANTARCTICA_CASEY":"Antarctica: Casey-Zeit (Antarctica/Casey)","TIMEZONES__ANTARCTICA_DAVIS":"Antarctica: Davis-Zeit (Antarctica/Davis)","TIMEZONES__ANTARCTICA_DUMONTDURVILLE":"Antarctica: Dumont-d’Urville-Zeit (Antarctica/DumontDUrville)","TIMEZONES__ANTARCTICA_MAWSON":"Antarctica: Mawson-Zeit (Antarctica/Mawson)","TIMEZONES__ANTARCTICA_PALMER":"Antarctica: Chilenische Zeit (Antarctica/Palmer)","TIMEZONES__ANTARCTICA_ROTHERA":"Antarctica: Rothera-Zeit (Antarctica/Rothera)","TIMEZONES__ANTARCTICA_SYOWA":"Antarctica: Syowa-Zeit (Antarctica/Syowa)","TIMEZONES__ANTARCTICA_TROLL":"Antarctica: Mittlere Greenwich-Zeit (Antarctica/Troll)","TIMEZONES__ANTARCTICA_VOSTOK":"Antarctica: Wostok-Zeit (Antarctica/Vostok)","TIMEZONES__AMERICA_ARGENTINA_BUENOS_AIRES":"Argentina: Argentinische Zeit (America/Argentina/Buenos_Aires)","TIMEZONES__AMERICA_ARGENTINA_CORDOBA":"Argentina: Argentinische Zeit (America/Argentina/Cordoba)","TIMEZONES__AMERICA_ARGENTINA_SALTA":"Argentina: Argentinische Zeit (America/Argentina/Salta)","TIMEZONES__AMERICA_ARGENTINA_JUJUY":"Argentina: Argentinische Zeit (America/Argentina/Jujuy)","TIMEZONES__AMERICA_ARGENTINA_TUCUMAN":"Argentina: Argentinische Zeit (America/Argentina/Tucuman)","TIMEZONES__AMERICA_ARGENTINA_CATAMARCA":"Argentina: Argentinische Zeit (America/Argentina/Catamarca)","TIMEZONES__AMERICA_ARGENTINA_LA_RIOJA":"Argentina: Argentinische Zeit (America/Argentina/La_Rioja)","TIMEZONES__AMERICA_ARGENTINA_SAN_JUAN":"Argentina: Argentinische Zeit (America/Argentina/San_Juan)","TIMEZONES__AMERICA_ARGENTINA_MENDOZA":"Argentina: Argentinische Zeit (America/Argentina/Mendoza)","TIMEZONES__AMERICA_ARGENTINA_SAN_LUIS":"Argentina: Westargentinische Zeit (America/Argentina/San_Luis)","TIMEZONES__AMERICA_ARGENTINA_RIO_GALLEGOS":"Argentina: Argentinische Zeit (America/Argentina/Rio_Gallegos)","TIMEZONES__AMERICA_ARGENTINA_USHUAIA":"Argentina: Argentinische Zeit (America/Argentina/Ushuaia)","TIMEZONES__PACIFIC_PAGO_PAGO":"Samoa (American): Samoa-Zeit (Pacific/Pago_Pago)","TIMEZONES__EUROPE_VIENNA":"Austria: Mitteleuropäische Zeit (Europe/Vienna)","TIMEZONES__AUSTRALIA_LORD_HOWE":"Australia: Lord-Howe-Zeit (Australia/Lord_Howe)","TIMEZONES__ANTARCTICA_MACQUARIE":"Australia: Macquarieinsel-Zeit (Antarctica/Macquarie)","TIMEZONES__AUSTRALIA_HOBART":"Australia: Ostaustralische Zeit (Australia/Hobart)","TIMEZONES__AUSTRALIA_CURRIE":"Australia: Ostaustralische Zeit (Australia/Currie)","TIMEZONES__AUSTRALIA_MELBOURNE":"Australia: Ostaustralische Zeit (Australia/Melbourne)","TIMEZONES__AUSTRALIA_SYDNEY":"Australia: Ostaustralische Zeit (Australia/Sydney)","TIMEZONES__AUSTRALIA_BROKEN_HILL":"Australia: Zentralaustralische Zeit (Australia/Broken_Hill)","TIMEZONES__AUSTRALIA_BRISBANE":"Australia: Ostaustralische Zeit (Australia/Brisbane)","TIMEZONES__AUSTRALIA_LINDEMAN":"Australia: Ostaustralische Zeit (Australia/Lindeman)","TIMEZONES__AUSTRALIA_ADELAIDE":"Australia: Zentralaustralische Zeit (Australia/Adelaide)","TIMEZONES__AUSTRALIA_DARWIN":"Australia: Zentralaustralische Zeit (Australia/Darwin)","TIMEZONES__AUSTRALIA_PERTH":"Australia: Westaustralische Zeit (Australia/Perth)","TIMEZONES__AUSTRALIA_EUCLA":"Australia: Zentral-/Westaustralische Zeit (Australia/Eucla)","TIMEZONES__AMERICA_ARUBA":"Aruba: Atlantik-Zeit (America/Aruba)","TIMEZONES__EUROPE_MARIEHAMN":"Åland Islands: Osteuropäische Zeit (Europe/Mariehamn)","TIMEZONES__ASIA_BAKU":"Azerbaijan: Aserbaidschanische Zeit (Asia/Baku)","TIMEZONES__EUROPE_SARAJEVO":"Bosnia & Herzegovina: Mitteleuropäische Zeit (Europe/Sarajevo)","TIMEZONES__AMERICA_BARBADOS":"Barbados: Atlantik-Zeit (America/Barbados)","TIMEZONES__ASIA_DHAKA":"Bangladesh: Bangladesch-Zeit (Asia/Dhaka)","TIMEZONES__EUROPE_BRUSSELS":"Belgium: Mitteleuropäische Zeit (Europe/Brussels)","TIMEZONES__AFRICA_OUAGADOUGOU":"Burkina Faso: Mittlere Greenwich-Zeit (Africa/Ouagadougou)","TIMEZONES__EUROPE_SOFIA":"Bulgaria: Osteuropäische Zeit (Europe/Sofia)","TIMEZONES__ASIA_BAHRAIN":"Bahrain: Arabische Zeit (Asia/Bahrain)","TIMEZONES__AFRICA_BUJUMBURA":"Burundi: Zentralafrikanische Zeit (Africa/Bujumbura)","TIMEZONES__AFRICA_PORTO_NOVO":"Benin: Westafrikanische Zeit (Africa/Porto-Novo)","TIMEZONES__AMERICA_ST_BARTHELEMY":"St Barthelemy: Atlantik-Zeit (America/St_Barthelemy)","TIMEZONES__ATLANTIC_BERMUDA":"Bermuda: Atlantik-Zeit (Atlantic/Bermuda)","TIMEZONES__ASIA_BRUNEI":"Brunei: Brunei-Zeit (Asia/Brunei)","TIMEZONES__AMERICA_LA_PAZ":"Bolivia: Bolivianische Zeit (America/La_Paz)","TIMEZONES__AMERICA_KRALENDIJK":"Caribbean NL: Atlantik-Zeit (America/Kralendijk)","TIMEZONES__AMERICA_NORONHA":"Brazil: Fernando de Noronha-Zeit (America/Noronha)","TIMEZONES__AMERICA_BELEM":"Brazil: Brasília-Zeit (America/Belem)","TIMEZONES__AMERICA_FORTALEZA":"Brazil: Brasília-Zeit (America/Fortaleza)","TIMEZONES__AMERICA_RECIFE":"Brazil: Brasília-Zeit (America/Recife)","TIMEZONES__AMERICA_ARAGUAINA":"Brazil: Brasília-Zeit (America/Araguaina)","TIMEZONES__AMERICA_MACEIO":"Brazil: Brasília-Zeit (America/Maceio)","TIMEZONES__AMERICA_BAHIA":"Brazil: Brasília-Zeit (America/Bahia)","TIMEZONES__AMERICA_SAO_PAULO":"Brazil: Brasília-Zeit (America/Sao_Paulo)","TIMEZONES__AMERICA_CAMPO_GRANDE":"Brazil: Amazonas-Zeit (America/Campo_Grande)","TIMEZONES__AMERICA_CUIABA":"Brazil: Amazonas-Zeit (America/Cuiaba)","TIMEZONES__AMERICA_SANTAREM":"Brazil: Brasília-Zeit (America/Santarem)","TIMEZONES__AMERICA_PORTO_VELHO":"Brazil: Amazonas-Zeit (America/Porto_Velho)","TIMEZONES__AMERICA_BOA_VISTA":"Brazil: Amazonas-Zeit (America/Boa_Vista)","TIMEZONES__AMERICA_MANAUS":"Brazil: Amazonas-Zeit (America/Manaus)","TIMEZONES__AMERICA_EIRUNEPE":"Brazil: Acre-Zeit (America/Eirunepe)","TIMEZONES__AMERICA_RIO_BRANCO":"Brazil: Acre-Zeit (America/Rio_Branco)","TIMEZONES__AMERICA_NASSAU":"Bahamas: Nordamerikanische Ostküstenzeit (America/Nassau)","TIMEZONES__ASIA_THIMPHU":"Bhutan: Bhutan-Zeit (Asia/Thimphu)","TIMEZONES__AFRICA_GABORONE":"Botswana: Zentralafrikanische Zeit (Africa/Gaborone)","TIMEZONES__EUROPE_MINSK":"Belarus: Moskauer Zeit (Europe/Minsk)","TIMEZONES__AMERICA_BELIZE":"Belize: Nordamerikanische Inlandzeit (America/Belize)","TIMEZONES__AMERICA_ST_JOHNS":"Canada: Neufundland-Zeit (America/St_Johns)","TIMEZONES__AMERICA_HALIFAX":"Canada: Atlantik-Zeit (America/Halifax)","TIMEZONES__AMERICA_GLACE_BAY":"Canada: Atlantik-Zeit (America/Glace_Bay)","TIMEZONES__AMERICA_MONCTON":"Canada: Atlantik-Zeit (America/Moncton)","TIMEZONES__AMERICA_GOOSE_BAY":"Canada: Atlantik-Zeit (America/Goose_Bay)","TIMEZONES__AMERICA_BLANC_SABLON":"Canada: Atlantik-Zeit (America/Blanc-Sablon)","TIMEZONES__AMERICA_TORONTO":"Canada: Nordamerikanische Ostküstenzeit (America/Toronto)","TIMEZONES__AMERICA_NIPIGON":"Canada: Nordamerikanische Ostküstenzeit (America/Nipigon)","TIMEZONES__AMERICA_THUNDER_BAY":"Canada: Nordamerikanische Ostküstenzeit (America/Thunder_Bay)","TIMEZONES__AMERICA_IQALUIT":"Canada: Nordamerikanische Ostküstenzeit (America/Iqaluit)","TIMEZONES__AMERICA_PANGNIRTUNG":"Canada: Nordamerikanische Ostküstenzeit (America/Pangnirtung)","TIMEZONES__AMERICA_ATIKOKAN":"Canada: Nordamerikanische Ostküstenzeit (America/Atikokan)","TIMEZONES__AMERICA_WINNIPEG":"Canada: Nordamerikanische Inlandzeit (America/Winnipeg)","TIMEZONES__AMERICA_RAINY_RIVER":"Canada: Nordamerikanische Inlandzeit (America/Rainy_River)","TIMEZONES__AMERICA_RESOLUTE":"Canada: Nordamerikanische Inlandzeit (America/Resolute)","TIMEZONES__AMERICA_RANKIN_INLET":"Canada: Nordamerikanische Inlandzeit (America/Rankin_Inlet)","TIMEZONES__AMERICA_REGINA":"Canada: Nordamerikanische Inlandzeit (America/Regina)","TIMEZONES__AMERICA_SWIFT_CURRENT":"Canada: Nordamerikanische Inlandzeit (America/Swift_Current)","TIMEZONES__AMERICA_EDMONTON":"Canada: Rocky-Mountain-Zeit (America/Edmonton)","TIMEZONES__AMERICA_CAMBRIDGE_BAY":"Canada: Rocky-Mountain-Zeit (America/Cambridge_Bay)","TIMEZONES__AMERICA_YELLOWKNIFE":"Canada: Rocky-Mountain-Zeit (America/Yellowknife)","TIMEZONES__AMERICA_INUVIK":"Canada: Rocky-Mountain-Zeit (America/Inuvik)","TIMEZONES__AMERICA_CRESTON":"Canada: Rocky-Mountain-Zeit (America/Creston)","TIMEZONES__AMERICA_DAWSON_CREEK":"Canada: Rocky-Mountain-Zeit (America/Dawson_Creek)","TIMEZONES__AMERICA_VANCOUVER":"Canada: Nordamerikanische Westküstenzeit (America/Vancouver)","TIMEZONES__AMERICA_WHITEHORSE":"Canada: Nordamerikanische Westküstenzeit (America/Whitehorse)","TIMEZONES__AMERICA_DAWSON":"Canada: Nordamerikanische Westküstenzeit (America/Dawson)","TIMEZONES__INDIAN_COCOS":"Cocos (Keeling) Islands: Kokosinseln-Zeit (Indian/Cocos)","TIMEZONES__AFRICA_KINSHASA":"Congo (Dem. Rep.): Westafrikanische Zeit (Africa/Kinshasa)","TIMEZONES__AFRICA_LUBUMBASHI":"Congo (Dem. Rep.): Zentralafrikanische Zeit (Africa/Lubumbashi)","TIMEZONES__AFRICA_BANGUI":"Central African Rep.: Westafrikanische Zeit (Africa/Bangui)","TIMEZONES__AFRICA_BRAZZAVILLE":"Congo (Rep.): Westafrikanische Zeit (Africa/Brazzaville)","TIMEZONES__EUROPE_ZURICH":"Switzerland: Mitteleuropäische Zeit (Europe/Zurich)","TIMEZONES__AFRICA_ABIDJAN":"Côte d'Ivoire: Mittlere Greenwich-Zeit (Africa/Abidjan)","TIMEZONES__PACIFIC_RAROTONGA":"Cook Islands: Cookinseln-Zeit (Pacific/Rarotonga)","TIMEZONES__AMERICA_SANTIAGO":"Chile: Chilenische Zeit (America/Santiago)","TIMEZONES__PACIFIC_EASTER":"Chile: Osterinsel-Zeit (Pacific/Easter)","TIMEZONES__AFRICA_DOUALA":"Cameroon: Westafrikanische Zeit (Africa/Douala)","TIMEZONES__ASIA_SHANGHAI":"China: Chinesische Zeit (Asia/Shanghai)","TIMEZONES__ASIA_URUMQI":"China: China Zeit (Asia/Urumqi)","TIMEZONES__AMERICA_BOGOTA":"Colombia: Kolumbianische Zeit (America/Bogota)","TIMEZONES__AMERICA_COSTA_RICA":"Costa Rica: Nordamerikanische Inlandzeit (America/Costa_Rica)","TIMEZONES__AMERICA_HAVANA":"Cuba: Kubanische Zeit (America/Havana)","TIMEZONES__ATLANTIC_CAPE_VERDE":"Cape Verde: Cabo-Verde-Zeit (Atlantic/Cape_Verde)","TIMEZONES__AMERICA_CURACAO":"Curacao: Atlantik-Zeit (America/Curacao)","TIMEZONES__INDIAN_CHRISTMAS":"Christmas Island: Weihnachtsinsel-Zeit (Indian/Christmas)","TIMEZONES__ASIA_NICOSIA":"Cyprus: Osteuropäische Zeit (Asia/Nicosia)","TIMEZONES__EUROPE_PRAGUE":"Czech Republic: Mitteleuropäische Zeit (Europe/Prague)","TIMEZONES__EUROPE_BERLIN":"Germany: Mitteleuropäische Zeit (Europe/Berlin)","TIMEZONES__EUROPE_BUSINGEN":"Germany: Mitteleuropäische Zeit (Europe/Busingen)","TIMEZONES__AFRICA_DJIBOUTI":"Djibouti: Ostafrikanische Zeit (Africa/Djibouti)","TIMEZONES__EUROPE_COPENHAGEN":"Denmark: Mitteleuropäische Zeit (Europe/Copenhagen)","TIMEZONES__AMERICA_DOMINICA":"Dominica: Atlantik-Zeit (America/Dominica)","TIMEZONES__AMERICA_SANTO_DOMINGO":"Dominican Republic: Atlantik-Zeit (America/Santo_Domingo)","TIMEZONES__AFRICA_ALGIERS":"Algeria: Mitteleuropäische Zeit (Africa/Algiers)","TIMEZONES__AMERICA_GUAYAQUIL":"Ecuador: Ecuadorianische Zeit (America/Guayaquil)","TIMEZONES__PACIFIC_GALAPAGOS":"Ecuador: Galapagos-Zeit (Pacific/Galapagos)","TIMEZONES__EUROPE_TALLINN":"Estonia: Osteuropäische Zeit (Europe/Tallinn)","TIMEZONES__AFRICA_CAIRO":"Egypt: Osteuropäische Zeit (Africa/Cairo)","TIMEZONES__AFRICA_EL_AAIUN":"Western Sahara: Westeuropäische Zeit (Africa/El_Aaiun)","TIMEZONES__AFRICA_ASMARA":"Eritrea: Ostafrikanische Zeit (Africa/Asmara)","TIMEZONES__EUROPE_MADRID":"Spain: Mitteleuropäische Zeit (Europe/Madrid)","TIMEZONES__AFRICA_CEUTA":"Spain: Mitteleuropäische Zeit (Africa/Ceuta)","TIMEZONES__ATLANTIC_CANARY":"Spain: Westeuropäische Zeit (Atlantic/Canary)","TIMEZONES__AFRICA_ADDIS_ABABA":"Ethiopia: Ostafrikanische Zeit (Africa/Addis_Ababa)","TIMEZONES__EUROPE_HELSINKI":"Finland: Osteuropäische Zeit (Europe/Helsinki)","TIMEZONES__PACIFIC_FIJI":"Fiji: Fidschi-Zeit (Pacific/Fiji)","TIMEZONES__ATLANTIC_STANLEY":"Falkland Islands: Falklandinseln-Zeit (Atlantic/Stanley)","TIMEZONES__PACIFIC_CHUUK":"Micronesia: Chuuk-Zeit (Pacific/Chuuk)","TIMEZONES__PACIFIC_POHNPEI":"Micronesia: Ponape-Zeit (Pacific/Pohnpei)","TIMEZONES__PACIFIC_KOSRAE":"Micronesia: Kosrae-Zeit (Pacific/Kosrae)","TIMEZONES__ATLANTIC_FAROE":"Faroe Islands: Westeuropäische Zeit (Atlantic/Faroe)","TIMEZONES__EUROPE_PARIS":"France: Mitteleuropäische Zeit (Europe/Paris)","TIMEZONES__AFRICA_LIBREVILLE":"Gabon: Westafrikanische Zeit (Africa/Libreville)","TIMEZONES__EUROPE_LONDON":"Britain (UK): Vereinigtes Königreich Zeit (Europe/London)","TIMEZONES__AMERICA_GRENADA":"Grenada: Atlantik-Zeit (America/Grenada)","TIMEZONES__ASIA_TBILISI":"Georgia: Georgische Zeit (Asia/Tbilisi)","TIMEZONES__AMERICA_CAYENNE":"French Guiana: Französisch-Guayana-Zeit (America/Cayenne)","TIMEZONES__EUROPE_GUERNSEY":"Guernsey: Mittlere Greenwich-Zeit (Europe/Guernsey)","TIMEZONES__AFRICA_ACCRA":"Ghana: Mittlere Greenwich-Zeit (Africa/Accra)","TIMEZONES__EUROPE_GIBRALTAR":"Gibraltar: Mitteleuropäische Zeit (Europe/Gibraltar)","TIMEZONES__AMERICA_GODTHAB":"Greenland: Westgrönland-Zeit (America/Godthab)","TIMEZONES__AMERICA_DANMARKSHAVN":"Greenland: Mittlere Greenwich-Zeit (America/Danmarkshavn)","TIMEZONES__AMERICA_SCORESBYSUND":"Greenland: Ostgrönland-Zeit (America/Scoresbysund)","TIMEZONES__AMERICA_THULE":"Greenland: Atlantik-Zeit (America/Thule)","TIMEZONES__AFRICA_BANJUL":"Gambia: Mittlere Greenwich-Zeit (Africa/Banjul)","TIMEZONES__AFRICA_CONAKRY":"Guinea: Mittlere Greenwich-Zeit (Africa/Conakry)","TIMEZONES__AMERICA_GUADELOUPE":"Guadeloupe: Atlantik-Zeit (America/Guadeloupe)","TIMEZONES__AFRICA_MALABO":"Equatorial Guinea: Westafrikanische Zeit (Africa/Malabo)","TIMEZONES__EUROPE_ATHENS":"Greece: Osteuropäische Zeit (Europe/Athens)","TIMEZONES__ATLANTIC_SOUTH_GEORGIA":"South Georgia & the South Sandwich Islands: Südgeorgische Zeit (Atlantic/South_Georgia)","TIMEZONES__AMERICA_GUATEMALA":"Guatemala: Nordamerikanische Inlandzeit (America/Guatemala)","TIMEZONES__PACIFIC_GUAM":"Guam: Chamorro-Zeit (Pacific/Guam)","TIMEZONES__AFRICA_BISSAU":"Guinea-Bissau: Mittlere Greenwich-Zeit (Africa/Bissau)","TIMEZONES__AMERICA_GUYANA":"Guyana: Guyana-Zeit (America/Guyana)","TIMEZONES__ASIA_HONG_KONG":"Hong Kong: Hongkong-Zeit (Asia/Hong_Kong)","TIMEZONES__AMERICA_TEGUCIGALPA":"Honduras: Nordamerikanische Inlandzeit (America/Tegucigalpa)","TIMEZONES__EUROPE_ZAGREB":"Croatia: Mitteleuropäische Zeit (Europe/Zagreb)","TIMEZONES__AMERICA_PORT_AU_PRINCE":"Haiti: Nordamerikanische Ostküstenzeit (America/Port-au-Prince)","TIMEZONES__EUROPE_BUDAPEST":"Hungary: Mitteleuropäische Zeit (Europe/Budapest)","TIMEZONES__ASIA_JAKARTA":"Indonesia: Westindonesische Zeit (Asia/Jakarta)","TIMEZONES__ASIA_PONTIANAK":"Indonesia: Westindonesische Zeit (Asia/Pontianak)","TIMEZONES__ASIA_MAKASSAR":"Indonesia: Zentralindonesische Zeit (Asia/Makassar)","TIMEZONES__ASIA_JAYAPURA":"Indonesia: Ostindonesische Zeit (Asia/Jayapura)","TIMEZONES__EUROPE_DUBLIN":"Ireland: Irland Zeit (Europe/Dublin)","TIMEZONES__ASIA_JERUSALEM":"Israel: Israelische Zeit (Asia/Jerusalem)","TIMEZONES__EUROPE_ISLE_OF_MAN":"Isle of Man: Mittlere Greenwich-Zeit (Europe/Isle_of_Man)","TIMEZONES__ASIA_KOLKATA":"India: Indische Zeit (Asia/Kolkata)","TIMEZONES__INDIAN_CHAGOS":"British Indian Ocean Territory: Indischer Ozean-Zeit (Indian/Chagos)","TIMEZONES__ASIA_BAGHDAD":"Iraq: Arabische Zeit (Asia/Baghdad)","TIMEZONES__ASIA_TEHRAN":"Iran: Iranische Zeit (Asia/Tehran)","TIMEZONES__ATLANTIC_REYKJAVIK":"Iceland: Mittlere Greenwich-Zeit (Atlantic/Reykjavik)","TIMEZONES__EUROPE_ROME":"Italy: Mitteleuropäische Zeit (Europe/Rome)","TIMEZONES__EUROPE_JERSEY":"Jersey: Mittlere Greenwich-Zeit (Europe/Jersey)","TIMEZONES__AMERICA_JAMAICA":"Jamaica: Nordamerikanische Ostküstenzeit (America/Jamaica)","TIMEZONES__ASIA_AMMAN":"Jordan: Osteuropäische Zeit (Asia/Amman)","TIMEZONES__ASIA_TOKYO":"Japan: Japanische Zeit (Asia/Tokyo)","TIMEZONES__AFRICA_NAIROBI":"Kenya: Ostafrikanische Zeit (Africa/Nairobi)","TIMEZONES__ASIA_BISHKEK":"Kyrgyzstan: Kirgisistan-Zeit (Asia/Bishkek)","TIMEZONES__ASIA_PHNOM_PENH":"Cambodia: Indochina-Zeit (Asia/Phnom_Penh)","TIMEZONES__PACIFIC_TARAWA":"Kiribati: Gilbert-Inseln-Zeit (Pacific/Tarawa)","TIMEZONES__PACIFIC_ENDERBURY":"Kiribati: Phoenixinseln-Zeit (Pacific/Enderbury)","TIMEZONES__PACIFIC_KIRITIMATI":"Kiribati: Linieninseln-Zeit (Pacific/Kiritimati)","TIMEZONES__INDIAN_COMORO":"Comoros: Ostafrikanische Zeit (Indian/Comoro)","TIMEZONES__AMERICA_ST_KITTS":"St Kitts & Nevis: Atlantik-Zeit (America/St_Kitts)","TIMEZONES__ASIA_PYONGYANG":"Korea (North): Pjöngjang-Zeit (Asia/Pyongyang)","TIMEZONES__ASIA_SEOUL":"Korea (South): Koreanische Zeit (Asia/Seoul)","TIMEZONES__ASIA_KUWAIT":"Kuwait: Arabische Zeit (Asia/Kuwait)","TIMEZONES__AMERICA_CAYMAN":"Cayman Islands: Nordamerikanische Ostküstenzeit (America/Cayman)","TIMEZONES__ASIA_ALMATY":"Kazakhstan: Ostkasachische Zeit (Asia/Almaty)","TIMEZONES__ASIA_QYZYLORDA":"Kazakhstan: Ostkasachische Zeit (Asia/Qyzylorda)","TIMEZONES__ASIA_AQTOBE":"Kazakhstan: Westkasachische Zeit (Asia/Aqtobe)","TIMEZONES__ASIA_AQTAU":"Kazakhstan: Westkasachische Zeit (Asia/Aqtau)","TIMEZONES__ASIA_ORAL":"Kazakhstan: Westkasachische Zeit (Asia/Oral)","TIMEZONES__ASIA_VIENTIANE":"Laos: Indochina-Zeit (Asia/Vientiane)","TIMEZONES__ASIA_BEIRUT":"Lebanon: Osteuropäische Zeit (Asia/Beirut)","TIMEZONES__AMERICA_ST_LUCIA":"St Lucia: Atlantik-Zeit (America/St_Lucia)","TIMEZONES__EUROPE_VADUZ":"Liechtenstein: Mitteleuropäische Zeit (Europe/Vaduz)","TIMEZONES__ASIA_COLOMBO":"Sri Lanka: Indische Zeit (Asia/Colombo)","TIMEZONES__AFRICA_MONROVIA":"Liberia: Mittlere Greenwich-Zeit (Africa/Monrovia)","TIMEZONES__AFRICA_MASERU":"Lesotho: Südafrikanische Zeit (Africa/Maseru)","TIMEZONES__EUROPE_VILNIUS":"Lithuania: Osteuropäische Zeit (Europe/Vilnius)","TIMEZONES__EUROPE_LUXEMBOURG":"Luxembourg: Mitteleuropäische Zeit (Europe/Luxembourg)","TIMEZONES__EUROPE_RIGA":"Latvia: Osteuropäische Zeit (Europe/Riga)","TIMEZONES__AFRICA_TRIPOLI":"Libya: Osteuropäische Zeit (Africa/Tripoli)","TIMEZONES__AFRICA_CASABLANCA":"Morocco: Westeuropäische Zeit (Africa/Casablanca)","TIMEZONES__EUROPE_MONACO":"Monaco: Mitteleuropäische Zeit (Europe/Monaco)","TIMEZONES__EUROPE_CHISINAU":"Moldova: Osteuropäische Zeit (Europe/Chisinau)","TIMEZONES__EUROPE_PODGORICA":"Montenegro: Mitteleuropäische Zeit (Europe/Podgorica)","TIMEZONES__AMERICA_MARIGOT":"St Martin (French): Atlantik-Zeit (America/Marigot)","TIMEZONES__INDIAN_ANTANANARIVO":"Madagascar: Ostafrikanische Zeit (Indian/Antananarivo)","TIMEZONES__PACIFIC_MAJURO":"Marshall Islands: Marshallinseln-Zeit (Pacific/Majuro)","TIMEZONES__PACIFIC_KWAJALEIN":"Marshall Islands: Marshallinseln-Zeit (Pacific/Kwajalein)","TIMEZONES__EUROPE_SKOPJE":"Macedonia: Mitteleuropäische Zeit (Europe/Skopje)","TIMEZONES__AFRICA_BAMAKO":"Mali: Mittlere Greenwich-Zeit (Africa/Bamako)","TIMEZONES__ASIA_RANGOON":"Myanmar (Burma): Myanmar-Zeit (Asia/Rangoon)","TIMEZONES__ASIA_ULAANBAATAR":"Mongolia: Ulaanbaatar-Zeit (Asia/Ulaanbaatar)","TIMEZONES__ASIA_HOVD":"Mongolia: Chowd-Zeit (Asia/Hovd)","TIMEZONES__ASIA_CHOIBALSAN":"Mongolia: Tschoibalsan-Zeit (Asia/Choibalsan)","TIMEZONES__ASIA_MACAU":"Macau: Chinesische Zeit (Asia/Macau)","TIMEZONES__PACIFIC_SAIPAN":"Northern Mariana Islands: Chamorro-Zeit (Pacific/Saipan)","TIMEZONES__AMERICA_MARTINIQUE":"Martinique: Atlantik-Zeit (America/Martinique)","TIMEZONES__AFRICA_NOUAKCHOTT":"Mauritania: Mittlere Greenwich-Zeit (Africa/Nouakchott)","TIMEZONES__AMERICA_MONTSERRAT":"Montserrat: Atlantik-Zeit (America/Montserrat)","TIMEZONES__EUROPE_MALTA":"Malta: Mitteleuropäische Zeit (Europe/Malta)","TIMEZONES__INDIAN_MAURITIUS":"Mauritius: Mauritius-Zeit (Indian/Mauritius)","TIMEZONES__INDIAN_MALDIVES":"Maldives: Malediven-Zeit (Indian/Maldives)","TIMEZONES__AFRICA_BLANTYRE":"Malawi: Zentralafrikanische Zeit (Africa/Blantyre)","TIMEZONES__AMERICA_MEXICO_CITY":"Mexico: Nordamerikanische Inlandzeit (America/Mexico_City)","TIMEZONES__AMERICA_CANCUN":"Mexico: Nordamerikanische Ostküstenzeit (America/Cancun)","TIMEZONES__AMERICA_MERIDA":"Mexico: Nordamerikanische Inlandzeit (America/Merida)","TIMEZONES__AMERICA_MONTERREY":"Mexico: Nordamerikanische Inlandzeit (America/Monterrey)","TIMEZONES__AMERICA_MATAMOROS":"Mexico: Nordamerikanische Inlandzeit (America/Matamoros)","TIMEZONES__AMERICA_MAZATLAN":"Mexico: Mexiko Pazifikzone-Zeit (America/Mazatlan)","TIMEZONES__AMERICA_CHIHUAHUA":"Mexico: Mexiko Pazifikzone-Zeit (America/Chihuahua)","TIMEZONES__AMERICA_OJINAGA":"Mexico: Rocky-Mountain-Zeit (America/Ojinaga)","TIMEZONES__AMERICA_HERMOSILLO":"Mexico: Mexiko Pazifikzone-Zeit (America/Hermosillo)","TIMEZONES__AMERICA_TIJUANA":"Mexico: Nordamerikanische Westküstenzeit (America/Tijuana)","TIMEZONES__AMERICA_BAHIA_BANDERAS":"Mexico: Nordamerikanische Inlandzeit (America/Bahia_Banderas)","TIMEZONES__ASIA_KUALA_LUMPUR":"Malaysia: Malaysische Zeit (Asia/Kuala_Lumpur)","TIMEZONES__ASIA_KUCHING":"Malaysia: Malaysische Zeit (Asia/Kuching)","TIMEZONES__AFRICA_MAPUTO":"Mozambique: Zentralafrikanische Zeit (Africa/Maputo)","TIMEZONES__AFRICA_WINDHOEK":"Namibia: Westafrikanische Zeit (Africa/Windhoek)","TIMEZONES__PACIFIC_NOUMEA":"New Caledonia: Neukaledonische Zeit (Pacific/Noumea)","TIMEZONES__AFRICA_NIAMEY":"Niger: Westafrikanische Zeit (Africa/Niamey)","TIMEZONES__PACIFIC_NORFOLK":"Norfolk Island: Norfolkinsel-Zeit (Pacific/Norfolk)","TIMEZONES__AFRICA_LAGOS":"Nigeria: Westafrikanische Zeit (Africa/Lagos)","TIMEZONES__AMERICA_MANAGUA":"Nicaragua: Nordamerikanische Inlandzeit (America/Managua)","TIMEZONES__EUROPE_AMSTERDAM":"Netherlands: Mitteleuropäische Zeit (Europe/Amsterdam)","TIMEZONES__EUROPE_OSLO":"Norway: Mitteleuropäische Zeit (Europe/Oslo)","TIMEZONES__ASIA_KATHMANDU":"Nepal: Nepalesische Zeit (Asia/Kathmandu)","TIMEZONES__PACIFIC_NAURU":"Nauru: Nauru-Zeit (Pacific/Nauru)","TIMEZONES__PACIFIC_NIUE":"Niue: Niue-Zeit (Pacific/Niue)","TIMEZONES__PACIFIC_AUCKLAND":"New Zealand: Neuseeland-Zeit (Pacific/Auckland)","TIMEZONES__PACIFIC_CHATHAM":"New Zealand: Chatham-Zeit (Pacific/Chatham)","TIMEZONES__ASIA_MUSCAT":"Oman: Golf-Zeit (Asia/Muscat)","TIMEZONES__AMERICA_PANAMA":"Panama: Nordamerikanische Ostküstenzeit (America/Panama)","TIMEZONES__AMERICA_LIMA":"Peru: Peruanische Zeit (America/Lima)","TIMEZONES__PACIFIC_TAHITI":"French Polynesia: Tahiti-Zeit (Pacific/Tahiti)","TIMEZONES__PACIFIC_MARQUESAS":"French Polynesia: Marquesas-Zeit (Pacific/Marquesas)","TIMEZONES__PACIFIC_GAMBIER":"French Polynesia: Gambier-Zeit (Pacific/Gambier)","TIMEZONES__PACIFIC_PORT_MORESBY":"Papua New Guinea: Papua-Neuguinea-Zeit (Pacific/Port_Moresby)","TIMEZONES__PACIFIC_BOUGAINVILLE":"Papua New Guinea: Papua-Neuguinea-Zeit (Pacific/Bougainville)","TIMEZONES__ASIA_MANILA":"Philippines: Philippinische Zeit (Asia/Manila)","TIMEZONES__ASIA_KARACHI":"Pakistan: Pakistanische Zeit (Asia/Karachi)","TIMEZONES__EUROPE_WARSAW":"Poland: Mitteleuropäische Zeit (Europe/Warsaw)","TIMEZONES__AMERICA_MIQUELON":"St Pierre & Miquelon: Saint-Pierre-und-Miquelon-Zeit (America/Miquelon)","TIMEZONES__PACIFIC_PITCAIRN":"Pitcairn: Pitcairninseln-Zeit (Pacific/Pitcairn)","TIMEZONES__AMERICA_PUERTO_RICO":"Puerto Rico: Atlantik-Zeit (America/Puerto_Rico)","TIMEZONES__ASIA_GAZA":"Palestine: Osteuropäische Zeit (Asia/Gaza)","TIMEZONES__ASIA_HEBRON":"Palestine: Osteuropäische Zeit (Asia/Hebron)","TIMEZONES__EUROPE_LISBON":"Portugal: Westeuropäische Zeit (Europe/Lisbon)","TIMEZONES__ATLANTIC_MADEIRA":"Portugal: Westeuropäische Zeit (Atlantic/Madeira)","TIMEZONES__ATLANTIC_AZORES":"Portugal: Azoren-Zeit (Atlantic/Azores)","TIMEZONES__PACIFIC_PALAU":"Palau: Palau-Zeit (Pacific/Palau)","TIMEZONES__AMERICA_ASUNCION":"Paraguay: Paraguayanische Zeit (America/Asuncion)","TIMEZONES__ASIA_QATAR":"Qatar: Arabische Zeit (Asia/Qatar)","TIMEZONES__INDIAN_REUNION":"Réunion: Réunion-Zeit (Indian/Reunion)","TIMEZONES__EUROPE_BUCHAREST":"Romania: Osteuropäische Zeit (Europe/Bucharest)","TIMEZONES__EUROPE_BELGRADE":"Serbia: Mitteleuropäische Zeit (Europe/Belgrade)","TIMEZONES__EUROPE_KALININGRAD":"Russia: Kaliningrad Zeit (Europe/Kaliningrad)","TIMEZONES__EUROPE_MOSCOW":"Russia: Moskau Zeit (Europe/Moscow)","TIMEZONES__EUROPE_SIMFEROPOL":"Russia: Simferopol Zeit (Europe/Simferopol)","TIMEZONES__EUROPE_VOLGOGRAD":"Russia: Wolgograd Zeit (Europe/Volgograd)","TIMEZONES__EUROPE_SAMARA":"Russia: Samara Zeit (Europe/Samara)","TIMEZONES__ASIA_YEKATERINBURG":"Russia: Jekaterinburg Zeit (Asia/Yekaterinburg)","TIMEZONES__ASIA_OMSK":"Russia: Omsk Zeit (Asia/Omsk)","TIMEZONES__ASIA_NOVOSIBIRSK":"Russia: Nowosibirsk Zeit (Asia/Novosibirsk)","TIMEZONES__ASIA_NOVOKUZNETSK":"Russia: Nowokuznetsk Zeit (Asia/Novokuznetsk)","TIMEZONES__ASIA_KRASNOYARSK":"Russia: Krasnojarsk Zeit (Asia/Krasnoyarsk)","TIMEZONES__ASIA_IRKUTSK":"Russia: Irkutsk Zeit (Asia/Irkutsk)","TIMEZONES__ASIA_CHITA":"Russia: Tschita Zeit (Asia/Chita)","TIMEZONES__ASIA_YAKUTSK":"Russia: Jakutsk Zeit (Asia/Yakutsk)","TIMEZONES__ASIA_KHANDYGA":"Russia: Chandyga Zeit (Asia/Khandyga)","TIMEZONES__ASIA_VLADIVOSTOK":"Russia: Wladiwostok Zeit (Asia/Vladivostok)","TIMEZONES__ASIA_UST_NERA":"Russia: Ust-Nera Zeit (Asia/Ust-Nera)","TIMEZONES__ASIA_MAGADAN":"Russia: Magadan Zeit (Asia/Magadan)","TIMEZONES__ASIA_SAKHALIN":"Russia: Sachalin Zeit (Asia/Sakhalin)","TIMEZONES__ASIA_SREDNEKOLYMSK":"Russia: Srednekolymsk Zeit (Asia/Srednekolymsk)","TIMEZONES__ASIA_KAMCHATKA":"Russia: Kamtschatka Zeit (Asia/Kamchatka)","TIMEZONES__ASIA_ANADYR":"Russia: Anadyr Zeit (Asia/Anadyr)","TIMEZONES__AFRICA_KIGALI":"Rwanda: Zentralafrikanische Zeit (Africa/Kigali)","TIMEZONES__ASIA_RIYADH":"Saudi Arabia: Arabische Zeit (Asia/Riyadh)","TIMEZONES__PACIFIC_GUADALCANAL":"Solomon Islands: Salomoninseln-Zeit (Pacific/Guadalcanal)","TIMEZONES__INDIAN_MAHE":"Seychelles: Seychellen-Zeit (Indian/Mahe)","TIMEZONES__AFRICA_KHARTOUM":"Sudan: Ostafrikanische Zeit (Africa/Khartoum)","TIMEZONES__EUROPE_STOCKHOLM":"Sweden: Mitteleuropäische Zeit (Europe/Stockholm)","TIMEZONES__ASIA_SINGAPORE":"Singapore: Singapur-Zeit (Asia/Singapore)","TIMEZONES__ATLANTIC_ST_HELENA":"St Helena: Mittlere Greenwich-Zeit (Atlantic/St_Helena)","TIMEZONES__EUROPE_LJUBLJANA":"Slovenia: Mitteleuropäische Zeit (Europe/Ljubljana)","TIMEZONES__ARCTIC_LONGYEARBYEN":"Svalbard & Jan Mayen: Mitteleuropäische Zeit (Arctic/Longyearbyen)","TIMEZONES__EUROPE_BRATISLAVA":"Slovakia: Mitteleuropäische Zeit (Europe/Bratislava)","TIMEZONES__AFRICA_FREETOWN":"Sierra Leone: Mittlere Greenwich-Zeit (Africa/Freetown)","TIMEZONES__EUROPE_SAN_MARINO":"San Marino: Mitteleuropäische Zeit (Europe/San_Marino)","TIMEZONES__AFRICA_DAKAR":"Senegal: Mittlere Greenwich-Zeit (Africa/Dakar)","TIMEZONES__AFRICA_MOGADISHU":"Somalia: Ostafrikanische Zeit (Africa/Mogadishu)","TIMEZONES__AMERICA_PARAMARIBO":"Suriname: Suriname-Zeit (America/Paramaribo)","TIMEZONES__AFRICA_JUBA":"South Sudan: Ostafrikanische Zeit (Africa/Juba)","TIMEZONES__AFRICA_SAO_TOME":"Sao Tome & Principe: Mittlere Greenwich-Zeit (Africa/Sao_Tome)","TIMEZONES__AMERICA_EL_SALVADOR":"El Salvador: Nordamerikanische Inlandzeit (America/El_Salvador)","TIMEZONES__AMERICA_LOWER_PRINCES":"St Maarten (Dutch): Atlantik-Zeit (America/Lower_Princes)","TIMEZONES__ASIA_DAMASCUS":"Syria: Osteuropäische Zeit (Asia/Damascus)","TIMEZONES__AFRICA_MBABANE":"Swaziland: Südafrikanische Zeit (Africa/Mbabane)","TIMEZONES__AMERICA_GRAND_TURK":"Turks & Caicos Is: Atlantik-Zeit (America/Grand_Turk)","TIMEZONES__AFRICA_NDJAMENA":"Chad: Westafrikanische Zeit (Africa/Ndjamena)","TIMEZONES__INDIAN_KERGUELEN":"French Southern & Antarctic Lands: Französische Süd- und Antarktisgebiete-Zeit (Indian/Kerguelen)","TIMEZONES__AFRICA_LOME":"Togo: Mittlere Greenwich-Zeit (Africa/Lome)","TIMEZONES__ASIA_BANGKOK":"Thailand: Indochina-Zeit (Asia/Bangkok)","TIMEZONES__ASIA_DUSHANBE":"Tajikistan: Tadschikistan-Zeit (Asia/Dushanbe)","TIMEZONES__PACIFIC_FAKAOFO":"Tokelau: Tokelau-Zeit (Pacific/Fakaofo)","TIMEZONES__ASIA_DILI":"East Timor: Osttimor-Zeit (Asia/Dili)","TIMEZONES__ASIA_ASHGABAT":"Turkmenistan: Turkmenistan-Zeit (Asia/Ashgabat)","TIMEZONES__AFRICA_TUNIS":"Tunisia: Mitteleuropäische Zeit (Africa/Tunis)","TIMEZONES__PACIFIC_TONGATAPU":"Tonga: Tonganische Zeit (Pacific/Tongatapu)","TIMEZONES__EUROPE_ISTANBUL":"Turkey: Türkei Zeit (Europe/Istanbul)","TIMEZONES__AMERICA_PORT_OF_SPAIN":"Trinidad & Tobago: Atlantik-Zeit (America/Port_of_Spain)","TIMEZONES__PACIFIC_FUNAFUTI":"Tuvalu: Tuvalu-Zeit (Pacific/Funafuti)","TIMEZONES__ASIA_TAIPEI":"Taiwan: Taipeh-Zeit (Asia/Taipei)","TIMEZONES__AFRICA_DAR_ES_SALAAM":"Tanzania: Ostafrikanische Zeit (Africa/Dar_es_Salaam)","TIMEZONES__EUROPE_KIEV":"Ukraine: Osteuropäische Zeit (Europe/Kiev)","TIMEZONES__EUROPE_UZHGOROD":"Ukraine: Osteuropäische Zeit (Europe/Uzhgorod)","TIMEZONES__EUROPE_ZAPOROZHYE":"Ukraine: Osteuropäische Zeit (Europe/Zaporozhye)","TIMEZONES__AFRICA_KAMPALA":"Uganda: Ostafrikanische Zeit (Africa/Kampala)","TIMEZONES__PACIFIC_JOHNSTON":"US minor outlying islands: Hawaii-Aleuten-Zeit (Pacific/Johnston)","TIMEZONES__PACIFIC_MIDWAY":"US minor outlying islands: Samoa-Zeit (Pacific/Midway)","TIMEZONES__PACIFIC_WAKE":"US minor outlying islands: Wake-Insel-Zeit (Pacific/Wake)","TIMEZONES__AMERICA_NEW_YORK":"United States: Nordamerikanische Ostküstenzeit (America/New_York)","TIMEZONES__AMERICA_DETROIT":"United States: Nordamerikanische Ostküstenzeit (America/Detroit)","TIMEZONES__AMERICA_KENTUCKY_LOUISVILLE":"United States: Nordamerikanische Ostküstenzeit (America/Kentucky/Louisville)","TIMEZONES__AMERICA_KENTUCKY_MONTICELLO":"United States: Nordamerikanische Ostküstenzeit (America/Kentucky/Monticello)","TIMEZONES__AMERICA_INDIANA_INDIANAPOLIS":"United States: Nordamerikanische Ostküstenzeit (America/Indiana/Indianapolis)","TIMEZONES__AMERICA_INDIANA_VINCENNES":"United States: Nordamerikanische Ostküstenzeit (America/Indiana/Vincennes)","TIMEZONES__AMERICA_INDIANA_WINAMAC":"United States: Nordamerikanische Ostküstenzeit (America/Indiana/Winamac)","TIMEZONES__AMERICA_INDIANA_MARENGO":"United States: Nordamerikanische Ostküstenzeit (America/Indiana/Marengo)","TIMEZONES__AMERICA_INDIANA_PETERSBURG":"United States: Nordamerikanische Ostküstenzeit (America/Indiana/Petersburg)","TIMEZONES__AMERICA_INDIANA_VEVAY":"United States: Nordamerikanische Ostküstenzeit (America/Indiana/Vevay)","TIMEZONES__AMERICA_CHICAGO":"United States: Nordamerikanische Inlandzeit (America/Chicago)","TIMEZONES__AMERICA_INDIANA_TELL_CITY":"United States: Nordamerikanische Inlandzeit (America/Indiana/Tell_City)","TIMEZONES__AMERICA_INDIANA_KNOX":"United States: Nordamerikanische Inlandzeit (America/Indiana/Knox)","TIMEZONES__AMERICA_MENOMINEE":"United States: Nordamerikanische Inlandzeit (America/Menominee)","TIMEZONES__AMERICA_NORTH_DAKOTA_CENTER":"United States: Nordamerikanische Inlandzeit (America/North_Dakota/Center)","TIMEZONES__AMERICA_NORTH_DAKOTA_NEW_SALEM":"United States: Nordamerikanische Inlandzeit (America/North_Dakota/New_Salem)","TIMEZONES__AMERICA_NORTH_DAKOTA_BEULAH":"United States: Nordamerikanische Inlandzeit (America/North_Dakota/Beulah)","TIMEZONES__AMERICA_DENVER":"United States: Rocky-Mountain-Zeit (America/Denver)","TIMEZONES__AMERICA_BOISE":"United States: Rocky-Mountain-Zeit (America/Boise)","TIMEZONES__AMERICA_PHOENIX":"United States: Rocky-Mountain-Zeit (America/Phoenix)","TIMEZONES__AMERICA_LOS_ANGELES":"United States: Nordamerikanische Westküstenzeit (America/Los_Angeles)","TIMEZONES__AMERICA_ANCHORAGE":"United States: Alaska-Zeit (America/Anchorage)","TIMEZONES__AMERICA_JUNEAU":"United States: Alaska-Zeit (America/Juneau)","TIMEZONES__AMERICA_SITKA":"United States: Alaska-Zeit (America/Sitka)","TIMEZONES__AMERICA_METLAKATLA":"United States: Alaska-Zeit (America/Metlakatla)","TIMEZONES__AMERICA_YAKUTAT":"United States: Alaska-Zeit (America/Yakutat)","TIMEZONES__AMERICA_NOME":"United States: Alaska-Zeit (America/Nome)","TIMEZONES__AMERICA_ADAK":"United States: Hawaii-Aleuten-Zeit (America/Adak)","TIMEZONES__PACIFIC_HONOLULU":"United States: Hawaii-Aleuten-Zeit (Pacific/Honolulu)","TIMEZONES__AMERICA_MONTEVIDEO":"Uruguay: Uruguayanische Zeit (America/Montevideo)","TIMEZONES__ASIA_SAMARKAND":"Uzbekistan: Usbekistan-Zeit (Asia/Samarkand)","TIMEZONES__ASIA_TASHKENT":"Uzbekistan: Usbekistan-Zeit (Asia/Tashkent)","TIMEZONES__EUROPE_VATICAN":"Vatican City: Mitteleuropäische Zeit (Europe/Vatican)","TIMEZONES__AMERICA_ST_VINCENT":"St Vincent: Atlantik-Zeit (America/St_Vincent)","TIMEZONES__AMERICA_CARACAS":"Venezuela: Venezuela-Zeit (America/Caracas)","TIMEZONES__AMERICA_TORTOLA":"Virgin Islands (UK): Atlantik-Zeit (America/Tortola)","TIMEZONES__AMERICA_ST_THOMAS":"Virgin Islands (US): Atlantik-Zeit (America/St_Thomas)","TIMEZONES__ASIA_HO_CHI_MINH":"Vietnam: Indochina-Zeit (Asia/Ho_Chi_Minh)","TIMEZONES__PACIFIC_EFATE":"Vanuatu: Vanuatu-Zeit (Pacific/Efate)","TIMEZONES__PACIFIC_WALLIS":"Wallis & Futuna: Wallis-und-Futuna-Zeit (Pacific/Wallis)","TIMEZONES__PACIFIC_APIA":"Samoa (western): Apia-Zeit (Pacific/Apia)","TIMEZONES__ASIA_ADEN":"Yemen: Arabische Zeit (Asia/Aden)","TIMEZONES__INDIAN_MAYOTTE":"Mayotte: Ostafrikanische Zeit (Indian/Mayotte)","TIMEZONES__AFRICA_JOHANNESBURG":"South Africa: Südafrikanische Zeit (Africa/Johannesburg)","TIMEZONES__AFRICA_LUSAKA":"Zambia: Zentralafrikanische Zeit (Africa/Lusaka)","TIMEZONES__AFRICA_HARARE":"Zimbabwe: Zentralafrikanische Zeit (Africa/Harare)","COMMON__CLOSE":"Beenden","CULTURE__EN":"Englisch","CULTURE__RU":"Russisch","CULTURE__DE":"Deutsch","CONFIGURATION__SIGN_OUT":"Ausloggen","MESSAGE__ACCOUNT__EMAIL_REQUIRED":"E-Mail ist erforderlich.","MESSAGE__ACCOUNT__PASSWORD_REQUIRED":"Passwort ist erforderlich.","MESSAGE__ACCOUNT__CONFIRM_PASSWORD_REQUIRED":"Passwort Bestätigung ist erforderlich.","MESSAGE__ACCOUNT__TERMS_NOT_ACCEPTED":"Allgemeine Geschäftsbedingungen sollten akzeptiert werden.","MESSAGE__ACCOUNT__NAME_REQUIRED":"Name ist erforderlich.","MESSAGE__ACCOUNT__COMPANY_NAME_REQUIRED":"Firmenname ist erforderlich.","MESSAGE__ACCOUNT__TIMEZONE_REQUIRED":"Zeitzone ist erforderlich.","MESSAGE__ACCOUNT__PASSWORD_CONFIRMATION_NOT_VALID":"Die Passwortbestätigung ist ungültig.","MESSAGE__ACCOUNT__EMAIL_NOT_VALID":"E-Mail ist ungültig.","FORGOT_PASSWORD__EMAIL_WAS_SENT":"Vielen Dank! Wenn ein Konto mit der angegebenen E-Mail-Adresse existiert, wird die Nachricht bald an diese Adresse gesendet. Bitte folgen Sie dem Link in der empfangenen Nachricht, um Ihr Passwort zurückzusetzen.","DASHBOARD__CONFIGURATION":"Konfiguration","DASHBOARD__LIST":"Liste","DASHBOARD__FORM":"Formular","DASHBOARD__TABLE":"Tabelle","DASHBOARD__CATALOG":"Katalog","FORM__FORM":"Formular","CONFIGURATION__CONFIGURATION":"Konfiguration","STATES__ALASKA":"Alaska","STATES__ARIZONA":"Arizona","STATES__ARKANSAS":"Arkansas","STATES__CALIFORNIA":"Kalifornien","STATES__COLORADO":"Colorado","STATES__CONNECTICUT":"Connecticut","STATES__DELAWARE":"Delaware","COLOR__SILVER":"Silber","COLOR__BLACK":"Schwarz","COLOR__GRAY":"Grau","FORM__TEXTAREA":"Textbereich","FORM__TEXT":"Text","STATES__ALABAMA":"Alabama","FORM__DROPDOWN":"Dropdown-Menü","FORM__CHECKBOX":"Kontrollkästchen","FORM__RADIO_BUTTONS":"Optionsfeldern","FORM__DATE":"Datum","FORM__DATE_AND_TIME":"Datum und Uhrzeit","ORDINAL__FIRST":"Erste","ORDINAL__SECOND":"Zweite","ORDINAL__THIRD":"Dritte","TABS__1":"Tab 1","FORM__SEGMENTED_CONTROL":"Segmentierte Steuerung","TABS__2":"Tab 2","TABS__3":"Tab 3","FORM__STATE":"Zustand","MESSAGE__FORM__TEXT_REQUIRED":"Text eingeben.","MESSAGE__FORM__TEXTAREA_REQUIRED":"Text eingeben.","MESSAGE__FORM__CHECKBOX_REQUIRED":"Markieren Sie das Feld.","MESSAGE__FORM__DROPDOWN_REQUIRED":"Wählen Sie einen beliebigen Wert aus dem Dropdown-Menü aus.","MESSAGE__FORM__RADIO_REQUIRED":"Wählen Sie eine beliebige Option mithilfe von Optionsfeldern aus.","MESSAGE__FORM__DATE_REQUIRED":"Geben Sie das Datum ein.","MESSAGE__FORM__DATETIME_REQUIRED":"Geben Sie Datum und Uhrzeit ein.","CONFIGURATION__TIMEZONE":"Zeitzone","FORM__FORM_SUCCESSFULLY_SAVED":"Formular erfolgreich gespeichert.","CONFIGURATION__LANGUAGE":"Sprache","CONFIGURATION__CONFIRM_SIGNOUT":"Sind Sie sicher, dass Sie sich abmelden möchten?","MESSAGE__LIST__NAME_REQUIRED":"Name eingeben.","SEX__MALE":"Männlich","SEX__FEMALE":"Weiblich","LIST__DELETE_ITEM_PROMPT":"Sind Sie sicher, dass Sie diesen Artikel löschen möchten?","LIST__LIST":"Liste","LIST__ADD":"Hinzufügen","TABLE__TABLE":"Tabelle","LIST__NAME":"Name","LIST__NEW_ITEM":"Neuer Artikel","TABLE__SEARCH":"Suche","TABLE__FOUND":"Gefunden","TABLE__CITY":"Stadt","TABLE__COMPANY":"Unternehmen","TABLE__PHONE":"Telefon","TABLE__NAME":"Name","CATALOG__OPEN":"Öffnen","CATALOG__CATALOG":"Katalog"}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"COMMON__CANCEL":"Отмена","COMMON__YES":"Да","COMMON__NO":"Нет","COMMON__SIGN_OUT":"Выйти","COMMON__SAVE":"Сохранить","COMMON__OK":"OK","COMMON__ADD":"Добавить","COMMON__DELETE":"Удалить","COMMON__DISABLED":"Выключено","COMMON__CREATE":"Создать","COMMON__REORDER":"Изменить порядок","COMMON__ENABLED":"Включено","COMMON__HELP":"Помощь","COMMON__APPLY":"Применить","SIGNIN__EMAIL":"E-mail","SIGNIN__PASSWORD":"Пароль","SIGNIN__SIGN_IN":"Войти","SIGNIN__TITLE":"Вход в аккаунт","FORGOT_PASSWORD__BACK_TO_SIGN_IN":"Назад на страницу входа","FORGOT_PASSWORD__RESET_PASSWORD":"Сброс пароля","FORGOT_PASSWORD__BACK":"Назад","FORGOT_PASSWORD__SENDING":"Высылается...","FORGOT_PASSWORD__SEND":"Выслать","FORGOT_PASSWORD__EMAIL":"E-mail","FORGOT_PASSWORD__ENTER_EMAIL":"Введите свой e-mail, чтобы получить ссылку для смены пароля.","SIGNUP__WAITING_FOR_EMAIL_CONFIRMAITON":"Ожидается подтверждение адреса","SIGNUP__TO_SIGN_IN":"На страницу входа","SIGNUP__NEW_ACCOUNT":"Новый аккаунт","SIGNUP__TO_TERMS_AND_CONDITIONS":"правила использования","SIGNUP__I_AGREE_TO":"Я принимаю","SIGNUP__COMPANY_NAME":"Название компании","SIGNUP__ACCOUNT_CREATED":"Аккаунт успешно создан. На ваш почтовый ящик было выслано сообщение. Пожалуйста, подтвердите ваш адрес электронной почты, перейдя по ссылке в сообщении.","SIGNUP__SIGN_UP":"Создать аккаунт","SIGNUP__TIMEZONE":"Часовой пояс","SIGNUP__NAME":"Ваше имя","SIGNUP__CONFIRM_PASSWORD":"Повтор пароля","SIGNUP__PASSWORD":"Пароль","SIGNUP__EMAIL":"E-mail","SIGNIN__NEED_ACCOUNT":"Нужен аккаунт?","SIGNIN__FORGOT_PASSWORD":"Забыли пароль?","MESSAGE__ACCOUNT__EMAIL_OR_PASSWORD_INVALID":"Неверный пароль или e-mail.","TIMEZONES__EUROPE_ANDORRA":"Центральная Европа (Europe/Andorra)","TIMEZONES__ASIA_DUBAI":"ОАЭ: Персидский залив (Asia/Dubai)","TIMEZONES__ASIA_KABUL":"Афганистан: Афганистан (Asia/Kabul)","TIMEZONES__AMERICA_ANTIGUA":"Атлантическое время (America/Antigua)","TIMEZONES__AMERICA_ANGUILLA":"Атлантическое время (America/Anguilla)","TIMEZONES__EUROPE_TIRANE":"Албания: Центральная Европа (Europe/Tirane)","TIMEZONES__ASIA_YEREVAN":"Армения: Армения (Asia/Yerevan)","TIMEZONES__AFRICA_LUANDA":"Западная Африка (Africa/Luanda)","TIMEZONES__ANTARCTICA_MCMURDO":"Новая Зеландия (Antarctica/McMurdo)","TIMEZONES__ANTARCTICA_ROTHERA":"Ротера (Antarctica/Rothera)","TIMEZONES__ANTARCTICA_PALMER":"Чили (Antarctica/Palmer)","TIMEZONES__ANTARCTICA_MAWSON":"Моусон (Antarctica/Mawson)","TIMEZONES__ANTARCTICA_DAVIS":"Дейвис (Antarctica/Davis)","TIMEZONES__ANTARCTICA_CASEY":"Западная Австралия (Antarctica/Casey)","TIMEZONES__ANTARCTICA_VOSTOK":"Восток (Antarctica/Vostok)","TIMEZONES__ANTARCTICA_DUMONTDURVILLE":"Дюмон-д Юрвиль (Antarctica/DumontDUrville)","TIMEZONES__ANTARCTICA_SYOWA":"Сёва (Antarctica/Syowa)","TIMEZONES__ANTARCTICA_TROLL":"Среднее время по Гринвичу (Antarctica/Troll)","TIMEZONES__AMERICA_ARGENTINA_BUENOS_AIRES":"Аргентина: Аргентина (America/Argentina/Buenos_Aires)","TIMEZONES__AMERICA_ARGENTINA_CORDOBA":"Аргентина: Аргентина (America/Argentina/Cordoba)","TIMEZONES__AMERICA_ARGENTINA_SALTA":"Аргентина: Аргентина (America/Argentina/Salta)","TIMEZONES__AMERICA_ARGENTINA_JUJUY":"Аргентина: Аргентина (America/Argentina/Jujuy)","TIMEZONES__AMERICA_ARGENTINA_TUCUMAN":"Аргентина: Аргентина (America/Argentina/Tucuman)","TIMEZONES__AMERICA_ARGENTINA_CATAMARCA":"Аргентина: Аргентина (America/Argentina/Catamarca)","TIMEZONES__AMERICA_ARGENTINA_LA_RIOJA":"Аргентина: Аргентина (America/Argentina/La_Rioja)","TIMEZONES__AMERICA_ARGENTINA_SAN_JUAN":"Аргентина: Аргентина (America/Argentina/San_Juan)","TIMEZONES__AMERICA_ARGENTINA_MENDOZA":"Аргентина: Аргентина (America/Argentina/Mendoza)","TIMEZONES__AMERICA_ARGENTINA_SAN_LUIS":"Аргентина: Западная Аргентина (America/Argentina/San_Luis)","TIMEZONES__AMERICA_ARGENTINA_RIO_GALLEGOS":"Аргентина: Аргентина (America/Argentina/Rio_Gallegos)","TIMEZONES__AMERICA_ARGENTINA_USHUAIA":"Аргентина: Аргентина (America/Argentina/Ushuaia)","TIMEZONES__PACIFIC_PAGO_PAGO":"Самоа (Pacific/Pago_Pago)","TIMEZONES__EUROPE_VIENNA":"Австрия: Центральная Европа (Europe/Vienna)","TIMEZONES__AUSTRALIA_LORD_HOWE":"Австралия: Лорд-Хау (Australia/Lord_Howe)","TIMEZONES__ANTARCTICA_MACQUARIE":"Австралия: Маккуори (Antarctica/Macquarie)","TIMEZONES__AUSTRALIA_HOBART":"Австралия: Восточная Австралия (Australia/Hobart)","TIMEZONES__AUSTRALIA_CURRIE":"Австралия: Восточная Австралия (Australia/Currie)","TIMEZONES__AUSTRALIA_MELBOURNE":"Австралия: Восточная Австралия (Australia/Melbourne)","TIMEZONES__AUSTRALIA_SYDNEY":"Австралия: Восточная Австралия (Australia/Sydney)","TIMEZONES__AUSTRALIA_BROKEN_HILL":"Австралия: Центральная Австралия (Australia/Broken_Hill)","TIMEZONES__AUSTRALIA_BRISBANE":"Австралия: Восточная Австралия (Australia/Brisbane)","TIMEZONES__AUSTRALIA_LINDEMAN":"Австралия: Восточная Австралия (Australia/Lindeman)","TIMEZONES__AUSTRALIA_ADELAIDE":"Австралия: Центральная Австралия (Australia/Adelaide)","TIMEZONES__AUSTRALIA_DARWIN":"Австралия: Центральная Австралия (Australia/Darwin)","TIMEZONES__AUSTRALIA_PERTH":"Австралия: Западная Австралия (Australia/Perth)","TIMEZONES__AUSTRALIA_EUCLA":"Австралия: Центральная Австралия, западное время (Australia/Eucla)","TIMEZONES__AMERICA_ARUBA":"Атлантическое время (America/Aruba)","TIMEZONES__EUROPE_MARIEHAMN":"Восточная Европа (Europe/Mariehamn)","TIMEZONES__ASIA_BAKU":"Азербайджан: Азербайджан (Asia/Baku)","TIMEZONES__EUROPE_SARAJEVO":"Босния и Герцеговина: Центральная Европа (Europe/Sarajevo)","TIMEZONES__AMERICA_BARBADOS":"Атлантическое время (America/Barbados)","TIMEZONES__ASIA_DHAKA":"Бангладеш: Бангладеш (Asia/Dhaka)","TIMEZONES__EUROPE_BRUSSELS":"Бельгия: Центральная Европа (Europe/Brussels)","TIMEZONES__AFRICA_OUAGADOUGOU":"Среднее время по Гринвичу (Africa/Ouagadougou)","TIMEZONES__EUROPE_SOFIA":"Болгария: Восточная Европа (Europe/Sofia)","TIMEZONES__ASIA_BAHRAIN":"Бахрейн: Саудовская Аравия (Asia/Bahrain)","TIMEZONES__AFRICA_BUJUMBURA":"Центральная Африка (Africa/Bujumbura)","TIMEZONES__AFRICA_PORTO_NOVO":"Западная Африка (Africa/Porto-Novo)","TIMEZONES__AMERICA_ST_BARTHELEMY":"Атлантическое время (America/St_Barthelemy)","TIMEZONES__ATLANTIC_BERMUDA":"Атлантическое время (Atlantic/Bermuda)","TIMEZONES__ASIA_BRUNEI":"Бруней Дар-эс-Салам: Бруней-Даруссалам (Asia/Brunei)","TIMEZONES__AMERICA_LA_PAZ":"Боливия: Боливия (America/La_Paz)","TIMEZONES__AMERICA_KRALENDIJK":"Атлантическое время (America/Kralendijk)","TIMEZONES__AMERICA_NORONHA":"Бразилия: Фернанду-ди-Норонья (America/Noronha)","TIMEZONES__AMERICA_BELEM":"Бразилия: Бразилия (America/Belem)","TIMEZONES__AMERICA_FORTALEZA":"Бразилия: Бразилия (America/Fortaleza)","TIMEZONES__AMERICA_RECIFE":"Бразилия: Бразилия (America/Recife)","TIMEZONES__AMERICA_ARAGUAINA":"Бразилия: Бразилия (America/Araguaina)","TIMEZONES__AMERICA_MACEIO":"Бразилия: Бразилия (America/Maceio)","TIMEZONES__AMERICA_BAHIA":"Бразилия: Бразилия (America/Bahia)","TIMEZONES__AMERICA_SAO_PAULO":"Бразилия: Бразилия (America/Sao_Paulo)","TIMEZONES__AMERICA_CAMPO_GRANDE":"Бразилия: Амазонка (America/Campo_Grande)","TIMEZONES__AMERICA_CUIABA":"Бразилия: Амазонка (America/Cuiaba)","TIMEZONES__AMERICA_SANTAREM":"Бразилия: Бразилия (America/Santarem)","TIMEZONES__AMERICA_PORTO_VELHO":"Бразилия: Амазонка (America/Porto_Velho)","TIMEZONES__AMERICA_BOA_VISTA":"Бразилия: Амазонка (America/Boa_Vista)","TIMEZONES__AMERICA_MANAUS":"Бразилия: Амазонка (America/Manaus)","TIMEZONES__AMERICA_EIRUNEPE":"Бразилия: Акри время (America/Eirunepe)","TIMEZONES__AMERICA_RIO_BRANCO":"Бразилия: Акри время (America/Rio_Branco)","TIMEZONES__AMERICA_NASSAU":"Восточная Америка (America/Nassau)","TIMEZONES__ASIA_THIMPHU":"Бутан (Asia/Thimphu)","TIMEZONES__AFRICA_GABORONE":"Botswana: Центральная Африка (Africa/Gaborone)","TIMEZONES__EUROPE_MINSK":"Беларусь: Минское время (Europe/Minsk)","TIMEZONES__AMERICA_BELIZE":"Белиз: Центральная Америка (America/Belize)","TIMEZONES__AMERICA_ST_JOHNS":"Канада: Ньюфаундленд (America/St_Johns)","TIMEZONES__AMERICA_HALIFAX":"Канада: Атлантическое время (America/Halifax)","TIMEZONES__AMERICA_GLACE_BAY":"Канада: Атлантическое время (America/Glace_Bay)","TIMEZONES__AMERICA_MONCTON":"Канада: Атлантическое время (America/Moncton)","TIMEZONES__AMERICA_GOOSE_BAY":"Канада: Атлантическое время (America/Goose_Bay)","TIMEZONES__AMERICA_BLANC_SABLON":"Канада: Атлантическое время (America/Blanc-Sablon)","TIMEZONES__AMERICA_TORONTO":"Канада: Восточная Америка (America/Toronto)","TIMEZONES__AMERICA_NIPIGON":"Канада: Восточная Америка (America/Nipigon)","TIMEZONES__AMERICA_THUNDER_BAY":"Канада: Восточная Америка (America/Thunder_Bay)","TIMEZONES__AMERICA_IQALUIT":"Канада: Восточная Америка (America/Iqaluit)","TIMEZONES__AMERICA_PANGNIRTUNG":"Канада: Восточная Америка (America/Pangnirtung)","TIMEZONES__AMERICA_RESOLUTE":"Канада: Центральная Америка (America/Resolute)","TIMEZONES__AMERICA_ATIKOKAN":"Канада: Восточная Америка (America/Atikokan)","TIMEZONES__AMERICA_RANKIN_INLET":"Канада: Центральная Америка (America/Rankin_Inlet)","TIMEZONES__AMERICA_WINNIPEG":"Канада: Центральная Америка (America/Winnipeg)","TIMEZONES__AMERICA_RAINY_RIVER":"Канада: Центральная Америка (America/Rainy_River)","TIMEZONES__AMERICA_REGINA":"Канада: Центральная Америка (America/Regina)","TIMEZONES__AMERICA_SWIFT_CURRENT":"Канада: Центральная Америка (America/Swift_Current)","TIMEZONES__AMERICA_EDMONTON":"Канада: Горное время (США) (America/Edmonton)","TIMEZONES__AMERICA_CAMBRIDGE_BAY":"Канада: Горное время (США) (America/Cambridge_Bay)","TIMEZONES__AMERICA_YELLOWKNIFE":"Канада: Горное время (США) (America/Yellowknife)","TIMEZONES__AMERICA_INUVIK":"Канада: Горное время (США) (America/Inuvik)","TIMEZONES__AMERICA_CRESTON":"Канада: Горное время (США) (America/Creston)","TIMEZONES__AMERICA_DAWSON_CREEK":"Канада: Горное время (США) (America/Dawson_Creek)","TIMEZONES__AMERICA_VANCOUVER":"Канада: Тихоокеанское время (America/Vancouver)","TIMEZONES__AMERICA_WHITEHORSE":"Канада: Тихоокеанское время (America/Whitehorse)","TIMEZONES__AMERICA_DAWSON":"Канада: Тихоокеанское время (America/Dawson)","TIMEZONES__INDIAN_COCOS":"Кокосовые о-ва (Indian/Cocos)","TIMEZONES__AFRICA_KINSHASA":"Западная Африка (Africa/Kinshasa)","TIMEZONES__AFRICA_LUBUMBASHI":"Центральная Африка (Africa/Lubumbashi)","TIMEZONES__AFRICA_BANGUI":"Западная Африка (Africa/Bangui)","TIMEZONES__AFRICA_BRAZZAVILLE":"Западная Африка (Africa/Brazzaville)","TIMEZONES__EUROPE_ZURICH":"Швейцария: Центральная Европа (Europe/Zurich)","TIMEZONES__AFRICA_ABIDJAN":"Кот-д'Ивуар: Среднее время по Гринвичу (Africa/Abidjan)","TIMEZONES__PACIFIC_RAROTONGA":"Кука, о-ва (Pacific/Rarotonga)","TIMEZONES__AMERICA_SANTIAGO":"Чили: Чили (America/Santiago)","TIMEZONES__PACIFIC_EASTER":"Чили: О-в Пасхи (Pacific/Easter)","TIMEZONES__AFRICA_DOUALA":"Cameroun: Западная Африка (Africa/Douala)","TIMEZONES__ASIA_SHANGHAI":"Китайская Народная Республика: Китай (Asia/Shanghai)","TIMEZONES__ASIA_URUMQI":"Китайская Народная Республика: Китай (Asia/Urumqi)","TIMEZONES__AMERICA_BOGOTA":"Колумбия: Колумбия (America/Bogota)","TIMEZONES__AMERICA_COSTA_RICA":"Коста-Рика: Центральная Америка (America/Costa_Rica)","TIMEZONES__AMERICA_HAVANA":"Cuba: Куба (America/Havana)","TIMEZONES__ATLANTIC_CAPE_VERDE":"Кабо-Верде (Atlantic/Cape_Verde)","TIMEZONES__AMERICA_CURACAO":"Атлантическое время (America/Curacao)","TIMEZONES__INDIAN_CHRISTMAS":"Рождества, о-в (Indian/Christmas)","TIMEZONES__ASIA_NICOSIA":"Восточная Европа (Asia/Nicosia)","TIMEZONES__EUROPE_PRAGUE":"Чешская республика: Центральная Европа (Europe/Prague)","TIMEZONES__EUROPE_BERLIN":"Германия: Центральная Европа (Europe/Berlin)","TIMEZONES__EUROPE_BUSINGEN":"Германия: Центральная Европа (Europe/Busingen)","TIMEZONES__AFRICA_DJIBOUTI":"Yabuuti: Восточная Африка (Africa/Djibouti)","TIMEZONES__EUROPE_COPENHAGEN":"Дания: Центральная Европа (Europe/Copenhagen)","TIMEZONES__AMERICA_DOMINICA":"Атлантическое время (America/Dominica)","TIMEZONES__AMERICA_SANTO_DOMINGO":"Доминиканская Республика: Атлантическое время (America/Santo_Domingo)","TIMEZONES__AFRICA_ALGIERS":"Алжир: Центральная Европа (Africa/Algiers)","TIMEZONES__AMERICA_GUAYAQUIL":"Эквадор: Эквадор (America/Guayaquil)","TIMEZONES__PACIFIC_GALAPAGOS":"Эквадор: Галапагосские о-ва (Pacific/Galapagos)","TIMEZONES__EUROPE_TALLINN":"Эстония: Восточная Европа (Europe/Tallinn)","TIMEZONES__AFRICA_CAIRO":"Египет: Восточная Европа (Africa/Cairo)","TIMEZONES__AFRICA_EL_AAIUN":"Западная Европа (Africa/El_Aaiun)","TIMEZONES__AFRICA_ASMARA":"Эритрея: Восточная Африка (Africa/Asmara)","TIMEZONES__EUROPE_MADRID":"Испания: Центральная Европа (Europe/Madrid)","TIMEZONES__AFRICA_CEUTA":"Испания: Центральная Европа (Africa/Ceuta)","TIMEZONES__ATLANTIC_CANARY":"Испания: Западная Европа (Atlantic/Canary)","TIMEZONES__AFRICA_ADDIS_ABABA":"Эфиопия: Восточная Африка (Africa/Addis_Ababa)","TIMEZONES__EUROPE_HELSINKI":"Финляндия: Восточная Европа (Europe/Helsinki)","TIMEZONES__PACIFIC_FIJI":"Фиджи (Pacific/Fiji)","TIMEZONES__ATLANTIC_STANLEY":"Фолклендские о-ва (Atlantic/Stanley)","TIMEZONES__PACIFIC_CHUUK":"Чуук (Pacific/Chuuk)","TIMEZONES__PACIFIC_POHNPEI":"Понапе, о-ва (Pacific/Pohnpei)","TIMEZONES__PACIFIC_KOSRAE":"Косраэ (Pacific/Kosrae)","TIMEZONES__ATLANTIC_FAROE":"Фарерские острова: Западная Европа (Atlantic/Faroe)","TIMEZONES__EUROPE_PARIS":"Франция: Центральная Европа (Europe/Paris)","TIMEZONES__AFRICA_LIBREVILLE":"Западная Африка (Africa/Libreville)","TIMEZONES__EUROPE_LONDON":"Великобритания: Британия (Europe/London)","TIMEZONES__AMERICA_GRENADA":"Атлантическое время (America/Grenada)","TIMEZONES__ASIA_TBILISI":"Грузия: Грузия (Asia/Tbilisi)","TIMEZONES__AMERICA_CAYENNE":"Французская Гвиана (America/Cayenne)","TIMEZONES__EUROPE_GUERNSEY":"Среднее время по Гринвичу (Europe/Guernsey)","TIMEZONES__AFRICA_ACCRA":"Среднее время по Гринвичу (Africa/Accra)","TIMEZONES__EUROPE_GIBRALTAR":"Центральная Европа (Europe/Gibraltar)","TIMEZONES__AMERICA_GODTHAB":"Гренландия: Западная Гренландия (America/Godthab)","TIMEZONES__AMERICA_DANMARKSHAVN":"Гренландия: Среднее время по Гринвичу (America/Danmarkshavn)","TIMEZONES__AMERICA_SCORESBYSUND":"Гренландия: Восточная Гренландия (America/Scoresbysund)","TIMEZONES__AMERICA_THULE":"Гренландия: Атлантическое время (America/Thule)","TIMEZONES__AFRICA_BANJUL":"Среднее время по Гринвичу (Africa/Banjul)","TIMEZONES__AFRICA_CONAKRY":"Среднее время по Гринвичу (Africa/Conakry)","TIMEZONES__AMERICA_GUADELOUPE":"Атлантическое время (America/Guadeloupe)","TIMEZONES__AFRICA_MALABO":"Западная Африка (Africa/Malabo)","TIMEZONES__EUROPE_ATHENS":"Греция: Восточная Европа (Europe/Athens)","TIMEZONES__ATLANTIC_SOUTH_GEORGIA":"Южная Георгия (Atlantic/South_Georgia)","TIMEZONES__AMERICA_GUATEMALA":"Гватемала: Центральная Америка (America/Guatemala)","TIMEZONES__PACIFIC_GUAM":"Чаморро (Pacific/Guam)","TIMEZONES__AFRICA_BISSAU":"Среднее время по Гринвичу (Africa/Bissau)","TIMEZONES__AMERICA_GUYANA":"Гайана (America/Guyana)","TIMEZONES__ASIA_HONG_KONG":"Гонконг: Гонконг (Asia/Hong_Kong)","TIMEZONES__AMERICA_TEGUCIGALPA":"Гондурас: Центральная Америка (America/Tegucigalpa)","TIMEZONES__EUROPE_ZAGREB":"Хорватия: Центральная Европа (Europe/Zagreb)","TIMEZONES__AMERICA_PORT_AU_PRINCE":"Haiti: Восточная Америка (America/Port-au-Prince)","TIMEZONES__EUROPE_BUDAPEST":"Венгрия: Центральная Европа (Europe/Budapest)","TIMEZONES__ASIA_JAKARTA":"Индонезия: Западная Индонезия (Asia/Jakarta)","TIMEZONES__ASIA_PONTIANAK":"Индонезия: Западная Индонезия (Asia/Pontianak)","TIMEZONES__ASIA_MAKASSAR":"Индонезия: Центральная Индонезия (Asia/Makassar)","TIMEZONES__ASIA_JAYAPURA":"Индонезия: Восточная Индонезия (Asia/Jayapura)","TIMEZONES__EUROPE_DUBLIN":"Ирландия: Ирландия (Europe/Dublin)","TIMEZONES__ASIA_JERUSALEM":"Израиль: Израиль (Asia/Jerusalem)","TIMEZONES__EUROPE_ISLE_OF_MAN":"Среднее время по Гринвичу (Europe/Isle_of_Man)","TIMEZONES__ASIA_KOLKATA":"Индия: Индия (Asia/Kolkata)","TIMEZONES__INDIAN_CHAGOS":"Индийский океан (Indian/Chagos)","TIMEZONES__ASIA_BAGHDAD":"Ирак: Саудовская Аравия (Asia/Baghdad)","TIMEZONES__ASIA_TEHRAN":"Иран: Иран (Asia/Tehran)","TIMEZONES__ATLANTIC_REYKJAVIK":"Исландия: Среднее время по Гринвичу (Atlantic/Reykjavik)","TIMEZONES__EUROPE_ROME":"Италия: Центральная Европа (Europe/Rome)","TIMEZONES__EUROPE_JERSEY":"Среднее время по Гринвичу (Europe/Jersey)","TIMEZONES__AMERICA_JAMAICA":"Ямайка: Восточная Америка (America/Jamaica)","TIMEZONES__ASIA_AMMAN":"Иордания: Восточная Европа (Asia/Amman)","TIMEZONES__ASIA_TOKYO":"Япония: Япония (Asia/Tokyo)","TIMEZONES__AFRICA_NAIROBI":"Кения: Восточная Африка (Africa/Nairobi)","TIMEZONES__ASIA_BISHKEK":"Киргизия: Киргизия (Asia/Bishkek)","TIMEZONES__ASIA_PHNOM_PENH":"Камбоджа: Индокитай (Asia/Phnom_Penh)","TIMEZONES__PACIFIC_TARAWA":"Гилберта, о-ва (Pacific/Tarawa)","TIMEZONES__PACIFIC_ENDERBURY":"Феникс, о-ва (Pacific/Enderbury)","TIMEZONES__PACIFIC_KIRITIMATI":"Лайн, о-ва (Pacific/Kiritimati)","TIMEZONES__INDIAN_COMORO":"Восточная Африка (Indian/Comoro)","TIMEZONES__AMERICA_ST_KITTS":"Атлантическое время (America/St_Kitts)","TIMEZONES__ASIA_PYONGYANG":"Корея (Asia/Pyongyang)","TIMEZONES__ASIA_SEOUL":"Южная Корея: Корея (Asia/Seoul)","TIMEZONES__ASIA_KUWAIT":"Кувейт: Саудовская Аравия (Asia/Kuwait)","TIMEZONES__AMERICA_CAYMAN":"Восточная Америка (America/Cayman)","TIMEZONES__ASIA_ALMATY":"Казахстан: Восточный Казахстан (Asia/Almaty)","TIMEZONES__ASIA_QYZYLORDA":"Казахстан: Восточный Казахстан (Asia/Qyzylorda)","TIMEZONES__ASIA_AQTOBE":"Казахстан: Западный Казахстан (Asia/Aqtobe)","TIMEZONES__ASIA_AQTAU":"Казахстан: Западный Казахстан (Asia/Aqtau)","TIMEZONES__ASIA_ORAL":"Казахстан: Западный Казахстан (Asia/Oral)","TIMEZONES__ASIA_VIENTIANE":"Лаосская Народно-Демократическая Республика: Индокитай (Asia/Vientiane)","TIMEZONES__ASIA_BEIRUT":"Ливан: Восточная Европа (Asia/Beirut)","TIMEZONES__AMERICA_ST_LUCIA":"Атлантическое время (America/St_Lucia)","TIMEZONES__EUROPE_VADUZ":"Лихтенштейн: Центральная Европа (Europe/Vaduz)","TIMEZONES__ASIA_COLOMBO":"Шри-Ланка: Индия (Asia/Colombo)","TIMEZONES__AFRICA_MONROVIA":"Среднее время по Гринвичу (Africa/Monrovia)","TIMEZONES__AFRICA_MASERU":"Южная Африка (Africa/Maseru)","TIMEZONES__EUROPE_VILNIUS":"Литва: Восточная Европа (Europe/Vilnius)","TIMEZONES__EUROPE_LUXEMBOURG":"Люксембург: Центральная Европа (Europe/Luxembourg)","TIMEZONES__EUROPE_RIGA":"Латвия: Восточная Европа (Europe/Riga)","TIMEZONES__AFRICA_TRIPOLI":"Ливия: Восточная Европа (Africa/Tripoli)","TIMEZONES__AFRICA_CASABLANCA":"Марокко: Западная Европа (Africa/Casablanca)","TIMEZONES__EUROPE_MONACO":"Монако: Центральная Европа (Europe/Monaco)","TIMEZONES__EUROPE_CHISINAU":"Republica Moldova: Восточная Европа (Europe/Chisinau)","TIMEZONES__EUROPE_PODGORICA":"Черногория: Центральная Европа (Europe/Podgorica)","TIMEZONES__AMERICA_MARIGOT":"Атлантическое время (America/Marigot)","TIMEZONES__INDIAN_ANTANANARIVO":"Восточная Африка (Indian/Antananarivo)","TIMEZONES__PACIFIC_MAJURO":"Маршалловы о-ва (Pacific/Majuro)","TIMEZONES__PACIFIC_KWAJALEIN":"Маршалловы о-ва (Pacific/Kwajalein)","TIMEZONES__EUROPE_SKOPJE":"Македония (Бывшая Югославская Республика Македония): Центральная Европа (Europe/Skopje)","TIMEZONES__AFRICA_BAMAKO":"Mali: Среднее время по Гринвичу (Africa/Bamako)","TIMEZONES__ASIA_RANGOON":"Мьянма (Asia/Rangoon)","TIMEZONES__ASIA_ULAANBAATAR":"Монголия: Улан-Батор (Asia/Ulaanbaatar)","TIMEZONES__ASIA_HOVD":"Монголия: Ховд (Asia/Hovd)","TIMEZONES__ASIA_CHOIBALSAN":"Монголия: Чойбалсан (Asia/Choibalsan)","TIMEZONES__ASIA_MACAU":"Макао: Китай (Asia/Macau)","TIMEZONES__PACIFIC_SAIPAN":"Чаморро (Pacific/Saipan)","TIMEZONES__AMERICA_MARTINIQUE":"Атлантическое время (America/Martinique)","TIMEZONES__AFRICA_NOUAKCHOTT":"Среднее время по Гринвичу (Africa/Nouakchott)","TIMEZONES__AMERICA_MONTSERRAT":"Атлантическое время (America/Montserrat)","TIMEZONES__EUROPE_MALTA":"Мальта: Центральная Европа (Europe/Malta)","TIMEZONES__INDIAN_MAURITIUS":"Маврикий (Indian/Mauritius)","TIMEZONES__INDIAN_MALDIVES":"Мальдивские о-ва: Мальдивы (Indian/Maldives)","TIMEZONES__AFRICA_BLANTYRE":"Центральная Африка (Africa/Blantyre)","TIMEZONES__AMERICA_MEXICO_CITY":"Мексика: Центральная Америка (America/Mexico_City)","TIMEZONES__AMERICA_CANCUN":"Мексика: Восточная Америка (America/Cancun)","TIMEZONES__AMERICA_MERIDA":"Мексика: Центральная Америка (America/Merida)","TIMEZONES__AMERICA_MONTERREY":"Мексика: Центральная Америка (America/Monterrey)","TIMEZONES__AMERICA_MATAMOROS":"Мексика: Центральная Америка (America/Matamoros)","TIMEZONES__AMERICA_MAZATLAN":"Мексика: Тихоокеанское мексиканское время (America/Mazatlan)","TIMEZONES__AMERICA_CHIHUAHUA":"Мексика: Тихоокеанское мексиканское время (America/Chihuahua)","TIMEZONES__AMERICA_OJINAGA":"Мексика: Горное время (США) (America/Ojinaga)","TIMEZONES__AMERICA_HERMOSILLO":"Мексика: Тихоокеанское мексиканское время (America/Hermosillo)","TIMEZONES__AMERICA_TIJUANA":"Мексика: Тихоокеанское время (America/Tijuana)","TIMEZONES__AMERICA_BAHIA_BANDERAS":"Мексика: Центральная Америка (America/Bahia_Banderas)","TIMEZONES__ASIA_KUALA_LUMPUR":"Малайзия: Малайзия (Asia/Kuala_Lumpur)","TIMEZONES__ASIA_KUCHING":"Малайзия: Малайзия (Asia/Kuching)","TIMEZONES__AFRICA_MAPUTO":"Центральная Африка (Africa/Maputo)","TIMEZONES__AFRICA_WINDHOEK":"Западная Африка (Africa/Windhoek)","TIMEZONES__PACIFIC_NOUMEA":"Новая Каледония (Pacific/Noumea)","TIMEZONES__AFRICA_NIAMEY":"Западная Африка (Africa/Niamey)","TIMEZONES__PACIFIC_NORFOLK":"Норфолк (Pacific/Norfolk)","TIMEZONES__AFRICA_LAGOS":"Нигерия: Западная Африка (Africa/Lagos)","TIMEZONES__AMERICA_MANAGUA":"Никарагуа: Центральная Америка (America/Managua)","TIMEZONES__EUROPE_AMSTERDAM":"Нидерланды: Центральная Европа (Europe/Amsterdam)","TIMEZONES__EUROPE_OSLO":"Норвегия: Центральная Европа (Europe/Oslo)","TIMEZONES__ASIA_KATHMANDU":"Непал: Непал (Asia/Kathmandu)","TIMEZONES__PACIFIC_NAURU":"Науру (Pacific/Nauru)","TIMEZONES__PACIFIC_NIUE":"Ниуэ (Pacific/Niue)","TIMEZONES__PACIFIC_AUCKLAND":"Новая Зеландия: Новая Зеландия (Pacific/Auckland)","TIMEZONES__PACIFIC_CHATHAM":"Новая Зеландия: Чатем (Pacific/Chatham)","TIMEZONES__ASIA_MUSCAT":"Оман: Персидский залив (Asia/Muscat)","TIMEZONES__AMERICA_PANAMA":"Панама: Восточная Америка (America/Panama)","TIMEZONES__AMERICA_LIMA":"Перу: Перу (America/Lima)","TIMEZONES__PACIFIC_TAHITI":"Таити, о-в (Pacific/Tahiti)","TIMEZONES__PACIFIC_MARQUESAS":"Маркизские о-ва (Pacific/Marquesas)","TIMEZONES__PACIFIC_GAMBIER":"Гамбье (Pacific/Gambier)","TIMEZONES__PACIFIC_PORT_MORESBY":"Папуа – Новая Гвинея (Pacific/Port_Moresby)","TIMEZONES__PACIFIC_BOUGAINVILLE":"Папуа – Новая Гвинея (Pacific/Bougainville)","TIMEZONES__ASIA_MANILA":"Филиппины: Филиппины (Asia/Manila)","TIMEZONES__ASIA_KARACHI":"Исламская Республика Пакистан: Пакистан (Asia/Karachi)","TIMEZONES__EUROPE_WARSAW":"Польша: Центральная Европа (Europe/Warsaw)","TIMEZONES__AMERICA_MIQUELON":"Сен-Пьер и Микелон (America/Miquelon)","TIMEZONES__PACIFIC_PITCAIRN":"Питкэрн (Pacific/Pitcairn)","TIMEZONES__AMERICA_PUERTO_RICO":"Пуэрто-Рико: Атлантическое время (America/Puerto_Rico)","TIMEZONES__ASIA_GAZA":"Восточная Европа (Asia/Gaza)","TIMEZONES__ASIA_HEBRON":"Восточная Европа (Asia/Hebron)","TIMEZONES__EUROPE_LISBON":"Португалия: Западная Европа (Europe/Lisbon)","TIMEZONES__ATLANTIC_MADEIRA":"Португалия: Западная Европа (Atlantic/Madeira)","TIMEZONES__ATLANTIC_AZORES":"Португалия: Азорские о-ва (Atlantic/Azores)","TIMEZONES__PACIFIC_PALAU":"Палау (Pacific/Palau)","TIMEZONES__AMERICA_ASUNCION":"Парагвай: Парагвай (America/Asuncion)","TIMEZONES__ASIA_QATAR":"Катар: Саудовская Аравия (Asia/Qatar)","TIMEZONES__INDIAN_REUNION":"Реюньон (Indian/Reunion)","TIMEZONES__EUROPE_BUCHAREST":"Румыния: Восточная Европа (Europe/Bucharest)","TIMEZONES__EUROPE_BELGRADE":"Сербия: Центральная Европа (Europe/Belgrade)","TIMEZONES__EUROPE_KALININGRAD":"Россия: Восточная Европа (Europe/Kaliningrad)","TIMEZONES__EUROPE_MOSCOW":"Россия: Москва (Europe/Moscow)","TIMEZONES__EUROPE_SIMFEROPOL":"Россия: Москва (Europe/Simferopol)","TIMEZONES__EUROPE_VOLGOGRAD":"Россия: Москва (Europe/Volgograd)","TIMEZONES__EUROPE_SAMARA":"Россия: Время в Самаре (Europe/Samara)","TIMEZONES__ASIA_YEKATERINBURG":"Россия: Екатеринбург (Asia/Yekaterinburg)","TIMEZONES__ASIA_OMSK":"Россия: Омск (Asia/Omsk)","TIMEZONES__ASIA_NOVOSIBIRSK":"Россия: Новосибирск (Asia/Novosibirsk)","TIMEZONES__ASIA_NOVOKUZNETSK":"Россия: Красноярск (Asia/Novokuznetsk)","TIMEZONES__ASIA_KRASNOYARSK":"Россия: Красноярск (Asia/Krasnoyarsk)","TIMEZONES__ASIA_IRKUTSK":"Россия: Иркутск (Asia/Irkutsk)","TIMEZONES__ASIA_CHITA":"Россия: Иркутск (Asia/Chita)","TIMEZONES__ASIA_YAKUTSK":"Россия: Якутск (Asia/Yakutsk)","TIMEZONES__ASIA_KHANDYGA":"Россия: Якутск (Asia/Khandyga)","TIMEZONES__ASIA_VLADIVOSTOK":"Россия: Владивосток (Asia/Vladivostok)","TIMEZONES__ASIA_SAKHALIN":"Россия: Сахалин (Asia/Sakhalin)","TIMEZONES__ASIA_UST_NERA":"Россия: Владивосток (Asia/Ust-Nera)","TIMEZONES__ASIA_MAGADAN":"Россия: Магадан (Asia/Magadan)","TIMEZONES__ASIA_SREDNEKOLYMSK":"Россия: Магадан (Asia/Srednekolymsk)","TIMEZONES__ASIA_KAMCHATKA":"Россия: Время в Петропавловску-Камчатскому (Asia/Kamchatka)","TIMEZONES__ASIA_ANADYR":"Россия: Магадан (Asia/Anadyr)","TIMEZONES__AFRICA_KIGALI":"Руанда: Центральная Африка (Africa/Kigali)","TIMEZONES__ASIA_RIYADH":"Саудовская Аравия: Саудовская Аравия (Asia/Riyadh)","TIMEZONES__PACIFIC_GUADALCANAL":"Соломоновы о-ва (Pacific/Guadalcanal)","TIMEZONES__INDIAN_MAHE":"Сейшельские о-ва (Indian/Mahe)","TIMEZONES__AFRICA_KHARTOUM":"Восточная Африка (Africa/Khartoum)","TIMEZONES__EUROPE_STOCKHOLM":"Швеция: Центральная Европа (Europe/Stockholm)","TIMEZONES__ASIA_SINGAPORE":"Сингапур: Сингапур (Asia/Singapore)","TIMEZONES__ATLANTIC_ST_HELENA":"Среднее время по Гринвичу (Atlantic/St_Helena)","TIMEZONES__EUROPE_LJUBLJANA":"Словения: Центральная Европа (Europe/Ljubljana)","TIMEZONES__ARCTIC_LONGYEARBYEN":"Центральная Европа (Arctic/Longyearbyen)","TIMEZONES__EUROPE_BRATISLAVA":"Словакия: Центральная Европа (Europe/Bratislava)","TIMEZONES__AFRICA_FREETOWN":"Среднее время по Гринвичу (Africa/Freetown)","TIMEZONES__EUROPE_SAN_MARINO":"Центральная Европа (Europe/San_Marino)","TIMEZONES__AFRICA_DAKAR":"Сенегал: Среднее время по Гринвичу (Africa/Dakar)","TIMEZONES__AFRICA_MOGADISHU":"Soomaaliya: Восточная Африка (Africa/Mogadishu)","TIMEZONES__AMERICA_PARAMARIBO":"Суринам (America/Paramaribo)","TIMEZONES__AFRICA_JUBA":"Восточная Африка (Africa/Juba)","TIMEZONES__AFRICA_SAO_TOME":"Среднее время по Гринвичу (Africa/Sao_Tome)","TIMEZONES__AMERICA_EL_SALVADOR":"Сальвадор: Центральная Америка (America/El_Salvador)","TIMEZONES__AMERICA_LOWER_PRINCES":"Атлантическое время (America/Lower_Princes)","TIMEZONES__ASIA_DAMASCUS":"Сирия: Восточная Европа (Asia/Damascus)","TIMEZONES__AFRICA_MBABANE":"Южная Африка (Africa/Mbabane)","TIMEZONES__AMERICA_GRAND_TURK":"Атлантическое время (America/Grand_Turk)","TIMEZONES__AFRICA_NDJAMENA":"Западная Африка (Africa/Ndjamena)","TIMEZONES__INDIAN_KERGUELEN":"Французское южное и антарктическое время (Indian/Kerguelen)","TIMEZONES__AFRICA_LOME":"Среднее время по Гринвичу (Africa/Lome)","TIMEZONES__ASIA_BANGKOK":"Таиланд: Индокитай (Asia/Bangkok)","TIMEZONES__ASIA_DUSHANBE":"Таджикистан: Таджикистан (Asia/Dushanbe)","TIMEZONES__PACIFIC_FAKAOFO":"Токелау (Pacific/Fakaofo)","TIMEZONES__ASIA_DILI":"Восточный Тимор (Asia/Dili)","TIMEZONES__ASIA_ASHGABAT":"Туркменистан: Туркмения (Asia/Ashgabat)","TIMEZONES__AFRICA_TUNIS":"Тунис: Центральная Европа (Africa/Tunis)","TIMEZONES__PACIFIC_TONGATAPU":"Тонга (Pacific/Tongatapu)","TIMEZONES__EUROPE_ISTANBUL":"Турция: Восточная Европа (Europe/Istanbul)","TIMEZONES__AMERICA_PORT_OF_SPAIN":"Тринидад и Тобаго: Атлантическое время (America/Port_of_Spain)","TIMEZONES__PACIFIC_FUNAFUTI":"Тувалу (Pacific/Funafuti)","TIMEZONES__ASIA_TAIPEI":"Тайвань: Тайвань (Asia/Taipei)","TIMEZONES__AFRICA_DAR_ES_SALAAM":"Восточная Африка (Africa/Dar_es_Salaam)","TIMEZONES__EUROPE_KIEV":"Украина: Восточная Европа (Europe/Kiev)","TIMEZONES__EUROPE_UZHGOROD":"Украина: Восточная Европа (Europe/Uzhgorod)","TIMEZONES__EUROPE_ZAPOROZHYE":"Украина: Восточная Европа (Europe/Zaporozhye)","TIMEZONES__AFRICA_KAMPALA":"Восточная Африка (Africa/Kampala)","TIMEZONES__PACIFIC_JOHNSTON":"Гавайско-алеутское время (Pacific/Johnston)","TIMEZONES__PACIFIC_MIDWAY":"Самоа (Pacific/Midway)","TIMEZONES__PACIFIC_WAKE":"Уэйк, о-в (Pacific/Wake)","TIMEZONES__AMERICA_NEW_YORK":"США: Восточная Америка (America/New_York)","TIMEZONES__AMERICA_DETROIT":"США: Восточная Америка (America/Detroit)","TIMEZONES__AMERICA_KENTUCKY_LOUISVILLE":"США: Восточная Америка (America/Kentucky/Louisville)","TIMEZONES__AMERICA_KENTUCKY_MONTICELLO":"США: Восточная Америка (America/Kentucky/Monticello)","TIMEZONES__AMERICA_INDIANA_INDIANAPOLIS":"США: Восточная Америка (America/Indiana/Indianapolis)","TIMEZONES__AMERICA_INDIANA_VINCENNES":"США: Восточная Америка (America/Indiana/Vincennes)","TIMEZONES__AMERICA_INDIANA_WINAMAC":"США: Восточная Америка (America/Indiana/Winamac)","TIMEZONES__AMERICA_INDIANA_MARENGO":"США: Восточная Америка (America/Indiana/Marengo)","TIMEZONES__AMERICA_INDIANA_PETERSBURG":"США: Восточная Америка (America/Indiana/Petersburg)","TIMEZONES__AMERICA_INDIANA_VEVAY":"США: Восточная Америка (America/Indiana/Vevay)","TIMEZONES__AMERICA_CHICAGO":"США: Центральная Америка (America/Chicago)","TIMEZONES__AMERICA_INDIANA_TELL_CITY":"США: Центральная Америка (America/Indiana/Tell_City)","TIMEZONES__AMERICA_INDIANA_KNOX":"США: Центральная Америка (America/Indiana/Knox)","TIMEZONES__AMERICA_MENOMINEE":"США: Центральная Америка (America/Menominee)","TIMEZONES__AMERICA_NORTH_DAKOTA_CENTER":"США: Центральная Америка (America/North_Dakota/Center)","TIMEZONES__AMERICA_NORTH_DAKOTA_NEW_SALEM":"США: Центральная Америка (America/North_Dakota/New_Salem)","TIMEZONES__AMERICA_NORTH_DAKOTA_BEULAH":"США: Центральная Америка (America/North_Dakota/Beulah)","TIMEZONES__AMERICA_DENVER":"США: Горное время (США) (America/Denver)","TIMEZONES__AMERICA_BOISE":"США: Горное время (США) (America/Boise)","TIMEZONES__AMERICA_PHOENIX":"США: Горное время (США) (America/Phoenix)","TIMEZONES__AMERICA_LOS_ANGELES":"США: Тихоокеанское время (America/Los_Angeles)","TIMEZONES__AMERICA_METLAKATLA":"США: Тихоокеанское время (America/Metlakatla)","TIMEZONES__AMERICA_ANCHORAGE":"США: Аляска (America/Anchorage)","TIMEZONES__AMERICA_JUNEAU":"США: Аляска (America/Juneau)","TIMEZONES__AMERICA_SITKA":"США: Аляска (America/Sitka)","TIMEZONES__AMERICA_YAKUTAT":"США: Аляска (America/Yakutat)","TIMEZONES__AMERICA_NOME":"США: Аляска (America/Nome)","TIMEZONES__AMERICA_ADAK":"США: Гавайско-алеутское время (America/Adak)","TIMEZONES__PACIFIC_HONOLULU":"США: Гавайско-алеутское время (Pacific/Honolulu)","TIMEZONES__AMERICA_MONTEVIDEO":"Уругвай: Уругвай (America/Montevideo)","TIMEZONES__ASIA_SAMARKAND":"Узбекистан: Узбекистан (Asia/Samarkand)","TIMEZONES__ASIA_TASHKENT":"Узбекистан: Узбекистан (Asia/Tashkent)","TIMEZONES__EUROPE_VATICAN":"Центральная Европа (Europe/Vatican)","TIMEZONES__AMERICA_ST_VINCENT":"Атлантическое время (America/St_Vincent)","TIMEZONES__AMERICA_CARACAS":"Боливарийская Республика Венесуэла: Венесуэла (America/Caracas)","TIMEZONES__AMERICA_TORTOLA":"Атлантическое время (America/Tortola)","TIMEZONES__AMERICA_ST_THOMAS":"Атлантическое время (America/St_Thomas)","TIMEZONES__ASIA_HO_CHI_MINH":"Вьетнам: Индокитай (Asia/Ho_Chi_Minh)","TIMEZONES__PACIFIC_EFATE":"Вануату (Pacific/Efate)","TIMEZONES__PACIFIC_WALLIS":"Уоллис и Футуна (Pacific/Wallis)","TIMEZONES__PACIFIC_APIA":"Апиа (Pacific/Apia)","TIMEZONES__ASIA_ADEN":"Йемен: Саудовская Аравия (Asia/Aden)","TIMEZONES__INDIAN_MAYOTTE":"Восточная Африка (Indian/Mayotte)","TIMEZONES__AFRICA_JOHANNESBURG":"Южная Африка: Южная Африка (Africa/Johannesburg)","TIMEZONES__AFRICA_LUSAKA":"Центральная Африка (Africa/Lusaka)","TIMEZONES__AFRICA_HARARE":"Зимбабве: Центральная Африка (Africa/Harare)","COMMON__CLOSE":"Закрыть","CULTURE__EN":"Английский","CULTURE__RU":"Русский","CULTURE__DE":"Немецкий","CONFIGURATION__SIGN_OUT":"Выйти","MESSAGE__ACCOUNT__EMAIL_REQUIRED":"Необходимо ввести e-mail.","MESSAGE__ACCOUNT__PASSWORD_REQUIRED":"Необходимо ввести пароль.","MESSAGE__ACCOUNT__CONFIRM_PASSWORD_REQUIRED":"Необходимо ввести подтверждение пароля.","MESSAGE__ACCOUNT__TERMS_NOT_ACCEPTED":"Требуется принять правила использования сервиса.","MESSAGE__ACCOUNT__NAME_REQUIRED":"Необходимо ввести имя.","MESSAGE__ACCOUNT__COMPANY_NAME_REQUIRED":"Необходимо ввести название компании.","MESSAGE__ACCOUNT__TIMEZONE_REQUIRED":"Необходимо выбрать часовой пояс.","MESSAGE__ACCOUNT__PASSWORD_CONFIRMATION_NOT_VALID":"Подтверждение пароля неверно.","MESSAGE__ACCOUNT__EMAIL_NOT_VALID":"Неверный e-mail.","FORGOT_PASSWORD__EMAIL_WAS_SENT":"Спасибо! Если аккаунт с указанным адресом электронной почты существует, то вскоре на этот адрес будет отправлено сообщение. Пожалуйста, перейдите по ссылке в сообщении, чтобы сменить пароль.","DASHBOARD__CONFIGURATION":"Конфигурация","DASHBOARD__LIST":"Список","DASHBOARD__FORM":"Форма","DASHBOARD__TABLE":"Таблица","DASHBOARD__CATALOG":"Каталог","FORM__FORM":"Форма","CONFIGURATION__CONFIGURATION":"Конфигурация","STATES__ALASKA":"Аляска","STATES__ARIZONA":"Аризона","STATES__ARKANSAS":"Арканзас","STATES__CALIFORNIA":"Калифорния","STATES__COLORADO":"Колорадо","STATES__CONNECTICUT":"Коннектикут","STATES__DELAWARE":"Делавэр","COLOR__SILVER":"Серебристый","COLOR__GRAY":"Серый","COLOR__BLACK":"Черный","FORM__TEXTAREA":"Текстовая область","FORM__TEXT":"Текст","STATES__ALABAMA":"Алабама","FORM__DROPDOWN":"Выпадающий список","FORM__CHECKBOX":"Флаг","FORM__RADIO_BUTTONS":"Опции","FORM__DATE":"Дата","FORM__DATE_AND_TIME":"Дата и время","ORDINAL__FIRST":"Первый","ORDINAL__SECOND":"Второй","ORDINAL__THIRD":"Третий","TABS__1":"Вкладка 1","FORM__SEGMENTED_CONTROL":"Сегменты","TABS__2":"Вкладка 2","TABS__3":"Вкладка 3","FORM__STATE":"Состояние","MESSAGE__FORM__DATETIME_REQUIRED":"Введите дату и время.","MESSAGE__FORM__DATE_REQUIRED":"Введите дату.","MESSAGE__FORM__RADIO_REQUIRED":"Выберите любой вариант радио кнопок.","MESSAGE__FORM__DROPDOWN_REQUIRED":"Выберите любое значение из выпадающего списка.","MESSAGE__FORM__CHECKBOX_REQUIRED":"Отметьте этот флаг.","MESSAGE__FORM__TEXTAREA_REQUIRED":"Введите текст.","MESSAGE__FORM__TEXT_REQUIRED":"Введите текст.","CONFIGURATION__TIMEZONE":"Часовой пояс","FORM__FORM_SUCCESSFULLY_SAVED":"Форма успешно сохранена.","CONFIGURATION__LANGUAGE":"Язык","CONFIGURATION__CONFIRM_SIGNOUT":"Вы уверены, что хотите выйти?","MESSAGE__LIST__NAME_REQUIRED":"Введите имя.","SEX__MALE":"Мужчина","SEX__FEMALE":"Женщина","LIST__DELETE_ITEM_PROMPT":"Вы уверены, что хотите удалить этот элемент?","LIST__LIST":"Список","LIST__ADD":"Добавить","TABLE__TABLE":"Таблица","LIST__NAME":"Имя","LIST__NEW_ITEM":"Новый элемент","TABLE__SEARCH":"Поиск","TABLE__FOUND":"Найдено","TABLE__CITY":"Город","TABLE__COMPANY":"Компания","TABLE__PHONE":"Телефон","TABLE__NAME":"Имя","CATALOG__OPEN":"Открыть","CATALOG__CATALOG":"Каталог"}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utilities__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(35);







var state = {
    email: 'john@example.com',
    password: 'password',
    errors: {}
};

var mutations = {
    email: function email(state, _email) {
        state.email = _email;
    },
    password: function password(state, _password) {
        state.password = _password;
    },
    errors: function errors(state, _errors) {
        state.errors = _errors;
    }
};

var getters = {};

var actions = {
    setEmail: function setEmail(store, payload) {
        store.commit('email', payload);
    },
    setPassword: function setPassword(store, payload) {
        store.commit('password', payload);
    },
    signin: function signin(store, btn) {
        __WEBPACK_IMPORTED_MODULE_3__utils_utilities__["a" /* default */].disableButton(btn);
        __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].post('/api/account/signin', {
            email: store.state.email,
            password: store.state.password
        }, 'signin/errors').then(function (response) {
            var authorizationData = response.body;

            try {
                localStorage.setItem(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].tokenKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a(authorizationData));
            } catch (e) {}
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Authorization'] = 'Bearer ' + authorizationData.token;
            __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
                name: 'dashboard'
            });
            store.dispatch('settings/initAccount', authorizationData, { root: true });
            __WEBPACK_IMPORTED_MODULE_3__utils_utilities__["a" /* default */].enableButton(btn);
        }, function () {
            __WEBPACK_IMPORTED_MODULE_3__utils_utilities__["a" /* default */].enableButton(btn);
        });
    },
    openSignUp: function openSignUp() {
        __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
            name: 'signup'
        });
    },
    openForgotPassword: function openForgotPassword() {
        __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
            name: 'forgot-password'
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utilities__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(61);







var state = {
    isEmailConfirmationPending: false,

    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    company: '',
    timezone: null,
    termsAccepted: false,
    errors: {},

    emailCheckTimer: null,

    confirmedSuccessfully: null
};

var mutations = {
    init: function init(state) {
        state.isEmailConfirmationPending = false;
        state.password = '';
        state.confirmPassword = '';
        state.errors = {};
        if (state.emailCheckTimer) {
            clearInterval(state.emailCheckTimer);
        }
        state.emailCheckTimer = null;
    },
    isEmailConfirmationPending: function isEmailConfirmationPending(state, _isEmailConfirmationPending) {
        state.isEmailConfirmationPending = _isEmailConfirmationPending;
    },
    emailCheckTimer: function emailCheckTimer(state, _emailCheckTimer) {
        state.emailCheckTimer = _emailCheckTimer;
    },
    confirmedSuccessfully: function confirmedSuccessfully(state, _confirmedSuccessfully) {
        state.confirmedSuccessfully = _confirmedSuccessfully;
    },
    email: function email(state, _email) {
        state.email = _email;
    },
    password: function password(state, _password) {
        state.password = _password;
    },
    confirmPassword: function confirmPassword(state, _confirmPassword) {
        state.confirmPassword = _confirmPassword;
    },
    name: function name(state, _name) {
        state.name = _name;
    },
    company: function company(state, _company) {
        state.company = _company;
    },
    timezone: function timezone(state, _timezone) {
        state.timezone = _timezone;
    },
    termsAccepted: function termsAccepted(state, _termsAccepted) {
        state.termsAccepted = _termsAccepted;
    },
    errors: function errors(state, _errors) {
        state.errors = _errors;
    }
};

var getters = {};

var functions = {
    checkEmail: function checkEmail(store) {
        __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].get('/api/account/checkEmail/' + store.state.email).then(function (response) {
            var result = response.body;
            if (result === true) {
                clearInterval(store.state.emailCheckTimer);
                store.commit('emailCheckTimer', null);

                store.commit('email', 'john@example.com');
                store.commit('password', 'password');

                __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].post('/api/account/signin', {
                    email: store.state.email,
                    password: store.state.password
                }, 'signin/errors').then(function (response) {
                    var authorizationData = response.body;

                    try {
                        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].tokenKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a(authorizationData));
                    } catch (e) {}
                    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({
                        name: 'dashboard'
                    });
                    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Authorization'] = 'Bearer ' + authorizationData.token;
                    store.dispatch('settings/initAccount', authorizationData, { root: true });
                }, function () {});
            }
        }, function () {});
    }
};

var actions = {
    load: function load(store) {
        store.commit('init');
    },
    signup: function signup(store, btn) {
        __WEBPACK_IMPORTED_MODULE_3__utils_utilities__["a" /* default */].disableButton(btn);
        __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].post('/api/account/signup', {
            email: store.state.email,
            password: store.state.password,
            confirmPassword: store.state.confirmPassword,
            name: store.state.name,
            company: store.state.company,
            timezone: store.state.timezone,
            termsAccepted: store.state.termsAccepted,
            culture: store.rootState.settings.culture
        }, 'signup/errors').then(function () {
            store.commit('emailCheckTimer', setInterval(function () {
                functions.checkEmail(store);
            }, 10000));
            store.commit('isEmailConfirmationPending', true);
        }, function () {
            __WEBPACK_IMPORTED_MODULE_3__utils_utilities__["a" /* default */].enableButton(btn);
        });
    },
    openSignIn: function openSignIn(store) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({
            name: 'signin',
            query: { l: store.rootState.settings.culture }
        });
    },
    setEmail: function setEmail(store, payload) {
        store.commit('email', payload);
    },
    setPassword: function setPassword(store, payload) {
        store.commit('password', payload);
    },
    setConfirmPassword: function setConfirmPassword(store, payload) {
        store.commit('confirmPassword', payload);
    },
    setName: function setName(store, payload) {
        store.commit('name', payload);
    },
    setCompany: function setCompany(store, payload) {
        store.commit('company', payload);
    },
    setTimezone: function setTimezone(store, payload) {
        store.commit('timezone', payload);
    },
    setTermsAccepted: function setTermsAccepted(store, payload) {
        store.commit('termsAccepted', payload);
    },
    setConfirmedSuccessfully: function setConfirmedSuccessfully(store, payload) {
        store.commit('confirmedSuccessfully', payload);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utilities__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(35);




var state = {
    email: '',
    completedSuccessfully: false,
    errors: {}
};

var mutations = {
    init: function init(state) {
        state.email = '';
        state.errors = {};
        state.completedSuccessfully = false;
    },
    email: function email(state, _email) {
        state.email = _email;
    },
    completedSuccessfully: function completedSuccessfully(state, _completedSuccessfully) {
        state.completedSuccessfully = _completedSuccessfully;
    },
    errors: function errors(state, _errors) {
        state.errors = _errors;
    }
};

var getters = {};

var actions = {
    load: function load(store) {
        store.commit('init');
    },
    setEmail: function setEmail(store, payload) {
        store.commit('email', payload);
    },
    send: function send(store, btn) {
        __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].disableButton(btn);
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/api/account/sendPasswordResetLink', {
            email: store.state.email
        }, 'forgotPassword/errors').then(function () {
            store.commit('completedSuccessfully', true);
        }, function () {
            __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].enableButton(btn);
        });
    },
    openSignIn: function openSignIn(store) {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
            name: 'signin',
            query: { l: store.rootState.settings.culture }
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(35);




var state = {};

var mutations = {};

var getters = {};

var actions = {
    openList: function openList() {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({
            name: 'list'
        });
    },
    openTable: function openTable() {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({
            name: 'table'
        });
    },
    openCatalog: function openCatalog() {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({
            name: 'catalog'
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(35);




var state = {
    visible: false,
    timezone: null,
    culture: null,
    errors: {}
};

var mutations = {
    errors: function errors(state, _errors) {
        state.errors = _errors;
    },
    open: function open(state) {
        state.visible = true;
    },
    close: function close(state) {
        state.visible = false;
        state.errors = {};
    },
    timezone: function timezone(state, value) {
        state.timezone = value;
    },
    culture: function culture(state, value) {
        state.culture = value;
    }
};

var getters = {};

var actions = {
    open: function open(store) {
        store.commit('timezone', store.rootState.settings.account.timezone);
        store.commit('culture', store.rootState.settings.account.culture);
        store.commit('open');
    },
    close: function close(store) {
        store.commit('close');
    },
    save: function save(store) {
        store.dispatch('settings/save', {
            timezone: store.state.timezone,
            culture: store.state.culture
        }, { root: true });
        store.commit('close');
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].go();
    },
    confirmSignout: function confirmSignout(store) {
        store.dispatch('confirmation/open', {
            title: 'CONFIGURATION__CONFIRM_SIGNOUT',
            handlerAction: 'configuration/signout',
            handlerActionParams: null
        }, { root: true });
    },
    signout: function signout(store) {
        store.commit('close');
        store.dispatch('settings/signout', null, { root: true });
    },
    setTimezone: function setTimezone(store, value) {
        store.commit('timezone', value);
    },
    setCulture: function setCulture(store, value) {
        store.commit('culture', value);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(35);



var state = {
    isLoaded: false,
    items: []
};

var mutations = {
    loading: function loading(state) {
        state.isLoaded = false;
    },
    loaded: function loaded(state) {
        state.isLoaded = true;
    },
    items: function items(state, _items) {
        state.items = _items;
    }
};

var getters = {};

var actions = {
    getItems: function getItems(store) {
        store.commit('loading');
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/api/list/').then(function (response) {
            store.commit('items', response.body);
            store.commit('loaded');
        }, function () {
            store.commit('loaded');
        });
    },
    back: function back() {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
            name: 'dashboard'
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utilities__ = __webpack_require__(60);



var state = {
    id: null,
    name: null,
    sex: 1,
    sexes: [{ id: 1, name: 'SEX__MALE' }, { id: 2, name: 'SEX__FEMALE' }],
    visible: false,
    errors: {}
};

var mutations = {
    errors: function errors(state, _errors) {
        state.errors = _errors;
    },
    show: function show(state, data) {
        state.id = data.id;
        state.name = data.name;
        state.sex = data.sex;
        state.visible = true;
    },
    close: function close(state) {
        state.visible = false;
        state.id = null;
        state.name = null;
        state.sex = 1;
        state.errors = {};
    },
    id: function id(state, value) {
        state.id = value;
    },
    name: function name(state, value) {
        state.name = value;
    },
    sex: function sex(state, value) {
        state.sex = value;
    }
};

var actions = {
    open: function open(store, id) {
        store.commit('id', id);
        if (id != null) {
            __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/api/list/' + id).then(function (response) {
                if (store.state.id === id) {
                    store.commit('show', response.body);
                }
            });
        } else {
            store.commit('show', {
                id: null,
                name: null,
                sex: 1
            });
        }
    },
    close: function close(store) {
        store.commit('close');
    },
    save: function save(store, target) {
        var model = {
            id: store.state.id,
            name: store.state.name,
            sex: store.state.sex
        };
        __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].disableButton(target);

        if (store.state.id) {
            __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/api/list/' + store.state.id, model, 'listItem/errors').then(function () {
                __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].enableButton(target);
                store.dispatch('list/getItems', null, { root: true });
                store.commit('close');
            }, function () {
                __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].enableButton(target);
            });
        } else {
            __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/api/list/', model, 'listItem/errors').then(function () {
                __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].enableButton(target);
                store.dispatch('list/getItems', null, { root: true });
                store.commit('close');
            }, function () {
                __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].enableButton(target);
            });
        }
    },
    confirmDeleteItem: function confirmDeleteItem(store) {
        store.dispatch('confirmation/open', {
            title: 'LIST__DELETE_ITEM_PROMPT',
            handlerAction: 'listItem/deleteItem',
            handlerActionParams: null
        }, { root: true });
    },
    deleteItem: function deleteItem(store) {
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/api/list/' + store.state.id).then(function () {
            store.dispatch('list/getItems', null, { root: true });
            store.commit('close');
        }, function () {});
    },
    setName: function setName(store, value) {
        store.commit('name', value);
    },
    setSex: function setSex(store, value) {
        store.commit('sex', +value);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utilities__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(76);






var state = {
    visible: false,
    selectedTab: 1,
    tabs: [{ id: 1, name: 'TABS__1' }, { id: 2, name: 'TABS__2' }, { id: 3, name: 'TABS__3' }],
    textValue: '',
    textareaValue: '',
    checkboxValue: false,
    dropdownValue: null,
    dropdownItems: [{ id: 'AL', name: 'STATES__ALABAMA' }, { id: 'AK', name: 'STATES__ALASKA' }, { id: 'AZ', name: 'STATES__ARIZONA' }, { id: 'AR', name: 'STATES__ARKANSAS' }, { id: 'CA', name: 'STATES__CALIFORNIA' }, { id: 'CO', name: 'STATES__COLORADO' }, { id: 'CT', name: 'STATES__CONNECTICUT' }, { id: 'DE', name: 'STATES__DELAWARE' }],
    radioValue: '#C0C0C0',
    radioItems: [{ id: '#C0C0C0', name: 'COLOR__SILVER' }, { id: '#808080', name: 'COLOR__GRAY' }, { id: '#000000', name: 'COLOR__BLACK' }],
    segmentedValue: 'FIRST',
    segmentedItems: [{ id: 'FIRST', name: 'ORDINAL__FIRST' }, { id: 'SECOND', name: 'ORDINAL__SECOND' }, { id: 'THIRD', name: 'ORDINAL__THIRD' }],
    dateString: null,
    dateTimeString: null,
    savedState: null,
    errors: {}
};

var mutations = {
    open: function open(state, _ref) {
        var data = _ref.data,
            timezone = _ref.timezone;

        state.selectedTab = 1;

        state.textValue = data.textValue;
        state.textareaValue = data.textareaValue;
        state.checkboxValue = data.checkboxValue;
        state.dropdownValue = data.dropdownValue;
        state.radioValue = data.radioValue;
        state.segmentedValue = data.segmentedValue;
        state.dateString = data.date ? __WEBPACK_IMPORTED_MODULE_2__main__["moment"].tz(data.date, timezone).format('L') : null;
        state.dateTimeString = data.dateTime ? __WEBPACK_IMPORTED_MODULE_2__main__["moment"].tz(data.dateTime, timezone).format('L LT') : null;

        state.visible = true;
    },
    close: function close(state) {
        state.visible = false;
        state.errors = {};
    },
    selectedTab: function selectedTab(state, value) {
        state.selectedTab = value;
    },
    textValue: function textValue(state, value) {
        state.textValue = value;
    },
    textareaValue: function textareaValue(state, value) {
        state.textareaValue = value;
    },
    checkboxValue: function checkboxValue(state, value) {
        state.checkboxValue = value;
    },
    dropdownValue: function dropdownValue(state, value) {
        state.dropdownValue = value;
    },
    radioValue: function radioValue(state, value) {
        state.radioValue = value;
    },
    segmentedValue: function segmentedValue(state, value) {
        state.segmentedValue = value;
    },
    dateString: function dateString(state, value) {
        state.dateString = value;
    },
    dateTimeString: function dateTimeString(state, value) {
        state.dateTimeString = value;
    },
    errors: function errors(state, _errors) {
        state.errors = _errors;
    }
};

var functions = {
    prettify: function prettify(key, value) {
        return '<span class="FormModal__key">"' + key + '"</span>:&nbsp;<span class="FormModal__value">' + value + '</span>';
    }
};

var getters = {
    getStateString: function getStateString(state) {
        return '{<br/>' + functions.prettify('selectedTab', state.selectedTab) + ',<br/>' + functions.prettify('textValue', '"' + state.textValue + '"') + ',<br/>' + functions.prettify('textareaValue', '"' + state.textareaValue + '"') + ',<br/>' + functions.prettify('checkboxValue', state.checkboxValue) + ',<br/>' + functions.prettify('dropdownValue', '"' + state.dropdownValue + '"') + ',<br/>' + functions.prettify('radioValue', '"' + state.radioValue + '"') + ',<br/>' + functions.prettify('segmentedValue', '"' + state.segmentedValue + '"') + ',<br/>' + functions.prettify('dateString', '"' + state.dateString + '"') + ',<br/>' + functions.prettify('dateTimeString', '"' + state.dateTimeString + '"') + '<br/>' + '}';
    }
};

var actions = {
    open: function open(store) {
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/api/form/').then(function (response) {
            var data = response.body;
            store.commit('open', {
                data: data,
                timezone: store.rootState.settings.account.timezone
            });
        }, function () {});
    },
    close: function close(store) {
        store.commit('close');
    },
    save: function save(store) {
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/api/form/', {
            textValue: store.state.textValue,
            textareaValue: store.state.textareaValue,
            checkboxValue: store.state.checkboxValue,
            dropdownValue: store.state.dropdownValue,
            radioValue: store.state.radioValue,
            segmentedValue: store.state.segmentedValue,
            date: __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].convertStringToDate(store, store.state.dateString, true, 'L'),
            dateTime: __WEBPACK_IMPORTED_MODULE_1__utils_utilities__["a" /* default */].convertStringToDate(store, store.state.dateTimeString, true, 'L LT')
        }, 'form/errors').then(function () {
            store.commit('close');
            store.dispatch('settings/addMessage', store.rootGetters['translation/translate']('FORM__FORM_SUCCESSFULLY_SAVED'), { root: true });
        }, function () {});
    },
    setSelectedTab: function setSelectedTab(store, value) {
        store.commit('selectedTab', value);
    },
    setTextValue: function setTextValue(store, value) {
        store.commit('textValue', value);
    },
    setTextareaValue: function setTextareaValue(store, value) {
        store.commit('textareaValue', value);
    },
    setCheckboxValue: function setCheckboxValue(store, value) {
        store.commit('checkboxValue', value);
    },
    setDropdownValue: function setDropdownValue(store, value) {
        store.commit('dropdownValue', value);
    },
    setRadioValue: function setRadioValue(store, value) {
        store.commit('radioValue', value);
    },
    setSegmentedValue: function setSegmentedValue(store, value) {
        store.commit('segmentedValue', value);
    },
    setDateString: function setDateString(store, payload) {
        store.commit('dateString', payload.dateString);
    },
    setDateTimeString: function setDateTimeString(store, payload) {
        store.commit('dateTimeString', payload.dateString);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(35);





var state = {
    isLoaded: false,
    filter: '',
    limit: 10,
    page: 1,
    order: 'name',
    totalCount: 0,
    items: [],
    start: 0,
    end: 0,
    canIncrease: false,
    canDecrease: false
};

var mutations = {
    clear: function clear(state) {
        state.filter = '';
        state.page = 1;
        state.order = 'name';
        state.totalCount = 0;
        state.items = [];

        state.start = 0;
        state.end = 0;
        state.canIncrease = false;
        state.canDecrease = false;
    },
    clearIndices: function clearIndices(state) {
        state.page = 1;
        state.start = 0;
        state.end = 0;
        state.canIncrease = false;
        state.canDecrease = false;
    },
    loading: function loading(state) {
        state.isLoaded = false;
    },
    loaded: function loaded(state) {
        state.isLoaded = true;
    },
    recalculatePaging: function recalculatePaging(state) {
        state.start = Math.min((state.page - 1) * state.limit + 1, state.totalCount);
        state.end = Math.min(state.page * state.limit, state.totalCount);
        state.canIncrease = state.page * state.limit < state.totalCount;
        state.canDecrease = state.page > 1;
    },
    filter: function filter(state, _filter) {
        state.filter = _filter;
    },
    page: function page(state, _page) {
        state.page = _page;
    },
    order: function order(state, _order) {
        if (state.order === _order) {
            _order = '-' + _order;
        }
        state.order = _order;
    },
    totalCount: function totalCount(state, _totalCount) {
        state.totalCount = _totalCount;
    },
    items: function items(state, _items) {
        state.items = _items;
    }
};

var getters = {
    sortByColumn: function sortByColumn(state) {
        return function (column) {
            return column === state.order || column === state.order.substr(1);
        };
    }
};

var functions = {
    reload: function reload(store) {
        store.commit('loading');
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/api/table/search', {
            filter: store.state.filter,
            limit: store.state.limit,
            page: store.state.page,
            order: store.state.order
        }).then(function (response) {
            store.commit('items', response.body.items);
            store.commit('totalCount', response.body.totalCount);
            store.commit('recalculatePaging');
            store.commit('loaded');
        });
    }
};

var actions = {
    open: function open(store) {
        store.commit('clear');
        functions.reload(store);
    },
    reload: function reload(store) {
        functions.reload(store);
    },
    search: function search(store) {
        store.commit('clearIndices');
        functions.reload(store);
    },
    previousPage: function previousPage(store) {
        if (store.state.isLoaded) {
            store.commit('page', store.state.page - 1);
            functions.reload(store);
        }
    },
    nextPage: function nextPage(store) {
        if (store.state.isLoaded) {
            store.commit('page', store.state.page + 1);
            functions.reload(store);
        }
    },
    back: function back() {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
            name: 'dashboard'
        });
    },
    setFilter: function setFilter(store, payload) {
        store.commit('filter', payload);
    },
    setOrder: function setOrder(store, payload) {
        store.commit('order', payload);
        functions.reload(store);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(35);



var state = {
    rootId: 0,
    id: 0,
    name: '',
    items: [],

    parentIds: [],
    parentNames: [],
    parentItems: []
};

var mutations = {
    id: function id(state, _id) {
        state.id = _id;
    },
    name: function name(state, _name) {
        state.name = _name;
    },
    items: function items(state, _items) {
        state.items = _items;
    },
    pustParent: function pustParent(state) {
        state.parentIds.push(state.id);
        state.parentNames.push(state.name);
        state.parentItems.push(state.items);
    },
    popParent: function popParent(state, index) {
        state.id = state.parentIds[index];
        state.name = state.parentNames[index];
        state.items = state.parentItems[index];

        var length = state.parentIds.length - index;
        state.parentIds.splice(index, length);
        state.parentNames.splice(index, length);
        state.parentItems.splice(index, length);
    }
};

var getters = {
    showUp: function showUp(state) {
        return state.rootId !== state.id;
    },
    showBack: function showBack(state) {
        return state.rootId === state.id;
    }
};

var actions = {
    resolveParentGroup: function resolveParentGroup(store, id) {
        var index = store.state.parentIds.indexOf(id);
        if (index !== -1) {
            store.commit('popParent', index);
        }
    },
    openGroup: function openGroup(store, item) {
        if (store.state.rootId !== item.id) {
            store.commit('pustParent');
        }
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/api/catalog/getItems/' + item.id).then(function (response) {
            store.commit('id', item.id);
            store.commit('name', item.name);
            store.commit('items', response.body);
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
                name: 'catalog',
                params: { id: item.id }
            });
        });
    },
    up: function up(store) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
            name: 'catalog',
            params: { id: store.state.parentIds[store.state.parentIds.length - 1] }
        });
    },
    back: function back() {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
            name: 'dashboard'
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 610 */,
/* 611 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_cordova_plugin_device__ = __webpack_require__(613);



/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.cordova = Vue.cordova || {
            deviceready: false,
            plugins: []
        };

        Vue.cordova.on = function (eventName, cb) {
            document.addEventListener(eventName, cb, false);
        };

        document.addEventListener('deviceready', function () {
            Vue.cordova.deviceready = true;
        }, false);

        __WEBPACK_IMPORTED_MODULE_0__plugins_cordova_plugin_device__["a" /* default */].install(Vue, options, function (pluginLoaded) {
            if (pluginLoaded) {
                Vue.cordova.plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins_cordova_plugin_device__["a" /* default */]);
            }
        });
    }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options, cb) {
        document.addEventListener('deviceready', function () {

            if (typeof device === 'undefined' || typeof device.cordova === 'undefined') {
                return cb(false);
            }

            Vue.cordova.device = {
                cordova: null,
                model: null,
                platform: null,
                uuid: null,
                version: null,
                manufacturer: null,
                isVirtual: null,
                serial: null
            };

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a(Vue.cordova.device).forEach(function (key) {
                if (typeof device[key] !== 'undefined') {
                    Vue.cordova.device[key] = device[key];
                }
            });

            return cb(true);
        }, false);
    }
});

/***/ }),
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(661),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_dateTimePicker_DateTimePicker_vue__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_dateTimePicker_DateTimePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_dateTimePicker_DateTimePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_TheConfirmation_vue__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_TheConfirmation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_TheConfirmation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_GlobalErrors_vue__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_GlobalErrors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_GlobalErrors_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_GlobalMessages_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_GlobalMessages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_GlobalMessages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_BaseLoader_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_BaseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_BaseLoader_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        DateTimePicker: __WEBPACK_IMPORTED_MODULE_2__components_common_dateTimePicker_DateTimePicker_vue___default.a,
        TheConfirmation: __WEBPACK_IMPORTED_MODULE_3__components_common_TheConfirmation_vue___default.a,
        GlobalErrors: __WEBPACK_IMPORTED_MODULE_4__components_common_GlobalErrors_vue___default.a,
        GlobalMessages: __WEBPACK_IMPORTED_MODULE_5__components_common_GlobalMessages_vue___default.a,
        BaseLoader: __WEBPACK_IMPORTED_MODULE_6__components_common_BaseLoader_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        loaded: function loaded(s) {
            return s.settings.loaded;
        },
        dateTimePickerVisible: function dateTimePickerVisible(s) {
            return s.dateTimePicker.visible;
        },
        confirmationVisible: function confirmationVisible(s) {
            return s.confirmation.visible;
        }
    }))
});

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DateTimePickerHeader_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DateTimePickerHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DateTimePickerHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateTimePickerMonthPicker_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateTimePickerMonthPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DateTimePickerMonthPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTimePickerMonth_vue__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTimePickerMonth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DateTimePickerMonth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateTimePickerTime_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateTimePickerTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DateTimePickerTime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateTimePickerTimeLine_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateTimePickerTimeLine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DateTimePickerTimeLine_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseButton_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__BaseButtonFlat_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DateTimePicker',
    components: {
        DateTimePickerHeader: __WEBPACK_IMPORTED_MODULE_2__DateTimePickerHeader_vue___default.a,
        DateTimePickerMonthPicker: __WEBPACK_IMPORTED_MODULE_3__DateTimePickerMonthPicker_vue___default.a,
        DateTimePickerMonth: __WEBPACK_IMPORTED_MODULE_4__DateTimePickerMonth_vue___default.a,
        DateTimePickerTime: __WEBPACK_IMPORTED_MODULE_5__DateTimePickerTime_vue___default.a,
        DateTimePickerTimeLine: __WEBPACK_IMPORTED_MODULE_6__DateTimePickerTimeLine_vue___default.a,
        BaseButton: __WEBPACK_IMPORTED_MODULE_7__BaseButton_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_8__BaseButtonFlat_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        showTime: function showTime(s) {
            return s.dateTimePicker.showTime;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        hide: 'dateTimePicker/hide',
        ok: 'dateTimePicker/ok'
    }))
});

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseNavigationButton_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseNavigationButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BaseNavigationButton_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DateTimePickerHeader',
    components: {
        BaseButton: __WEBPACK_IMPORTED_MODULE_2__BaseButton_vue___default.a,
        BaseNavigationButton: __WEBPACK_IMPORTED_MODULE_3__BaseNavigationButton_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        title: function title(s) {
            return s.dateTimePicker.title;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        hide: 'dateTimePicker/hide',
        ok: 'dateTimePicker/ok'
    }))
});

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePickerHeader"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "class-name": 'DateTimePickerHeader__back',
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation-bar__title DateTimePickerHeader__title"
  }, [_vm._v("\n        " + _vm._s(_vm.translate(_vm.title)) + "\n    ")]), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__OK',
      "class-name": 'DateTimePickerHeader__ok',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DateTimePickerMonthPicker',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        monthTitle: function monthTitle(s) {
            return s.dateTimePicker.monthTitle;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        nextMonth: 'dateTimePicker/nextMonth',
        previousMonth: 'dateTimePicker/previousMonth'
    }))
});

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePickerMonthPicker"
  }, [_c('div', {
    staticClass: "DateTimePickerMonthPicker__content"
  }, [_c('div', {
    staticClass: "DateTimePickerMonthPicker__icon",
    on: {
      "click": function($event) {
        _vm.previousMonth()
      }
    }
  }, [_c('i', {
    staticClass: "icon-left-open-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "DateTimePickerMonthPicker__title"
  }, [_vm._v("\n            " + _vm._s(_vm.monthTitle) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "DateTimePickerMonthPicker__icon",
    on: {
      "click": function($event) {
        _vm.nextMonth()
      }
    }
  }, [_c('i', {
    staticClass: "icon-right-open-1"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DateTimePickerDay_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DateTimePickerDay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DateTimePickerDay_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DateTimePickerMonth',
    components: { DateTimePickerDay: __WEBPACK_IMPORTED_MODULE_2__DateTimePickerDay_vue___default.a },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        days: function days(s) {
            return s.dateTimePicker.days;
        },
        weekdays: function weekdays(s) {
            return s.dateTimePicker.weekdays;
        }
    }))
});

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DateTimePickerDay',
    props: ['day', 'index'],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        pickDay: 'dateTimePicker/pickDay'
    }))
});

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePickerDay__container",
    on: {
      "click": function($event) {
        _vm.pickDay({
          date: _vm.day.date,
          index: _vm.index
        })
      }
    }
  }, [_c('div', {
    staticClass: "DateTimePickerDay",
    class: {
      'DateTimePickerDay_current': _vm.day.isCurrentMonth, 'DateTimePickerDay_selected': _vm.day.isSelected
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePickerDay__name"
  }, [_vm._v("\n            " + _vm._s(_vm.day.name) + "\n        ")])
}]}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePickerMonth"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.days), function(day, index) {
    return _c('DateTimePickerDay', {
      key: day.date.valueOf(),
      attrs: {
        "day": day,
        "index": index
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.weekdays), function(weekday) {
    return _c('div', {
      staticClass: "DateTimePickerMonth__weekday"
    }, [_c('div', {
      staticClass: "DateTimePickerMonth__weekday_name"
    }, [_vm._v("\n            " + _vm._s(weekday) + "\n        ")])])
  })
}]}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DateTimePickerTime',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        title: function title(s) {
            return s.dateTimePicker.time != null ? s.dateTimePicker.time.title : null;
        },
        index: function index(s) {
            return s.dateTimePicker.time != null ? s.dateTimePicker.time.index : null;
        },
        length: function length(s) {
            return s.dateTimePicker.times.length;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        nextTime: 'dateTimePicker/nextTime',
        previousTime: 'dateTimePicker/previousTime'
    }))
});

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePickerTime"
  }, [_c('div', {
    staticClass: "DateTimePickerTime__content"
  }, [_c('div', {
    staticClass: "DateTimePickerTime__icon",
    class: {
      'DateTimePickerTime__icon_disabled': _vm.index <= 0
    },
    on: {
      "click": function($event) {
        _vm.previousTime()
      }
    }
  }, [_c('i', {
    staticClass: "icon-left-open-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "DateTimePickerTime__title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "DateTimePickerTime__icon",
    class: {
      'DateTimePickerTime__icon_disabled': _vm.index >= _vm.length - 1
    },
    on: {
      "click": function($event) {
        _vm.nextTime()
      }
    }
  }, [_c('i', {
    staticClass: "icon-right-open-1"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(647),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DateTimePickerTimeLine',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        hours: function hours(s) {
            return s.dateTimePicker.hours;
        },
        times: function times(s) {
            return s.dateTimePicker.times;
        },
        time: function time(s) {
            return s.dateTimePicker.time;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        pickTime: 'dateTimePicker/pickTime'
    }))
});

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePickerTimeLine",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        _vm.pickTime($event)
      },
      "click": function($event) {
        _vm.pickTime($event)
      },
      "touchmove": function($event) {
        _vm.pickTime($event)
      }
    }
  }, [(_vm.time) ? _c('div', {
    staticClass: "DateTimePickerTimeLine__marker-container"
  }, [_c('div', {
    staticClass: "DateTimePickerTimeLine__marker",
    style: ({
      left: _vm.time.position + '%'
    }),
    attrs: {
      "draggable": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "DateTimePickerTimeLine__body"
  }, [
    [_c('div', {
      staticClass: "DateTimePickerTimeLine__points"
    }, _vm._l((_vm.times), function(time) {
      return _c('div', {
        key: time.date.valueOf(),
        staticClass: "DateTimePickerTimeLine__point",
        style: ({
          left: time.position + '%'
        })
      })
    }))], _vm._v(" "), _c('div', {
      staticClass: "DateTimePickerTimeLine__hours"
    }, _vm._l((_vm.hours), function(hour) {
      return _c('div', {
        key: hour,
        staticClass: "DateTimePickerTimeLine__hour"
      }, [_c('div', {
        staticClass: "DateTimePickerTimeLine__hour-tick"
      }), _vm._v(" "), _vm._o(_c('div', {
        staticClass: "DateTimePickerTimeLine__hour-name"
      }, [_vm._v("\n                    " + _vm._s(hour) + " "), _c('span', {
        staticClass: "DateTimePickerTimeLine__hour-name-minutes"
      }, [_vm._v("00")])]), 0, hour)])
    }))
  ], 2)])
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DateTimePicker__mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hide()
      }
    }
  }, [_c('div', {
    staticClass: "DateTimePicker"
  }, [_c('DateTimePickerHeader'), _vm._v(" "), _c('DateTimePickerMonthPicker'), _vm._v(" "), _c('div', {
    staticClass: "DateTimePicker__body"
  }, [_c('DateTimePickerMonth'), _vm._v(" "), (_vm.showTime) ? [_c('DateTimePickerTime'), _vm._v(" "), _c('DateTimePickerTimeLine')] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "DateTimePicker__bottom"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'COMMON__CLOSE',
      "class-name": 'DateTimePicker__back'
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__OK',
      "class-name": 'DateTimePicker__ok',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(652),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseButtonFlat_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseButtonFlat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BaseButtonFlat_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TheConfirmation',
    components: {
        BaseButton: __WEBPACK_IMPORTED_MODULE_2__BaseButton_vue___default.a,
        BaseButtonFlat: __WEBPACK_IMPORTED_MODULE_3__BaseButtonFlat_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        title: function title(s) {
            return s.confirmation.title;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        hide: 'confirmation/hide',
        ok: 'confirmation/ok'
    }))
});

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheConfirmation__mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hide()
      }
    }
  }, [_c('div', {
    staticClass: "TheConfirmation"
  }, [_c('div', {
    staticClass: "TheConfirmation__body"
  }, [_vm._v("\n            " + _vm._s(_vm.translate(_vm.title)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "TheConfirmation__bottom"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'COMMON__CANCEL'
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__YES',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.ok($event.target)
      }
    }
  })], 1)])])
}]}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(656),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GlobalErrors',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        errors: function errors(s) {
            return s.settings.errors;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        removeError: 'settings/removeError'
    }))
});

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "GlobalErrors"
  }, [_vm._l((_vm.errors), function(error, index) {
    return [_c('transition', {
      attrs: {
        "name": "error-toast"
      }
    }, [_c('div', {
      staticClass: "GlobalErrors__toast"
    }, [_c('div', {
      staticClass: "GlobalErrors__close",
      on: {
        "click": function($event) {
          _vm.removeError(index)
        }
      }
    }), _vm._v("\n                " + _vm._s(error) + "\n            ")])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GlobalMessages',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */]({
        messages: function messages(s) {
            return s.settings.messages;
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]({
        removeMessage: 'settings/removeMessage'
    }))
});

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "GlobalMessages"
  }, [_vm._l((_vm.messages), function(message, index) {
    return [_c('transition', {
      attrs: {
        "name": "message-toast"
      }
    }, [_c('div', {
      staticClass: "GlobalMessages__toast"
    }, [_c('div', {
      staticClass: "GlobalMessages__close",
      on: {
        "click": function($event) {
          _vm.removeMessage(index)
        }
      }
    }), _vm._v("\n                " + _vm._s(message) + "\n            ")])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "App"
  }, [(_vm.loaded) ? _c('router-view') : _c('BaseLoader'), _vm._v(" "), (_vm.dateTimePickerVisible) ? _c('DateTimePicker') : _vm._e(), _vm._v(" "), (_vm.confirmationVisible) ? _c('TheConfirmation') : _vm._e(), _vm._v(" "), _c('GlobalErrors'), _vm._v(" "), _c('GlobalMessages')], 1)
},staticRenderFns: []}

/***/ }),
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ru": 204,
	"./ru.js": 204
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = {"version":"2017b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Juba","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ })
]),[205]);


// WEBPACK FOOTER //
// static/js/app.4ccd4267b3f6e1455831.js